import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import {
  FieldPolicy,
  FieldReadFunction,
  TypePolicies,
  TypePolicy,
} from '@apollo/client/cache';
import { ArticleStructure } from 'lib-knowledge-document-structure/structure/types';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Color: { input: string; output: string };
  ContentJson: {
    input: ArticleStructure | null;
    output: ArticleStructure | null;
  };
  EmailAddress: { input: string; output: string };
  Json: { input: object | null; output: object | null };
  Limit: { input: number; output: number };
  Long: { input: number; output: number };
  NonEmptyString: { input: string; output: string };
  NonNegativeInt: { input: number; output: number };
  Offset: { input: number; output: number };
  PositiveInt: { input: number; output: number };
  URL: { input: string; output: string };
  Unit: { input: string; output: string };
};

export enum AccessLevel {
  None = 'NONE',
  Read = 'READ',
  Write = 'WRITE',
}

export type AiDraft = {
  __typename: 'AiDraft';
  /** When an agent approved the draft, as epoch millis. An approved draft is kept until the article it became is published, so that the knowledge it holds is still found in the meantime, and is never listed again. `null` while the draft is awaiting review */
  approvedAt?: Maybe<Scalars['Long']['output']>;
  /** `categoryId`, with the category's name. Replaces `categoryId`, which is kept until the clients have moved over */
  category?: Maybe<AiDraftCategory>;
  /** Where the article is filed once the draft is approved. Takes precedence over `collectionId`. For an `ARTICLE_UPDATE` draft, where the article it updates already lives, which the draft cannot change */
  categoryId?: Maybe<Scalars['ID']['output']>;
  /** `collectionId`, with the collection's name. Replaces `collectionId`, which is kept until the clients have moved over */
  collection?: Maybe<AiDraftCollection>;
  /** Where the article is filed once the draft is approved. For an `ARTICLE_UPDATE` draft, where the article it updates already lives, which the draft cannot change */
  collectionId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Long']['output'];
  /** When that conversation last had something said in it as of the moment the draft was written, as epoch millis */
  createdFromLastMessageAt?: Maybe<Scalars['Long']['output']>;
  /** The article the draft is against: the one an `ARTICLE_UPDATE` draft updates, or, once approved, the one a `NEW_ARTICLE` draft became */
  forArticleId?: Maybe<Scalars['ID']['output']>;
  /** The proposed article body, as HTML */
  htmlContent: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The agent who asked for the draft. `null` when the AI initiated the draft on its own */
  initiatedBy?: Maybe<User>;
  /** The conversation the draft was written from */
  initiatedFromConversation: Scalars['Long']['output'];
  languageId: LanguageId;
  /** When the draft was last edited. `null` for drafts that have not been edited since they were written */
  modifiedAt?: Maybe<Scalars['Long']['output']>;
  /** The collections the draft may be filed under: the ones linked to the queue the conversation it was written from sat in. Filing it anywhere else is rejected. Empty when that queue is linked to no collection, or when the draft records no queue, in which case any collection is allowed */
  possibleCollectionIds: Array<Scalars['ID']['output']>;
  /** `possibleCollectionIds`, with the collections' names. Replaces `possibleCollectionIds`, which is kept until the clients have moved over */
  possibleCollections: Array<AiDraftCollection>;
  /** The other conversations the draft was written from */
  referencedConversationIds: Array<Scalars['Long']['output']>;
  /** When an agent rejected the draft, as epoch millis. `null` while the draft is awaiting review */
  rejectedAt?: Maybe<Scalars['Long']['output']>;
  /** Whether the article an `ARTICLE_UPDATE` draft is written against already has unpublished changes of its own, which approving this draft would overwrite. Always `false` for a `NEW_ARTICLE` draft, which has no article yet */
  replacesExistingDraft: Scalars['Boolean']['output'];
  /** A short summary of what the draft proposes: of the article itself for a `NEW_ARTICLE` draft, and of what it changes about the article for an `ARTICLE_UPDATE` one. `null` when the AI wrote none */
  summary?: Maybe<Scalars['NonEmptyString']['output']>;
  title: Scalars['NonEmptyString']['output'];
  type: AiDraftType;
};

/** A category a draft can be filed in */
export type AiDraftCategory = {
  __typename: 'AiDraftCategory';
  id: Scalars['ID']['output'];
  name: Scalars['NonEmptyString']['output'];
};

/** A collection a draft can be filed in */
export type AiDraftCollection = {
  __typename: 'AiDraftCollection';
  id: Scalars['ID']['output'];
  name: Scalars['NonEmptyString']['output'];
};

/** Filters which can be used to exclude drafts from the result list. Rejected and approved drafts are always excluded */
export type AiDraftFiltersInput = {
  /** `AGENT` lists the drafts an agent asked for, `AI` the ones the AI initiated on its own */
  initiatedBy?: InputMaybe<AiDraftInitiator>;
  /** Only list drafts of this type */
  type?: InputMaybe<AiDraftType>;
};

export enum AiDraftInitiator {
  Agent = 'AGENT',
  Ai = 'AI',
}

export type AiDraftQueryPayload = {
  __typename: 'AiDraftQueryPayload';
  pagination: PaginationPayload;
  results: Array<AiDraft>;
};

export enum AiDraftType {
  ArticleUpdate = 'ARTICLE_UPDATE',
  NewArticle = 'NEW_ARTICLE',
}

export type AiSettingsPayload = {
  __typename: 'AiSettingsPayload';
  /** Instructions for the AI deciding whether a conversation points at a gap in the knowledge base. `null` when none are set */
  judgeInstructions?: Maybe<Scalars['String']['output']>;
  /** How many conversations about the same issue it takes before it is judged, the one being judged included */
  minSimilarConversations: Scalars['Int']['output'];
  /** How alike other conversations must be to the one being judged to count as the same issue */
  similarity: SimilarityLevel;
  /** Instructions for the AI writing and revising AI drafts. `null` when none are set */
  writerInstructions?: Maybe<Scalars['String']['output']>;
};

export type AiSettingsVersionPayload = {
  __typename: 'AiSettingsVersionPayload';
  /** When the version was created, or the draft last changed. `null` for the defaults */
  createdAt?: Maybe<Scalars['Long']['output']>;
  /** `null` for the defaults */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether this is the version the organisation's AI uses. Never the draft or the defaults, which the AI only uses while no version is active */
  isActive: Scalars['Boolean']['output'];
  /** Whether these are the settings of the draft the organisation is editing */
  isDraft: Scalars['Boolean']['output'];
  /** The only part of a saved version that can be changed. `null` for the draft and for the defaults */
  name?: Maybe<Scalars['String']['output']>;
  settings: AiSettingsPayload;
  /** Counts up per organisation, so no two versions share it. `null` for the draft and for the defaults */
  version?: Maybe<Scalars['Long']['output']>;
};

export type AiSettingsVersionSummaryPayload = {
  __typename: 'AiSettingsVersionSummaryPayload';
  createdAt: Scalars['Long']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  version: Scalars['Long']['output'];
};

export type Article = Child & {
  __typename: 'Article';
  /** Whether AI helped draft at least one of this article's translations */
  aiAssisted: Scalars['Boolean']['output'];
  availableInPreRelease: Scalars['Boolean']['output'];
  createdAt: Scalars['Long']['output'];
  createdBy?: Maybe<User>;
  /**
   * Get the default location of this entity.
   * **Performance warning:** Calling this field requires the backend to build the graph across all collections which can be expensive when an organization has many collections. Only call this field if you're sure you need it. If this field was already called elsewhere, then calling it multiple times has no additional cost.
   */
  defaultLocation?: Maybe<Article>;
  /** @deprecated No longer in use. Always returns an empty object */
  fields: Scalars['Json']['output'];
  id: Scalars['ID']['output'];
  indexedAt?: Maybe<Scalars['Long']['output']>;
  indexedBy?: Maybe<User>;
  /** List of translations that interlink to this one */
  interlinkedBy: Array<ArticleTranslation>;
  /** Interlinks contained within the draft version of the article which are broken */
  invalidInterlinks?: Maybe<
    Array<
      | InvalidInterlink_ArticleNotFound
      | InvalidInterlink_ArticleNotInCollection
      | InvalidInterlink_ArticleNotPublished
      | InvalidInterlink_TranslationNotFound
      | InvalidInterlink_TranslationNotPublished
    >
  >;
  isDefaultLocation?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the article is tracked by Elevio workspace imports */
  isLocked: Scalars['Boolean']['output'];
  /** @deprecated Use `availableInPreRelease` instead */
  isPreRelease: Scalars['Boolean']['output'];
  locationHash?: Maybe<Scalars['String']['output']>;
  ownedBy?: Maybe<User>;
  parent?: Maybe<Category | Collection>;
  /** Returns a list of the collections this article belongs to */
  parentCollections: Array<Collection>;
  /**
   * List all the parents of this entity (cross-collection).
   * **Performance warning:** Calling this field requires the backend to build the graph across all collections which can be expensive when an organization has many collections. Only call this field if you're sure you need it. If this field was already called elsewhere, then calling it multiple times has no additional cost.
   */
  parents: Array<Category | Collection>;
  /** The conversations this article was drafted from, taken from the first AI assisted translation that references any */
  referencedConversationIds: Array<Scalars['Long']['output']>;
  restrictions: RestrictionsPayload;
  shortId: Scalars['ID']['output'];
  tags: Array<Tag>;
  /**
   * The title of the entity. Please note that the `NonEmptyString` type is kept for schema compatibility purposes only. It is possible for the title to be an empty string.
   * A future version of the schema will set the type to `String` instead.
   */
  title?: Maybe<Scalars['NonEmptyString']['output']>;
  titleDefault: TranslationTitle;
  titles: Array<TranslationTitle>;
  /** Query for the translation of an article */
  translation?: Maybe<TranslationQuery>;
  /** Query for the translations of this article */
  translations: TranslationListQuery;
  updatedAt: Scalars['Long']['output'];
  updatedBy?: Maybe<User>;
};

export type ArticleTitleArgs = {
  languageId: LanguageId;
};

export type ArticleTranslationArgs = {
  languageId?: InputMaybe<LanguageId>;
};

/**
 * Filters which can be used to exclude articles from the result list.
 *
 * NOTE: Filtering based on collection(s) is controlled via the `collectionId` and `excludeOrphans`. Possible combinations:
 *
 * * `{ collectionId: null, excludeOrphans: false | null }`: Returns all articles
 * * `{ collectionId: null, excludeOrphans: true }`: Returns all articles that belong to at least 1 collection
 * * `{ collectionId: [ ], excludeOrphans: false | null }`: Returns orphans only
 * * `{ collectionId: [XX, YY], excludeOrphans: true }`: Return articles of collection XX + collection YY
 * * `{ collectionId: [XX, YY], excludeOrphans: false | null }`: Return articles of collection XX + collection YY + orphans
 * * `{ collectionId: [ ], excludeOrphans: true }`: **WARNING**: Will always return an empty result list
 *
 */
export type ArticleFiltersInput = {
  /** List articles which exist in at least one of these collections.**IMPORTANT**: This filter applies only to articles that belong in at least one collection. Orphaned articles need to be explicitly excluded by setting `excludeOrphans: true` */
  collectionId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Exclude articles that do not belong to any collection. **Tip**: To return orphaned articles only, pass `excludeOrphans: false, collectionId: []` */
  excludeOrphans?: InputMaybe<Scalars['Boolean']['input']>;
  /** List articles that have translations in these languages only */
  languageId?: InputMaybe<Array<LanguageId>>;
  /** List articles which are owned by these users only */
  ownerId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List articles which have one of the specified publication statuses. While not enforced, it is highly recommended to use this filter in combination with 1 language ID */
  publicationStatus?: InputMaybe<Array<PublicationStatus>>;
};

export type ArticleList = {
  __typename: 'ArticleList';
  /** @deprecated use `query(filters: { collectionId: [] })` instead */
  orphans: Array<ArticleListItem>;
  /** List all users that own at least 1 article. Note that the current user will always appear at the top of the least if they own at least 1 article, and the remaining users will be sorted alphabetically */
  owners: Array<User>;
  query: ArticleQueryPayload;
  /** @deprecated Use `query` instead */
  results: Array<ArticleListItem>;
};

export type ArticleListQueryArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  query?: InputMaybe<ArticleSearchInput>;
};

export type ArticleListResultsArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  query?: InputMaybe<ArticleSearchInput>;
};

export type ArticleListItem = {
  __typename: 'ArticleListItem';
  archived: Scalars['Boolean']['output'];
  /** whether the article is available in the KCS prior to being published */
  availableInPrerelease?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Long']['output'];
  createdBy?: Maybe<User>;
  /** @deprecated No longer in use. Always returns an empty object */
  fields: Scalars['Json']['output'];
  id: Scalars['ID']['output'];
  indexedAt?: Maybe<Scalars['Long']['output']>;
  indexedBy?: Maybe<User>;
  /** Whether the article is tracked by Elevio workspace imports */
  isLocked: Scalars['Boolean']['output'];
  /** @deprecated use `availableInPrerelease` instead */
  isPreRelease: Scalars['Boolean']['output'];
  ownedBy?: Maybe<User>;
  parentCategories: Array<CategoryListItem>;
  parentCollections: Array<CollectionListItem>;
  publicationStatus?: Maybe<PublicationStatus>;
  restrictions: RestrictionsPayload;
  /**
   * The title of the entity. Please note that the `NonEmptyString` type is kept for schema compatibility purposes only. It is possible for the title to be an empty string.
   * A future version of the schema will set the type to `String` instead.
   */
  title?: Maybe<Scalars['NonEmptyString']['output']>;
  titleDefault: TranslationTitle;
  titles: Array<TranslationTitle>;
  updatedAt: Scalars['Long']['output'];
  updatedBy?: Maybe<User>;
};

export type ArticleListItemPublicationStatusArgs = {
  languageId: LanguageId;
};

export type ArticleListItemTitleArgs = {
  languageId: LanguageId;
};

export type ArticleQueryPayload = {
  __typename: 'ArticleQueryPayload';
  pagination: PaginationPayload;
  results: Array<ArticleListItem>;
};

export type ArticleSearchInput = {
  /** The language of the input search terms. This might become optional in the future in favour of automatic language detection */
  searchLanguage: LanguageId;
  /** Simple websearch-based text with support for double-quoted (exact) matches, and the OR and `-` operators */
  searchTerms: Scalars['NonEmptyString']['input'];
};

export type ArticleTranslation = {
  __typename: 'ArticleTranslation';
  /** Whether AI helped draft the translation. `null` when the origin is unknown */
  aiAssisted?: Maybe<Scalars['Boolean']['output']>;
  articleId: Scalars['ID']['output'];
  availableAt: AvailableAtPayload;
  /** @deprecated Use `contents.json` instead */
  content: Scalars['ContentJson']['output'];
  /** The article contents in different formats */
  contents: Contents;
  createdAt: Scalars['Long']['output'];
  createdBy?: Maybe<User>;
  featuredImage?: Maybe<File>;
  indexedAt?: Maybe<Scalars['Long']['output']>;
  indexedBy?: Maybe<User>;
  interlinkedBy: Array<ArticleTranslation>;
  invalidInterlinks?: Maybe<
    Array<
      | InvalidInterlink_ArticleNotFound
      | InvalidInterlink_ArticleNotInCollection
      | InvalidInterlink_ArticleNotPublished
      | InvalidInterlink_TranslationNotFound
      | InvalidInterlink_TranslationNotPublished
    >
  >;
  isIndexedVersion: Scalars['Boolean']['output'];
  languageId: LanguageId;
  /** @deprecated No longer in use. Always returns an empty object */
  metadata: Scalars['Json']['output'];
  /** The translation's publication status. NOTE: This field will return the same value regardless whether of the queried version (i.e., draft or published) */
  publicationStatus: PublicationStatus;
  /** The conversations the translation was drafted from. `null` when it referenced none */
  referencedConversationIds?: Maybe<Array<Scalars['Long']['output']>>;
  title: Scalars['NonEmptyString']['output'];
  titleTranslatedAt?: Maybe<Scalars['String']['output']>;
  titleUpdatedAt?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Long']['output'];
  updatedBy?: Maybe<User>;
  version: TranslationVersion;
};

export type ArticleTranslationInput = {
  /** Whether AI helped draft the translation */
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Article content in Slate JSON format. Mutually exclusive with `contentHtml`. */
  content?: InputMaybe<Scalars['ContentJson']['input']>;
  /** Article content as HTML. Mutually exclusive with `content`. */
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  languageId: LanguageId;
  /** Do not use. Kept for compatibility purposes only */
  metadata?: InputMaybe<Scalars['Json']['input']>;
  /** The conversations the translation was drafted from */
  referencedConversationIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  /**
   * The title of the entity. Please note that the `NonEmptyString` type is kept for schema compatibility purposes only. It is possible for the title to be an empty string.
   * A future version of the schema will set the type to `String` instead.
   */
  title: Scalars['NonEmptyString']['input'];
};

export type ArticleTranslationList = {
  __typename: 'ArticleTranslationList';
  results: Array<ArticleTranslation>;
};

export enum AvailabilityReason {
  NotAllowed = 'NOT_ALLOWED',
  Taken = 'TAKEN',
}

export type AvailableAtPayload = {
  __typename: 'AvailableAtPayload';
  helpCenters: Array<HelpCenterLink>;
};

/** Equivalent to a 400 code, raised when the input is invalid */
export type Bad_User_Input = {
  __typename: 'BAD_USER_INPUT';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom error raised when the translation `Content` is larger than 3 Megabytes */
export type Content_Size_Limit_Exceeded = {
  __typename: 'CONTENT_SIZE_LIMIT_EXCEEDED';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type Category = Child &
  Parent & {
    __typename: 'Category';
    articles: Array<Article>;
    categories: Array<Category>;
    /**
     * Get the default location of this entity.
     * **Performance warning:** Calling this field requires the backend to build the graph across all collections which can be expensive when an organization has many collections. Only call this field if you're sure you need it. If this field was already called elsewhere, then calling it multiple times has no additional cost.
     */
    defaultLocation?: Maybe<Category>;
    /** @deprecated No longer in use. Always returns an empty object */
    fields: Scalars['Json']['output'];
    id: Scalars['ID']['output'];
    isDefaultLocation?: Maybe<Scalars['Boolean']['output']>;
    /** Whether the category is tracked by Elevio workspace imports */
    isLocked: Scalars['Boolean']['output'];
    locationHash?: Maybe<Scalars['String']['output']>;
    parent?: Maybe<Category | Collection>;
    /** Returns a list of the collections this category belongs to */
    parentCollections: Array<Collection>;
    /**
     * List all the parents of this entity (cross-collection).
     * **Performance warning:** Calling this field requires the backend to build the graph across all collections which can be expensive when an organization has many collections. Only call this field if you're sure you need it. If this field was already called elsewhere, then calling it multiple times has no additional cost.
     */
    parents: Array<Category | Collection>;
    restrictions: RestrictionsPayload;
    shortId: Scalars['ID']['output'];
    title?: Maybe<Scalars['NonEmptyString']['output']>;
    titleDefault: TranslationTitle;
    titles: Array<TranslationTitle>;
  };

export type CategoryTitleArgs = {
  languageId: LanguageId;
};

export type CategoryList = {
  __typename: 'CategoryList';
  results: Array<CategoryListItem>;
};

export type CategoryListItem = {
  __typename: 'CategoryListItem';
  archived: Scalars['Boolean']['output'];
  /** @deprecated No longer in use. Always returns an empty object */
  fields: Scalars['Json']['output'];
  id: Scalars['ID']['output'];
  /** Whether the category is tracked by Elevio workspace imports */
  isLocked: Scalars['Boolean']['output'];
  parentCollections: Array<CollectionListItem>;
  restrictions: RestrictionsPayload;
  title?: Maybe<Scalars['NonEmptyString']['output']>;
  titleDefault: TranslationTitle;
  titles: Array<TranslationTitle>;
};

export type CategoryListItemTitleArgs = {
  languageId: LanguageId;
};

export type CategoryTranslationInputInput = {
  languageId: LanguageId;
  title: Scalars['NonEmptyString']['input'];
};

export type Child = {
  /** @deprecated No longer in use. Always returns an empty object */
  fields: Scalars['Json']['output'];
  id: Scalars['ID']['output'];
  isDefaultLocation?: Maybe<Scalars['Boolean']['output']>;
  isLocked: Scalars['Boolean']['output'];
  locationHash?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Category | Collection>;
  parentCollections: Array<Collection>;
  /**
   * List all the parents of this entity (cross-collection).
   * **Performance warning:** Calling this field requires the backend to build the graph across all collections which can be expensive when an organization has many collections. Only call this field if you're sure you need it. If this field was already called elsewhere, then calling it multiple times has no additional cost.
   */
  parents: Array<Category | Collection>;
  restrictions: RestrictionsPayload;
  shortId: Scalars['ID']['output'];
  title?: Maybe<Scalars['NonEmptyString']['output']>;
  titleDefault: TranslationTitle;
  titles: Array<TranslationTitle>;
};

export type ChildTitleArgs = {
  languageId: LanguageId;
};

export enum ChildDeletionMode {
  Delete = 'DELETE',
  Orphan = 'ORPHAN',
}

export type CnameRecord = {
  __typename: 'CnameRecord';
  aliasOf: Scalars['String']['output'];
  hostname: Scalars['String']['output'];
};

export type CnameStatus = {
  __typename: 'CnameStatus';
  record?: Maybe<CnameRecord>;
  status: VerificationStatus;
  verificationErrors?: Maybe<Array<Scalars['String']['output']>>;
};

export type Collection = Parent & {
  __typename: 'Collection';
  /** Lists **ALL** the articles found in the collection, optionally applying filters to the list. If an article exists more than once in the collection, it will be returned multiple times for each location. This is needed as articles in different locations might have different inherited restrictions */
  articleList: CollectionArticleList;
  /**
   * Articles that are placed in the root of the collection.
   * IMPORTANT: This query **will not** return all the articles that exist in the collection. To list all articles, use the `articleList` field
   */
  articles: Array<Article>;
  categories: Array<Category>;
  description?: Maybe<Scalars['NonEmptyString']['output']>;
  /** @deprecated No longer in use. Always returns an empty object */
  fields: Scalars['Json']['output'];
  helpCenters: Array<HelpCenter>;
  id: Scalars['ID']['output'];
  internalKbEnabled: Scalars['Boolean']['output'];
  /** Whether the collection is tracked by Elevio workspace imports */
  isLocked: Scalars['Boolean']['output'];
  linkedResources: Array<Queue>;
  restrictions: RestrictionsPayload;
  statistics: CollectionStats;
  themeColors: CollectionThemeColors;
  title: Scalars['NonEmptyString']['output'];
};

export type CollectionArticleListArgs = {
  filters?: CollectionArticleListFiltersInput;
  pagination?: InputMaybe<ListInput>;
};

export type CollectionArticleList = {
  __typename: 'CollectionArticleList';
  pagination: PaginationPayload;
  results: Array<Article>;
};

export type CollectionArticleListFiltersInput = {
  /** Only show articles that have a translation in one of these languages */
  languageIds?: InputMaybe<Array<LanguageId>>;
  /** Only show articles that have been published after this date */
  publishedAfter?: InputMaybe<Scalars['Long']['input']>;
  /** Only include articles that have one of these restrictions. NOTE: passing an empty list will return only articles with no restrictions */
  restrictions?: InputMaybe<Array<Restriction>>;
};

export type CollectionList = {
  __typename: 'CollectionList';
  results: Array<CollectionListItem>;
};

export type CollectionListItem = {
  __typename: 'CollectionListItem';
  description?: Maybe<Scalars['NonEmptyString']['output']>;
  /** @deprecated No longer in use. Always returns an empty object */
  fields: Scalars['Json']['output'];
  id: Scalars['ID']['output'];
  internalKbEnabled: Scalars['Boolean']['output'];
  /** Whether the collection is tracked by Elevio workspace imports */
  isLocked: Scalars['Boolean']['output'];
  linkedResources: Array<Queue>;
  restrictions: RestrictionsPayload;
  themeColors: CollectionThemeColors;
  title: Scalars['NonEmptyString']['output'];
};

export type CollectionStats = {
  __typename: 'CollectionStats';
  articleCount: Scalars['NonNegativeInt']['output'];
  categoryCount: Scalars['NonNegativeInt']['output'];
  queueCount: Scalars['NonNegativeInt']['output'];
};

export type CollectionThemeColors = {
  __typename: 'CollectionThemeColors';
  icon: Scalars['Color']['output'];
};

export type CollectionThemeColorsInput = {
  icon?: Scalars['Color']['input'];
};

/** The article contents in different formats */
export type Contents = {
  __typename: 'Contents';
  html: Scalars['String']['output'];
  json: Scalars['ContentJson']['output'];
  plaintext: Scalars['String']['output'];
};

export type CustomHostname = {
  __typename: 'CustomHostname';
  hostname: Scalars['String']['output'];
  records?: Maybe<HostnameRecords>;
};

export type DeletionSuccessful = {
  __typename: 'DeletionSuccessful';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type Draft = {
  __typename: 'Draft';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type Entity = {
  /** @deprecated No longer in use. Always returns an empty object */
  fields: Scalars['Json']['output'];
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  restrictions: RestrictionsPayload;
};

export type ErrorType =
  | Bad_User_Input
  | Content_Size_Limit_Exceeded
  | Forbidden
  | Internal_Server_Error
  | Invalid_Dependency_State
  | Media_Type_Not_Supported
  | Not_Found
  | Organisation_Not_Setup
  | Unauthorized;

export type ExternalResource = {
  archived: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['NonEmptyString']['output'];
};

export type ExternalResourceInput = {
  id: Scalars['ID']['input'];
  type: ExternalResourceType;
};

export enum ExternalResourceType {
  Queue = 'QUEUE',
}

/** Equivalent to a 403 code, raised when the user is not authorized to access a resource */
export type Forbidden = {
  __typename: 'FORBIDDEN';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type File = {
  __typename: 'File';
  /** The URL at which the file can be fetched from */
  availableAt: Scalars['URL']['output'];
  fileType: FileType;
  /** The name of the file as stored on S3 */
  filename: Scalars['NonEmptyString']['output'];
  /** The original name of the file as it was uploaded */
  originalFileName?: Maybe<Scalars['NonEmptyString']['output']>;
  /** File size in bytes */
  size: Scalars['Long']['output'];
  uploadedAt: Scalars['Long']['output'];
};

export type FileDeletionPayload =
  | DeletionSuccessful
  | FileInUseFailure
  | KbFileInUseFailure;

export type FileInUseFailure = {
  __typename: 'FileInUseFailure';
  translations: Array<TranslationHead>;
};

export type FileList = {
  __typename: 'FileList';
  continuationToken?: Maybe<Scalars['NonEmptyString']['output']>;
  results: Array<File>;
};

export enum FileType {
  Image = 'IMAGE',
}

export type FullName = {
  __typename: 'FullName';
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  middleNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type HelpCenter = {
  __typename: 'HelpCenter';
  collection?: Maybe<Collection>;
  companyUrl?: Maybe<Scalars['URL']['output']>;
  /** Custom hostname which aliases to the hosted help center */
  customHostname?: Maybe<CustomHostname>;
  defaultLanguage: Language;
  enabledLanguages: Array<Language>;
  favicon?: Maybe<File>;
  /** The hostname of the hosted help center */
  hostname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isHelpCenterIndexable: Scalars['Boolean']['output'];
  logo?: Maybe<File>;
  name: Scalars['NonEmptyString']['output'];
  subdomain: Scalars['String']['output'];
  theme: HelpCenterTheme;
  themeCustomization: HelpCenterThemeCustomization;
  translation?: Maybe<HelpCenterTranslation>;
  translations: Array<HelpCenterTranslation>;
  /**
   * The fully qualified URL for the help center.
   * This will be the custom hostname if one is set, otherwise it will be the hosted help-center hostname.
   * This field is only available if the help center is active
   */
  url?: Maybe<Scalars['URL']['output']>;
};

export type HelpCenterTranslationArgs = {
  languageId: LanguageId;
};

export type HelpCenterLink = {
  __typename: 'HelpCenterLink';
  /** The Help Center's ID */
  id: Scalars['ID']['output'];
  /** The Help Center's name */
  name: Scalars['String']['output'];
  /** The fully-qualified URL to access the referenced entity */
  url: Scalars['URL']['output'];
};

export type HelpCenterList = {
  __typename: 'HelpCenterList';
  results: Array<HelpCenter>;
};

export type HelpCenterSettings = {
  __typename: 'HelpCenterSettings';
  /** The base domain of the hosted help center */
  hostedDomain: Scalars['String']['output'];
};

export type HelpCenterTheme = {
  __typename: 'HelpCenterTheme';
  colors: HelpCenterThemeColors;
  id: Scalars['ID']['output'];
  name: Scalars['NonEmptyString']['output'];
  usedBy: Array<HelpCenter>;
};

export type HelpCenterThemeColors = {
  __typename: 'HelpCenterThemeColors';
  accent: Scalars['Color']['output'];
  accentText: Scalars['Color']['output'];
  link: Scalars['Color']['output'];
  pageBackground: Scalars['Color']['output'];
  text: Scalars['Color']['output'];
  websiteBackground: Scalars['Color']['output'];
};

export type HelpCenterThemeColorsInput = {
  accent?: Scalars['Color']['input'];
  accentText?: Scalars['Color']['input'];
  link?: Scalars['Color']['input'];
  pageBackground?: Scalars['Color']['input'];
  text?: Scalars['Color']['input'];
  websiteBackground?: Scalars['Color']['input'];
};

export type HelpCenterThemeColorsUpdateInput = {
  accent?: InputMaybe<Scalars['Color']['input']>;
  accentText?: InputMaybe<Scalars['Color']['input']>;
  link?: InputMaybe<Scalars['Color']['input']>;
  pageBackground?: InputMaybe<Scalars['Color']['input']>;
  text?: InputMaybe<Scalars['Color']['input']>;
  websiteBackground?: InputMaybe<Scalars['Color']['input']>;
};

export type HelpCenterThemeCustomization = {
  __typename: 'HelpCenterThemeCustomization';
  css: ThemeCustomizationField;
  footerHtml: ThemeCustomizationField;
  headerHtml: ThemeCustomizationField;
  js: ThemeCustomizationField;
};

export type HelpCenterThemeCustomizationInput = {
  css?: InputMaybe<ThemeCustomizationFieldInput>;
  footerHtml?: InputMaybe<ThemeCustomizationFieldInput>;
  headerHtml?: InputMaybe<ThemeCustomizationFieldInput>;
  js?: InputMaybe<ThemeCustomizationFieldInput>;
};

export type HelpCenterThemeList = {
  __typename: 'HelpCenterThemeList';
  results: Array<HelpCenterTheme>;
};

export type HelpCenterTranslation = {
  __typename: 'HelpCenterTranslation';
  languageId: LanguageId;
  tagline?: Maybe<Scalars['NonEmptyString']['output']>;
  title?: Maybe<Scalars['NonEmptyString']['output']>;
};

export type HelpCenterTranslationInput = {
  languageId: LanguageId;
  tagline: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type HostnameRecords = {
  __typename: 'HostnameRecords';
  cname: CnameStatus;
  ssl: SslStatus;
};

export enum HttpMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
}

/** Equivalent to a 500 code, raised when the server encounters an unexpected error */
export type Internal_Server_Error = {
  __typename: 'INTERNAL_SERVER_ERROR';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom error code which indicates that a dependency is in a state which prohibits the request from completing successfully. This error code will always be followed by a `cause` field in the error extensions */
export type Invalid_Dependency_State = {
  __typename: 'INVALID_DEPENDENCY_STATE';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type Indexed = {
  __typename: 'Indexed';
  versionNumber: Scalars['PositiveInt']['output'];
};

export type InheritedRestriction = {
  __typename: 'InheritedRestriction';
  from: Category | Collection;
  restriction: Restriction;
};

export type InvalidInterlink = {
  id: Scalars['ID']['output'];
};

/** The interlinked article does not exist */
export type InvalidInterlink_ArticleNotFound = InvalidInterlink & {
  __typename: 'InvalidInterlink_ArticleNotFound';
  id: Scalars['ID']['output'];
};

/** The parent article exists in a collection that does not contain the interlinked article */
export type InvalidInterlink_ArticleNotInCollection = InvalidInterlink & {
  __typename: 'InvalidInterlink_ArticleNotInCollection';
  /** The ID of the interlinked entity */
  id: Scalars['ID']['output'];
  /** The list of collections that the parent article is in, but the interlinked entity is not */
  missingFrom: Array<CollectionListItem>;
};

/** The interlinked article is not published */
export type InvalidInterlink_ArticleNotPublished = InvalidInterlink & {
  __typename: 'InvalidInterlink_ArticleNotPublished';
  id: Scalars['ID']['output'];
};

/** The parent article contains a translation interlinking a non-existent translation */
export type InvalidInterlink_TranslationNotFound = InvalidInterlink & {
  __typename: 'InvalidInterlink_TranslationNotFound';
  id: Scalars['ID']['output'];
  languageId: LanguageId;
};

/** The parent article contains a translation interlinking an unpublished translation */
export type InvalidInterlink_TranslationNotPublished = InvalidInterlink & {
  __typename: 'InvalidInterlink_TranslationNotPublished';
  id: Scalars['ID']['output'];
  languageId: LanguageId;
};

export type KbFileInUseFailure = {
  __typename: 'KbFileInUseFailure';
  ids: Array<Scalars['ID']['output']>;
};

export type Language = {
  __typename: 'Language';
  /** English name of language */
  description: Scalars['NonEmptyString']['output'];
  languageId: LanguageId;
  /** Native name of language */
  nativeDescription: Scalars['NonEmptyString']['output'];
  /** Usage statistics for this language */
  usage: LanguageUsage;
};

export enum LanguageId {
  /** Arabic */
  Ar = 'ar',
  /** Bulgarian */
  Bg = 'bg',
  /** Catalan */
  Ca = 'ca',
  /** Valencian */
  CaValencia = 'ca_valencia',
  /** Czech */
  Cs = 'cs',
  /** Danish */
  Da = 'da',
  /** German */
  De = 'de',
  /** German (Austria) */
  DeAt = 'de_at',
  /** German (Belgium) */
  DeBe = 'de_be',
  /** German (Switzerland) */
  DeCh = 'de_ch',
  /** Ewe */
  Ee = 'ee',
  /** Greek */
  El = 'el',
  /** English */
  En = 'en',
  /** English (Australia) */
  EnAu = 'en_au',
  /** English (Canada) */
  EnCa = 'en_ca',
  /** English (United Kingdom) */
  EnGb = 'en_gb',
  /** English (Ireland) */
  EnIe = 'en_ie',
  /** English (New Zealand) */
  EnNz = 'en_nz',
  /** English (United States) */
  EnUs = 'en_us',
  /** Spanish */
  Es = 'es',
  /** Spanish (Latin America) */
  Es_419 = 'es_419',
  /** Estonian */
  Et = 'et',
  /** Basque */
  Eu = 'eu',
  /** Persian */
  Fa = 'fa',
  /** Finnish */
  Fi = 'fi',
  /** French */
  Fr = 'fr',
  /** French (Belgium) */
  FrBe = 'fr_be',
  /** French (Canada) */
  FrCa = 'fr_ca',
  /** French (Switzerland) */
  FrCh = 'fr_ch',
  /** Galician */
  Gl = 'gl',
  /** Hindi */
  Hi = 'hi',
  /** Croatian */
  Hr = 'hr',
  /** Hungarian */
  Hu = 'hu',
  /** Indonesian */
  Id = 'id',
  /** Icelandic */
  Is = 'is',
  /** Italian */
  It = 'it',
  /** Italian (Switzerland) */
  ItCh = 'it_ch',
  /** Hebrew */
  Iw = 'iw',
  /** Japanese */
  Ja = 'ja',
  /** Korean */
  Ko = 'ko',
  /** Lithuanian */
  Lt = 'lt',
  /** Latvian */
  Lv = 'lv',
  /** Norwegian Bokmål */
  Nb = 'nb',
  /** Dutch */
  Nl = 'nl',
  /** Dutch (Belgium) */
  NlBe = 'nl_be',
  /** Norwegian Nynorsk */
  Nn = 'nn',
  /** Norwegian */
  No = 'no',
  /** Polish */
  Pl = 'pl',
  /** Portuguese */
  Pt = 'pt',
  /** Portuguese (Brazil) */
  PtBr = 'pt_br',
  /** Romanian */
  Ro = 'ro',
  /** Russian */
  Ru = 'ru',
  /** Slovak */
  Sk = 'sk',
  /** Slovenian */
  Sl = 'sl',
  /** Albanian */
  Sq = 'sq',
  /** Serbian */
  Sr = 'sr',
  /** Swedish */
  Sv = 'sv',
  /** Thai */
  Th = 'th',
  /** Turkish */
  Tr = 'tr',
  /** Ukrainian */
  Uk = 'uk',
  /** Vietnamese */
  Vi = 'vi',
  /** Chinese */
  Zh = 'zh',
  /** Chinese (Traditional) */
  ZhHant = 'zh_hant',
}

export type LanguageUsage = {
  __typename: 'LanguageUsage';
  /** Number of articles with a translation in this language */
  nArticles: Scalars['Int']['output'];
  /** Number of categories with a translation in this language */
  nCategories: Scalars['Int']['output'];
  /** Number of help centers with a translation in this language */
  nHelpCenters: Scalars['Int']['output'];
};

export type ListInput = {
  limit?: InputMaybe<Scalars['Limit']['input']>;
  offset?: InputMaybe<Scalars['Offset']['input']>;
};

/** Equivalent to a 415 code, raised when the media type is not supported by the server */
export type Media_Type_Not_Supported = {
  __typename: 'MEDIA_TYPE_NOT_SUPPORTED';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutations = {
  __typename: 'Mutations';
  /** Approve an AI generated draft. The article it proposes is created (or, for `ARTICLE_UPDATE` drafts, its translation is updated), the draft is marked approved, and the resulting article is returned. An approved draft is kept — and keeps reporting the article it became as `forArticleId` — until that article is published, so that what it holds is still found in the meantime; it is dropped once the article is published. A `NEW_ARTICLE` draft must have both a `collectionId` and a `categoryId` first, as the article needs somewhere to live; an `ARTICLE_UPDATE` draft needs neither, since the article it updates already has a place. Pass `alsoPublish: true` to publish the article right away instead of leaving it as an unpublished draft */
  aiDraftApprove?: Maybe<Article>;
  /** Delete an AI generated draft for good. An agent can delete the drafts they asked for themselves; deleting anyone else's, or one the AI put forward on its own, needs the `knowledge.content:w` scope */
  aiDraftDelete?: Maybe<Scalars['Unit']['output']>;
  /** Draft an article from a conversation and the conversations most similar to it, and store it for an agent to review. The draft records the conversation it was written from and the ones that informed it */
  aiDraftGenerate?: Maybe<AiDraft>;
  /** Reject an AI generated draft. Rejected drafts are kept for the record but never listed again. An approved draft cannot be rejected: the article it became is already written */
  aiDraftReject?: Maybe<AiDraft>;
  /** Ask the AI to revise a draft based on an agent's feedback. The draft's title and body are replaced with the revision the AI returns */
  aiDraftUpdate?: Maybe<AiDraft>;
  /** Change the default parent for an article */
  articleChangeDefaultParent?: Maybe<Article>;
  /**
   * Permanently deletes the publication history of an article for all translations.
   * It requires that the article has no currently published translations.
   */
  articleClearPublishedHistory?: Maybe<Article>;
  /** Create a new article */
  articleCreate?: Maybe<Article>;
  /** Delete an existing article */
  articleDelete?: Maybe<Scalars['Unit']['output']>;
  /** Publish a new version of all translations for an article */
  articlePublish?: Maybe<Article>;
  /** Create a new translation for an article and language */
  articleTranslationCreate?: Maybe<ArticleTranslation>;
  /** Delete all versions of an article translation */
  articleTranslationDelete?: Maybe<Scalars['Unit']['output']>;
  /** Publish a specific translation for search */
  articleTranslationPublish?: Maybe<Scalars['Unit']['output']>;
  /**
   * Reverts the draft version to a previously published version.
   * Fails if the translation doesn't have a published version
   */
  articleTranslationRevertDraft?: Maybe<ArticleTranslation>;
  /** Mark a specific translation as unpublished */
  articleTranslationUnpublish?: Maybe<Scalars['Unit']['output']>;
  /** Update the draft version of an article translation */
  articleTranslationUpdate?: Maybe<ArticleTranslation>;
  /** Upsert a translation for an article and language */
  articleTranslationUpsert?: Maybe<ArticleTranslation>;
  /** Unlock an article from Elevio Workspace Import */
  articleUnlock?: Maybe<Article>;
  /** Remove all translations of an article from search */
  articleUnpublish?: Maybe<Article>;
  /** Modify an existing article */
  articleUpdate?: Maybe<Article>;
  /** Change the default parent for a category */
  categoryChangeDefaultParent?: Maybe<Category>;
  /** Create a category within a collection */
  categoryCreate?: Maybe<Category>;
  /** Hard delete an existing category and all it's children */
  categoryDelete?: Maybe<Scalars['Unit']['output']>;
  /** Deletes a category translation. Raises an error if there are no other translations */
  categoryTranslationDelete?: Maybe<Category>;
  /** Updates an existing category translation if it exists or creates a new one if it not */
  categoryTranslationUpsert?: Maybe<Category>;
  /** Modify an existing category */
  categoryUpdate?: Maybe<Category>;
  /** Create a new collection */
  collectionCreate?: Maybe<Collection>;
  /** Hard delete an existing collection and all it's children */
  collectionDelete?: Maybe<Scalars['Unit']['output']>;
  /** Publishes a new version of all articles within the collection. Note that only articles which this is their default collection will be published */
  collectionPublish?: Maybe<Scalars['Unit']['output']>;
  /** Unlock a collection from Elevio Workspace Import */
  collectionUnlock?: Maybe<Collection>;
  /** Unpublishes all articles within the collection. Note that only articles which this is their default collection will be unpublished */
  collectionUnpublish?: Maybe<Scalars['Unit']['output']>;
  /** Modify an existing collection */
  collectionUpdate?: Maybe<Collection>;
  /**
   * Mutation used for moving an entity in the following ways:
   *
   * 1. New parent and specific the placement in the list (specify both `newPosition` and `newParentId`)
   * 2. New parent and place it at the bottom of the list (specify `newParentId` only)
   * 3. Move entity to a new location under the same parent (specify `newPosition` only)
   *
   * Returns an error if none of `newParentId` and `newPosition` are specified
   *
   */
  contentMove?: Maybe<Category | Collection>;
  entityAddRestrictions?: Maybe<Entity>;
  entityRemoveRestrictions?: Maybe<Entity>;
  /** Deletes a file from cloud storage. The file cannot be deleted if it's referenced in an article */
  fileDelete?: Maybe<FileDeletionPayload>;
  /** Generates a presigned request to upload files to S3. Currently only images are supported */
  fileUploadRequest?: Maybe<PresignedUploadRequest>;
  /** Creates a new help center (HC). By default, the help center is not linked to a collection. */
  helpCenterCreate?: Maybe<HelpCenter>;
  /** Deletes a help center. By default, attempting to delete a help center which has a custom hostname registered will cause the mutation to fail. Pass `deregisterCustomHostname: true` to force deletion of the HC in such cases. */
  helpCenterDelete?: Maybe<Scalars['Unit']['output']>;
  /** Deregisters the custom hostname. Re-registering the domain requires the SSL records to be re-validated */
  helpCenterDeregisterHostname?: Maybe<HelpCenter>;
  /** Make this help center available at a custom hostname. If the mutation is successful, the SSL and hostname validation records are guaranteed to be available in the payload */
  helpCenterRegisterHostname?: Maybe<HelpCenter>;
  /** Create a new help center theme */
  helpCenterThemeCreate?: Maybe<HelpCenterTheme>;
  /** Create a new help center theme */
  helpCenterThemeDelete?: Maybe<Scalars['Unit']['output']>;
  /** Updates a help center theme */
  helpCenterThemeUpdate?: Maybe<HelpCenterTheme>;
  /** Mutation that updates one or more of the help center's attributes */
  helpCenterUpdate?: Maybe<HelpCenter>;
  /** Make a saved version of the AI settings the one the organisation's AI uses */
  organisationActivateAiSettingsVersion?: Maybe<AiSettingsVersionPayload>;
  /** Turn the AI settings draft into the organisation's next version, and optionally make it the one its AI uses. Fails when there is no draft */
  organisationCreateAiSettingsVersion?: Maybe<AiSettingsVersionPayload>;
  /** Disable language for organisation */
  organisationDisableLanguage: OrganisationSettingsPayload;
  /** Enable languages for organisation */
  organisationEnableLanguages: OrganisationSettingsPayload;
  /** Rename a saved version of the AI settings, the only part of it that can be changed */
  organisationRenameAiSettingsVersion?: Maybe<AiSettingsVersionPayload>;
  /** Set default language for organisation */
  organisationSetDefaultLanguage: OrganisationSettingsPayload;
  /** Create the organisation's AI settings draft, or replace the settings it holds. The draft has no name or number, and is never used by the AI */
  organisationUpdateAiSettingsDraft?: Maybe<AiSettingsVersionPayload>;
  /** Add a category/article to a collection/category */
  parentAddChild?: Maybe<Category | Collection>;
  /** Remove a category/article from a collection/category */
  parentRemoveChild?: Maybe<Category | Collection>;
  /**
   * Sets up an organisation to use knowledge by creating all necessary resources: a default collection, default language, and a starter 'Welcome' category and article. Idempotent — calling on an already set-up organisation returns the existing default collection and does not create duplicate starter content.
   * @deprecated No longer needed — onboarding runs automatically on the first authenticated GraphQL request
   */
  setupOrganisation?: Maybe<Collection>;
};

export type MutationsAiDraftApproveArgs = {
  alsoPublish?: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationsAiDraftDeleteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationsAiDraftGenerateArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  csid: Scalars['Long']['input'];
  languageId: LanguageId;
  topK?: Scalars['Int']['input'];
};

export type MutationsAiDraftRejectArgs = {
  id: Scalars['ID']['input'];
};

export type MutationsAiDraftUpdateArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  feedback?: InputMaybe<Scalars['NonEmptyString']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationsArticleChangeDefaultParentArgs = {
  id: Scalars['ID']['input'];
  newDefaultParentId: Scalars['ID']['input'];
};

export type MutationsArticleClearPublishedHistoryArgs = {
  articleId: Scalars['ID']['input'];
};

export type MutationsArticleCreateArgs = {
  fields?: InputMaybe<Scalars['Json']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  preRelease?: Scalars['Boolean']['input'];
  restrictions?: Array<Restriction>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  translations: Array<ArticleTranslationInput>;
};

export type MutationsArticleDeleteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationsArticlePublishArgs = {
  articleId: Scalars['ID']['input'];
};

export type MutationsArticleTranslationCreateArgs = {
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  articleId: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['ContentJson']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  languageId: LanguageId;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  referencedConversationIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  title: Scalars['NonEmptyString']['input'];
};

export type MutationsArticleTranslationDeleteArgs = {
  articleId: Scalars['ID']['input'];
  languageId: LanguageId;
};

export type MutationsArticleTranslationPublishArgs = {
  articleId: Scalars['ID']['input'];
  languageId: LanguageId;
};

export type MutationsArticleTranslationRevertDraftArgs = {
  articleId: Scalars['ID']['input'];
  languageId: LanguageId;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type MutationsArticleTranslationUnpublishArgs = {
  articleId: Scalars['ID']['input'];
  languageId: LanguageId;
};

export type MutationsArticleTranslationUpdateArgs = {
  articleId: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['ContentJson']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['String']['input']>;
  languageId: LanguageId;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  titleTranslatedAt?: InputMaybe<Scalars['String']['input']>;
  titleUpdatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type MutationsArticleTranslationUpsertArgs = {
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  articleId: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['ContentJson']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  languageId: LanguageId;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  referencedConversationIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  title: Scalars['NonEmptyString']['input'];
};

export type MutationsArticleUnlockArgs = {
  id: Scalars['ID']['input'];
};

export type MutationsArticleUnpublishArgs = {
  articleId: Scalars['ID']['input'];
};

export type MutationsArticleUpdateArgs = {
  fields?: InputMaybe<Scalars['Json']['input']>;
  id: Scalars['ID']['input'];
  ownedBy?: InputMaybe<Scalars['ID']['input']>;
  preRelease?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<TagsInput>;
};

export type MutationsCategoryChangeDefaultParentArgs = {
  id: Scalars['ID']['input'];
  newDefaultParentId: Scalars['ID']['input'];
};

export type MutationsCategoryCreateArgs = {
  fields?: InputMaybe<Scalars['Json']['input']>;
  parentId: Scalars['ID']['input'];
  restrictions?: Array<Restriction>;
  translations: Array<CategoryTranslationInputInput>;
};

export type MutationsCategoryDeleteArgs = {
  articles?: InputMaybe<ChildDeletionMode>;
  id: Scalars['ID']['input'];
};

export type MutationsCategoryTranslationDeleteArgs = {
  id: Scalars['ID']['input'];
  languageId: LanguageId;
};

export type MutationsCategoryTranslationUpsertArgs = {
  id: Scalars['ID']['input'];
  languageId: LanguageId;
  title: Scalars['NonEmptyString']['input'];
};

export type MutationsCategoryUpdateArgs = {
  fields?: InputMaybe<Scalars['Json']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationsCollectionCreateArgs = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fields?: InputMaybe<Scalars['Json']['input']>;
  internalKbEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  restrictions?: Array<Restriction>;
  themeColors?: CollectionThemeColorsInput;
  title: Scalars['NonEmptyString']['input'];
};

export type MutationsCollectionDeleteArgs = {
  articles?: InputMaybe<ChildDeletionMode>;
  deactivateLinkedKbs?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationsCollectionPublishArgs = {
  id: Scalars['ID']['input'];
};

export type MutationsCollectionUnlockArgs = {
  id: Scalars['ID']['input'];
};

export type MutationsCollectionUnpublishArgs = {
  id: Scalars['ID']['input'];
};

export type MutationsCollectionUpdateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalResources?: InputMaybe<ResourcesUpdateInput>;
  fields?: InputMaybe<Scalars['Json']['input']>;
  id: Scalars['ID']['input'];
  internalKbEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  themeColors?: InputMaybe<UpdateCollectionThemeColorsInput>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type MutationsContentMoveArgs = {
  currentParentId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  newParentId?: InputMaybe<Scalars['ID']['input']>;
  newPosition?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type MutationsEntityAddRestrictionsArgs = {
  id: Scalars['ID']['input'];
  restrictions: Array<Restriction>;
};

export type MutationsEntityRemoveRestrictionsArgs = {
  id: Scalars['ID']['input'];
  restrictions: Array<Restriction>;
};

export type MutationsFileDeleteArgs = {
  filename: Scalars['NonEmptyString']['input'];
};

export type MutationsFileUploadRequestArgs = {
  filename: Scalars['NonEmptyString']['input'];
};

export type MutationsHelpCenterCreateArgs = {
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  defaultLanguage?: InputMaybe<LanguageId>;
  isHelpCenterIndexable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['NonEmptyString']['input'];
  subdomain: Scalars['String']['input'];
  themeId?: InputMaybe<Scalars['ID']['input']>;
  translations?: Array<HelpCenterTranslationInput>;
};

export type MutationsHelpCenterDeleteArgs = {
  deregisterCustomHostname?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationsHelpCenterDeregisterHostnameArgs = {
  id: Scalars['ID']['input'];
};

export type MutationsHelpCenterRegisterHostnameArgs = {
  customHostname: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type MutationsHelpCenterThemeCreateArgs = {
  colors: HelpCenterThemeColorsInput;
  name: Scalars['NonEmptyString']['input'];
};

export type MutationsHelpCenterThemeDeleteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationsHelpCenterThemeUpdateArgs = {
  colors?: InputMaybe<HelpCenterThemeColorsUpdateInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type MutationsHelpCenterUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  companyUrl?: InputMaybe<Scalars['URL']['input']>;
  defaultLanguage?: InputMaybe<LanguageId>;
  disableLanguages?: InputMaybe<Array<LanguageId>>;
  enableLanguages?: InputMaybe<Array<LanguageId>>;
  favicon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isHelpCenterIndexable?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  themeCustomization?: InputMaybe<HelpCenterThemeCustomizationInput>;
  themeId?: InputMaybe<Scalars['ID']['input']>;
  translation?: InputMaybe<HelpCenterTranslationInput>;
};

export type MutationsOrganisationActivateAiSettingsVersionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationsOrganisationCreateAiSettingsVersionArgs = {
  activate?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type MutationsOrganisationDisableLanguageArgs = {
  languageId: LanguageId;
};

export type MutationsOrganisationEnableLanguagesArgs = {
  languageIds: Array<LanguageId>;
};

export type MutationsOrganisationRenameAiSettingsVersionArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationsOrganisationSetDefaultLanguageArgs = {
  languageId: LanguageId;
};

export type MutationsOrganisationUpdateAiSettingsDraftArgs = {
  judgeInstructions?: InputMaybe<Scalars['String']['input']>;
  minSimilarConversations: Scalars['Int']['input'];
  similarity: SimilarityLevel;
  writerInstructions?: InputMaybe<Scalars['String']['input']>;
};

export type MutationsParentAddChildArgs = {
  childId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['Json']['input']>;
  parentId: Scalars['ID']['input'];
};

export type MutationsParentRemoveChildArgs = {
  childId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
};

/** Equivalent to a 404 code, raised when the requested resource does not exist on the server. */
export type Not_Found = {
  __typename: 'NOT_FOUND';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom error raised when the user's organisation has not been set up yet to use knowledge */
export type Organisation_Not_Setup = {
  __typename: 'ORGANISATION_NOT_SETUP';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganisationSettingsPayload = {
  __typename: 'OrganisationSettingsPayload';
  /** All available languages */
  availableLanguages: Array<Language>;
  /** Default language for organisation */
  defaultLanguage: Language;
  /** Enabled languages for organisation */
  enabledLanguages: Array<Language>;
};

export type PaginationPayload = {
  __typename: 'PaginationPayload';
  /** The index of the last result in the list. Null when the query returned no results */
  end?: Maybe<Scalars['Int']['output']>;
  /** Whether the results of the query can be paginated further */
  hasMore: Scalars['Boolean']['output'];
  /** The index of the first result in the list. Null when the query returned no results */
  start?: Maybe<Scalars['Int']['output']>;
  /** The total number of results available for this query */
  total: Scalars['Int']['output'];
};

export type Parent = {
  articles: Array<Article>;
  categories: Array<Category>;
  /** @deprecated No longer in use. Always returns an empty object */
  fields: Scalars['Json']['output'];
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  restrictions: RestrictionsPayload;
};

export type PresignedUploadRequest = {
  __typename: 'PresignedUploadRequest';
  /** URL at which the file will be available after upload */
  availableAt: Scalars['URL']['output'];
  /** The exact content-type header that must be used in the request */
  contentType: Scalars['String']['output'];
  /** Headers that MUST be included in the upload request */
  customHeaders: Array<Scalars['String']['output']>;
  /** Unix epoch in milliseconds until the upload must begin */
  expiresAt: Scalars['Long']['output'];
  /** The unique filename which will be used to store the file on cloud storage */
  filename: Scalars['NonEmptyString']['output'];
  /** HTTP method to use to in the upload request */
  method: HttpMethod;
  /** URL to which to upload the file */
  uploadUrl: Scalars['URL']['output'];
};

export enum PublicationStatus {
  NeverPublished = 'NEVER_PUBLISHED',
  Published = 'PUBLISHED',
  PublishedWithDraft = 'PUBLISHED_WITH_DRAFT',
  Unpublished = 'UNPUBLISHED',
}

export type Queries = {
  __typename: 'Queries';
  /** Get an AI generated article draft via its id */
  aiDraft?: Maybe<AiDraft>;
  /** Get the draft written from a conversation, most recent first. `null` when it has none */
  aiDraftByCsid?: Maybe<AiDraft>;
  /** List the AI generated article drafts awaiting review, most recently modified first. Rejected and approved drafts are never listed */
  aiDrafts?: Maybe<AiDraftQueryPayload>;
  /** A version of the organisation's AI settings, or its draft. Without an id, the draft or, while there is none, the latest version, or the defaults when it never saved any */
  aiSettingsVersion?: Maybe<AiSettingsVersionPayload>;
  /** Every saved version of the organisation's AI settings, most recent first. Never the draft */
  aiSettingsVersions?: Maybe<Array<AiSettingsVersionSummaryPayload>>;
  /** Get an article via its id */
  article?: Maybe<Article>;
  /**
   * Get an article translation via its UID and language ID
   * @deprecated Use the `translation` field on Article instead
   */
  articleTranslation?: Maybe<TranslationQuery>;
  /**
   * Search for draft translations based on a query string
   * @deprecated use articles.query and pass the searchQuery argument instead
   */
  articleTranslationSearch: ArticleTranslationList;
  /**
   * List article translations
   * @deprecated Use the `translations` field on Article instead
   */
  articleTranslations: TranslationListQuery;
  /** List articles */
  articles: ArticleList;
  /** List categories */
  categories: CategoryList;
  /** Get a category via its id */
  category?: Maybe<Category>;
  /** Get a collection via its id */
  collection?: Maybe<Collection>;
  /** List collections */
  collections: CollectionList;
  /** List all files of a specific type */
  files?: Maybe<FileList>;
  /** Get a help center via its ID */
  helpCenter?: Maybe<HelpCenter>;
  /** Get a help center theme via its ID */
  helpCenterTheme?: Maybe<HelpCenterTheme>;
  /** Get a help center theme via its ID */
  helpCenterThemes?: Maybe<HelpCenterThemeList>;
  /** List all help centers */
  helpCenters: HelpCenterList;
  /** Get settings for organisation */
  organisationSettings: OrganisationSettingsPayload;
  /**
   * Search the organisation's published articles by meaning rather than keywords.
   *
   * Unlike the other search queries this is not scoped to collections and applies no per-article access control — it is
   * intended for service-to-service use. Returns nothing for organisations without article embeddings enabled.
   */
  semanticSearch: SemanticSearchResults;
  /** Various settings which can be used to determine which UI components to rended for the user */
  settings: SettingsPayload;
  /** Checks if a hosted KB subdomain is available */
  subdomainAvailability?: Maybe<SubdomainAvailability>;
};

export type QueriesAiDraftArgs = {
  id: Scalars['ID']['input'];
};

export type QueriesAiDraftByCsidArgs = {
  csid: Scalars['Long']['input'];
};

export type QueriesAiDraftsArgs = {
  filters?: InputMaybe<AiDraftFiltersInput>;
  limit?: InputMaybe<Scalars['Limit']['input']>;
  offset?: InputMaybe<Scalars['Offset']['input']>;
  searchQuery?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type QueriesAiSettingsVersionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueriesArticleArgs = {
  id: Scalars['ID']['input'];
  locationHash?: InputMaybe<Scalars['String']['input']>;
};

export type QueriesArticleTranslationArgs = {
  id: Scalars['ID']['input'];
  languageId: LanguageId;
};

export type QueriesArticleTranslationSearchArgs = {
  languageId: LanguageId;
  limit?: InputMaybe<Scalars['Limit']['input']>;
  query: Scalars['NonEmptyString']['input'];
};

export type QueriesArticleTranslationsArgs = {
  id: Scalars['ID']['input'];
};

export type QueriesArticlesArgs = {
  limit?: InputMaybe<Scalars['Limit']['input']>;
  offset?: InputMaybe<Scalars['Offset']['input']>;
};

export type QueriesCategoriesArgs = {
  limit?: InputMaybe<Scalars['Limit']['input']>;
  offset?: InputMaybe<Scalars['Offset']['input']>;
};

export type QueriesCategoryArgs = {
  id: Scalars['ID']['input'];
  locationHash?: InputMaybe<Scalars['String']['input']>;
};

export type QueriesCollectionArgs = {
  id: Scalars['ID']['input'];
};

export type QueriesCollectionsArgs = {
  limit?: InputMaybe<Scalars['Limit']['input']>;
  offset?: InputMaybe<Scalars['Offset']['input']>;
};

export type QueriesFilesArgs = {
  continuationToken?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fileType: FileType;
  limit?: InputMaybe<Scalars['Limit']['input']>;
};

export type QueriesHelpCenterArgs = {
  id: Scalars['ID']['input'];
};

export type QueriesHelpCenterThemeArgs = {
  id: Scalars['ID']['input'];
};

export type QueriesHelpCenterThemesArgs = {
  limit?: InputMaybe<Scalars['Limit']['input']>;
  offset?: InputMaybe<Scalars['Offset']['input']>;
};

export type QueriesHelpCentersArgs = {
  limit?: InputMaybe<Scalars['Limit']['input']>;
  offset?: InputMaybe<Scalars['Offset']['input']>;
};

export type QueriesSemanticSearchArgs = {
  helpCenterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeAiDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  includeFullContent?: InputMaybe<Scalars['Boolean']['input']>;
  includeRejectedDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<LanguageId>;
  text: Scalars['NonEmptyString']['input'];
  topK?: InputMaybe<Scalars['Limit']['input']>;
};

export type QueriesSubdomainAvailabilityArgs = {
  subdomain: Scalars['String']['input'];
};

export type Queue = ExternalResource & {
  __typename: 'Queue';
  archived: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['NonEmptyString']['output'];
};

export type ResourcesUpdateInput = {
  link?: InputMaybe<Array<ExternalResourceInput>>;
  unlink?: InputMaybe<Array<ExternalResourceInput>>;
};

export enum Restriction {
  Internal = 'INTERNAL',
}

/** NOTE: This payload will be extended in the future to also contain inherited restrictions */
export type RestrictionsPayload = {
  __typename: 'RestrictionsPayload';
  /** Restrictions that are applied directly to this entity */
  direct: Array<Restriction>;
  /**
   * Restrictions that are inherited from the parents in the entity hierarchy. In cases that the same restriction is applied to multiple parents, only the one at the top of the hierarchy is included in this payload.
   * Note that this field is nullable for queries where the entity's parents are not known
   */
  inherited?: Maybe<Array<InheritedRestriction>>;
};

export type SemanticSearchResult = {
  __typename: 'SemanticSearchResult';
  /** ID of the AI draft the matching chunk belongs to. Null when the match is a published article */
  aiDraftId?: Maybe<Scalars['ID']['output']>;
  /** ID of the article the matching chunk belongs to. Null when the match is an AI draft */
  articleId?: Maybe<Scalars['ID']['output']>;
  /** The full document as HTML, for an article and a draft alike. Only populated when `includeFullContent` is set on the query, since it costs extra to read */
  htmlContent?: Maybe<Scalars['String']['output']>;
  languageId: LanguageId;
  /** The chunk that matched, suitable for use as an excerpt */
  matchedChunk: Scalars['String']['output'];
  /** How close the match is, from 0 (unrelated) to 1 (identical) */
  similarity: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type SemanticSearchResults = {
  __typename: 'SemanticSearchResults';
  results: Array<SemanticSearchResult>;
};

export type SettingsPayload = {
  __typename: 'SettingsPayload';
  /**
   * Whether the user has sufficient permissions to create new collections
   * @deprecated Use `permissions.collections` instead
   */
  canCreateCollections: Scalars['Boolean']['output'];
  /**
   * Whether the user has sufficient permissions to setup the initial knowledge resources for the organization. This field is `null` if the organization is already setup
   * @deprecated No longer used, always returns `null`
   */
  canSetupOrganisation?: Maybe<Scalars['Boolean']['output']>;
  /** Settings related for managing help centers */
  helpCenter: HelpCenterSettings;
  /**
   * Whether the organization has been setup to use knowledge
   * @deprecated No longer used, always returns true
   */
  isOrganisationSetup: Scalars['Boolean']['output'];
  /** Can be used to determine whether a user has access to perform certain actions in the Knowledge */
  userPermissions: UserPermissionsSettings;
};

export enum SimilarityLevel {
  Broad = 'BROAD',
  Default = 'DEFAULT',
  Strict = 'STRICT',
}

export type SslStatus = {
  __typename: 'SslStatus';
  /** @deprecated Use `records` instead, which can hold more than one record */
  record?: Maybe<SslTxtRecord>;
  /** TXT records that the certificate authority will check during domain validation */
  records: Array<SslTxtRecord>;
  status: VerificationStatus;
};

export type SslTxtRecord = {
  __typename: 'SslTxtRecord';
  name: Scalars['NonEmptyString']['output'];
  value: Scalars['NonEmptyString']['output'];
};

export type SubdomainAvailability = {
  __typename: 'SubdomainAvailability';
  isAvailable: Scalars['Boolean']['output'];
  reason?: Maybe<AvailabilityReason>;
};

export type Subscriptions = {
  __typename: 'Subscriptions';
  articleTranslationUpdates?: Maybe<ArticleTranslation>;
};

export type SubscriptionsArticleTranslationUpdatesArgs = {
  id: Scalars['ID']['input'];
  languageId: LanguageId;
};

export type Tag = {
  __typename: 'Tag';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeactivated: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: TagType;
};

export enum TagType {
  Conversation = 'CONVERSATION',
  Queue = 'QUEUE',
  User = 'USER',
}

export type TagsInput = {
  add?: InputMaybe<Array<Scalars['ID']['input']>>;
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ThemeCustomizationField = {
  __typename: 'ThemeCustomizationField';
  enabled: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ThemeCustomizationFieldInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TranslationHead = {
  __typename: 'TranslationHead';
  articleId: Scalars['ID']['output'];
  isCurrentlyIndexed: Scalars['Boolean']['output'];
  languageId: LanguageId;
  /**
   * The title of the entity. Please note that the `NonEmptyString` type is kept for schema compatibility purposes only. It is possible for the title to be an empty string.
   * A future version of the schema will set the type to `String` instead.
   */
  title: Scalars['NonEmptyString']['output'];
  version: TranslationVersion;
};

export type TranslationListQuery = {
  __typename: 'TranslationListQuery';
  /** Lists the draft translations for each available language */
  draft: Array<ArticleTranslation>;
  /**
   * Lists all versions for a specific language
   * @deprecated Do not use, will be removed in a future version
   */
  forLanguage?: Maybe<Array<ArticleTranslation>>;
  /** Lists all published versions for an article */
  published: Array<ArticleTranslation>;
  /** Lists all published versions for a specific language, ordered by version descending */
  versions: Array<TranslationVersionSummaryPayload>;
};

export type TranslationListQueryForLanguageArgs = {
  languageId: LanguageId;
};

export type TranslationListQueryVersionsArgs = {
  languageId: LanguageId;
};

export type TranslationQuery = {
  __typename: 'TranslationQuery';
  articleId: Scalars['ID']['output'];
  /** Get the draft version of this translation */
  draft: ArticleTranslation;
  /**
   * Whether the draft version of the translation content or title differs from the published version. Returns `true` when the translation has not been published yet
   * @deprecated Use `publicationStatus` instead
   */
  hasUnpublishedChanges: Scalars['Boolean']['output'];
  languageId: LanguageId;
  publicationStatus: PublicationStatus;
  /** Get the published version of this translation. Returns `null` if the translation is not published */
  published?: Maybe<ArticleTranslation>;
  /** Get a specific version of this translation. Returns `null` if the version does not exist */
  version?: Maybe<ArticleTranslation>;
};

export type TranslationQueryVersionArgs = {
  versionNumber: Scalars['PositiveInt']['input'];
};

export type TranslationTitle = {
  __typename: 'TranslationTitle';
  languageId: LanguageId;
  /**
   * The title of the entity. Please note that the `NonEmptyString` type is kept for schema compatibility purposes only. It is possible for the title to be an empty string.
   * A future version of the schema will set the type to `String` instead.
   */
  title: Scalars['NonEmptyString']['output'];
};

export type TranslationVersion = Draft | Indexed;

/** Summary of a published translation version */
export type TranslationVersionSummaryPayload = {
  __typename: 'TranslationVersionSummaryPayload';
  /** Whether AI helped draft this version. `null` when the origin is unknown */
  aiAssisted?: Maybe<Scalars['Boolean']['output']>;
  isCurrentlyIndexed: Scalars['Boolean']['output'];
  /** When this version was published (epoch millis) */
  publishedAt: Scalars['Long']['output'];
  /** The user who published this version */
  publishedBy?: Maybe<User>;
  /** The conversations this version was drafted from. `null` when it referenced none */
  referencedConversationIds?: Maybe<Array<Scalars['Long']['output']>>;
  title: Scalars['NonEmptyString']['output'];
  version: TranslationVersion;
};

/** Equivalent to a 401 code, raised when are missing or are invalid */
export type Unauthorized = {
  __typename: 'UNAUTHORIZED';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCollectionThemeColorsInput = {
  icon?: InputMaybe<Scalars['Color']['input']>;
};

export type User = {
  __typename: 'User';
  avatarUrl?: Maybe<Scalars['URL']['output']>;
  deactivated: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['EmailAddress']['output']>;
  fullName?: Maybe<FullName>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type UserPermissionsSettings = {
  __typename: 'UserPermissionsSettings';
  collections: AccessLevel;
  content: AccessLevel;
  helpCenterSettings: AccessLevel;
  languageSettings: AccessLevel;
};

export enum VerificationStatus {
  Active = 'ACTIVE',
  Error = 'ERROR',
  Pending = 'PENDING',
}

export type AiDraftApproveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  alsoPublish: Scalars['Boolean']['input'];
}>;

export type AiDraftApproveMutation = {
  __typename: 'Mutations';
  aiDraftApprove?: { __typename: 'Article'; id: string } | null;
};

export type AiDraftQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type AiDraftQuery = {
  __typename: 'Queries';
  aiDraft?: ({ __typename: 'AiDraft' } & AiDraftListItemFragment) | null;
};

export type AiDraftRejectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type AiDraftRejectMutation = {
  __typename: 'Mutations';
  aiDraftReject?: { __typename: 'AiDraft'; id: string } | null;
};

export type AiDraftUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  feedback?: InputMaybe<Scalars['NonEmptyString']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AiDraftUpdateMutation = {
  __typename: 'Mutations';
  aiDraftUpdate?: ({ __typename: 'AiDraft' } & AiDraftListItemFragment) | null;
};

export type AiDraftsQueryVariables = Exact<{
  searchQuery?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filters?: InputMaybe<AiDraftFiltersInput>;
  limit?: InputMaybe<Scalars['Limit']['input']>;
  offset?: InputMaybe<Scalars['Offset']['input']>;
}>;

export type AiDraftsQuery = {
  __typename: 'Queries';
  aiDrafts?: {
    __typename: 'AiDraftQueryPayload';
    results: Array<{ __typename: 'AiDraft' } & AiDraftListItemFragment>;
    pagination: {
      __typename: 'PaginationPayload';
      hasMore: boolean;
      end?: number | null;
      total: number;
    };
  } | null;
};

export type AiDraftListItemFragment = {
  __typename: 'AiDraft';
  id: string;
  title: string;
  type: AiDraftType;
  languageId: LanguageId;
  createdAt: number;
  modifiedAt?: number | null;
  initiatedFromConversation: number;
  referencedConversationIds: Array<number>;
  collectionId?: string | null;
  categoryId?: string | null;
  possibleCollectionIds: Array<string>;
  forArticleId?: string | null;
  summary?: string | null;
  htmlContent: string;
  initiatedBy?: {
    __typename: 'User';
    id: string;
    name?: string | null;
    email?: string | null;
    avatarUrl?: string | null;
  } | null;
};

export type ArticleCreateMutationVariables = Exact<{
  translations: Array<ArticleTranslationInput> | ArticleTranslationInput;
  parentId: Scalars['ID']['input'];
}>;

export type ArticleCreateMutation = {
  __typename: 'Mutations';
  articleCreate?: ({ __typename: 'Article' } & ArticleFieldsFragment) | null;
};

export type ArticleDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ArticleDeleteMutation = {
  __typename: 'Mutations';
  articleDelete?: string | null;
};

export type ArticleFieldsFragment = {
  __typename: 'Article';
  id: string;
  updatedAt: number;
  indexedAt?: number | null;
  isSyncedWithElevio: boolean;
  parent?:
    | { __typename: 'Category'; id: string }
    | { __typename: 'Collection'; id: string }
    | null;
  titles: Array<{
    __typename: 'TranslationTitle';
    title: string;
    languageId: LanguageId;
  }>;
  restrictions: {
    __typename: 'RestrictionsPayload';
    direct: Array<Restriction>;
    inherited?: Array<{
      __typename: 'InheritedRestriction';
      restriction: Restriction;
      from:
        | { __typename: 'Category'; id: string }
        | { __typename: 'Collection'; id: string };
    }> | null;
  };
};

export type ArticleMoveMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  currentParentId: Scalars['ID']['input'];
  newParentId?: InputMaybe<Scalars['ID']['input']>;
  newPosition?: InputMaybe<Scalars['PositiveInt']['input']>;
}>;

export type ArticleMoveMutation = {
  __typename: 'Mutations';
  contentMove?:
    | { __typename: 'Category'; id: string }
    | { __typename: 'Collection'; id: string }
    | null;
};

export type ArticleNodeFragment = {
  __typename: 'Article';
  id: string;
  parent?:
    | { __typename: 'Category'; id: string }
    | { __typename: 'Collection'; id: string }
    | null;
  titles: Array<{
    __typename: 'TranslationTitle';
    title: string;
    languageId: LanguageId;
  }>;
};

export type ArticleListItemNodeFragment = {
  __typename: 'ArticleListItem';
  id: string;
  parentCategories: Array<{ __typename: 'CategoryListItem'; id: string }>;
  titles: Array<{
    __typename: 'TranslationTitle';
    title: string;
    languageId: LanguageId;
  }>;
};

export type ArticleTranslationUpdateMutationVariables = Exact<{
  articleId: Scalars['ID']['input'];
  languageId: LanguageId;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  content?: InputMaybe<Scalars['ContentJson']['input']>;
  titleUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  titleTranslatedAt?: InputMaybe<Scalars['String']['input']>;
}>;

export type ArticleTranslationUpdateMutation = {
  __typename: 'Mutations';
  articleTranslationUpdate?:
    | ({ __typename: 'ArticleTranslation' } & ArticleTranslationFieldsFragment)
    | null;
};

export type ArticleDetachFromElevioMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ArticleDetachFromElevioMutation = {
  __typename: 'Mutations';
  articleUnlock?: {
    __typename: 'Article';
    id: string;
    isSyncedWithElevio: boolean;
  } | null;
};

export type ArticlesQueryVariables = Exact<{
  languageId: LanguageId;
  limit?: InputMaybe<Scalars['Limit']['input']>;
  offset?: InputMaybe<Scalars['Offset']['input']>;
  filters?: InputMaybe<ArticleFiltersInput>;
  query?: InputMaybe<ArticleSearchInput>;
}>;

export type ArticlesQuery = {
  __typename: 'Queries';
  articles: {
    __typename: 'ArticleList';
    query: {
      __typename: 'ArticleQueryPayload';
      results: Array<
        { __typename: 'ArticleListItem' } & ArticleListItemResultFragment
      >;
      pagination: {
        __typename: 'PaginationPayload';
        hasMore: boolean;
        end?: number | null;
      };
    };
  };
};

export type ArticleListItemResultFragment = {
  __typename: 'ArticleListItem';
  id: string;
  title?: string | null;
  publicationStatus?: PublicationStatus | null;
  createdAt: number;
  updatedAt: number;
  isSyncedWithElevio: boolean;
  titles: Array<{
    __typename: 'TranslationTitle';
    languageId: LanguageId;
    title: string;
  }>;
  parentCollections: Array<{
    __typename: 'CollectionListItem';
    id: string;
    internalKbEnabled: boolean;
    title: string;
    linkedResources: Array<{ __typename: 'Queue'; id: string; name: string }>;
  }>;
  createdBy?: {
    __typename: 'User';
    name?: string | null;
    deactivated: boolean;
  } | null;
  updatedBy?: {
    __typename: 'User';
    name?: string | null;
    deactivated: boolean;
  } | null;
  parentCategories: Array<{
    __typename: 'CategoryListItem';
    id: string;
    title?: string | null;
    parentCollections: Array<{
      __typename: 'CollectionListItem';
      id: string;
      title: string;
    }>;
  }>;
};

export type CategoryChildFragment = {
  __typename: 'Category';
  articles: Array<{ __typename: 'Article' } & ArticleFieldsFragment>;
  categories: Array<{ __typename: 'Category' } & CategoryFieldsFragment>;
} & CategoryFieldsFragment;

export type CategoryCreateMutationVariables = Exact<{
  parentId: Scalars['ID']['input'];
  translations:
    | Array<CategoryTranslationInputInput>
    | CategoryTranslationInputInput;
}>;

export type CategoryCreateMutation = {
  __typename: 'Mutations';
  categoryCreate?: ({ __typename: 'Category' } & CategoryFieldsFragment) | null;
};

export type CategoryDeleteMutationVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;

export type CategoryDeleteMutation = {
  __typename: 'Mutations';
  categoryDelete?: string | null;
};

export type CategoryDropdownQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;

export type CategoryDropdownQuery = {
  __typename: 'Queries';
  collection?: {
    __typename: 'Collection';
    categories: Array<{
      __typename: 'Category';
      id: string;
      isSyncedWithElevio: boolean;
      titles: Array<{
        __typename: 'TranslationTitle';
        title: string;
        languageId: LanguageId;
      }>;
      categories: Array<{
        __typename: 'Category';
        id: string;
        isSyncedWithElevio: boolean;
        titles: Array<{
          __typename: 'TranslationTitle';
          title: string;
          languageId: LanguageId;
        }>;
        categories: Array<{
          __typename: 'Category';
          id: string;
          isSyncedWithElevio: boolean;
          titles: Array<{
            __typename: 'TranslationTitle';
            title: string;
            languageId: LanguageId;
          }>;
          categories: Array<{
            __typename: 'Category';
            id: string;
            isSyncedWithElevio: boolean;
            titles: Array<{
              __typename: 'TranslationTitle';
              title: string;
              languageId: LanguageId;
            }>;
            categories: Array<{
              __typename: 'Category';
              id: string;
              isSyncedWithElevio: boolean;
              titles: Array<{
                __typename: 'TranslationTitle';
                title: string;
                languageId: LanguageId;
              }>;
            }>;
          }>;
        }>;
      }>;
    }>;
  } | null;
};

export type CategoryFieldsFragment = {
  __typename: 'Category';
  id: string;
  isSyncedWithElevio: boolean;
  parent?:
    | { __typename: 'Category'; id: string }
    | { __typename: 'Collection'; id: string }
    | null;
  titles: Array<{
    __typename: 'TranslationTitle';
    title: string;
    languageId: LanguageId;
  }>;
  restrictions: {
    __typename: 'RestrictionsPayload';
    direct: Array<Restriction>;
    inherited?: Array<{
      __typename: 'InheritedRestriction';
      restriction: Restriction;
      from:
        | { __typename: 'Category'; id: string }
        | { __typename: 'Collection'; id: string };
    }> | null;
  };
};

export type CategoryMoveMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  currentParentId: Scalars['ID']['input'];
  newParentId?: InputMaybe<Scalars['ID']['input']>;
  newPosition?: InputMaybe<Scalars['PositiveInt']['input']>;
}>;

export type CategoryMoveMutation = {
  __typename: 'Mutations';
  contentMove?:
    | {
        __typename: 'Category';
        id: string;
        categories: Array<{
          __typename: 'Category';
          id: string;
          parent?:
            | { __typename: 'Category'; id: string }
            | { __typename: 'Collection'; id: string }
            | null;
        }>;
      }
    | {
        __typename: 'Collection';
        id: string;
        categories: Array<{
          __typename: 'Category';
          id: string;
          parent?:
            | { __typename: 'Category'; id: string }
            | { __typename: 'Collection'; id: string }
            | null;
        }>;
      }
    | null;
};

export type CategoryMoveQQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CategoryMoveQQuery = {
  __typename: 'Queries';
  category?: {
    __typename: 'Category';
    id: string;
    parent?:
      | { __typename: 'Category'; id: string }
      | { __typename: 'Collection'; id: string }
      | null;
  } | null;
};

export type CategoryNodeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CategoryNodeQuery = {
  __typename: 'Queries';
  category?: ({ __typename: 'Category' } & CategoryChildFragment) | null;
};

export type CategoryNodeFragment = {
  __typename: 'Category';
  id: string;
  parent?:
    | { __typename: 'Category'; id: string }
    | { __typename: 'Collection'; id: string }
    | null;
  restrictions: {
    __typename: 'RestrictionsPayload';
    direct: Array<Restriction>;
  };
};

export type CategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CategoryQuery = {
  __typename: 'Queries';
  category?: {
    __typename: 'Category';
    id: string;
    isSyncedWithElevio: boolean;
    titles: Array<{
      __typename: 'TranslationTitle';
      languageId: LanguageId;
      title: string;
    }>;
    parent?:
      | { __typename: 'Category'; id: string }
      | { __typename: 'Collection'; id: string }
      | null;
    restrictions: {
      __typename: 'RestrictionsPayload';
      direct: Array<Restriction>;
    };
  } | null;
};

export type CategoryTranslationDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  languageId: LanguageId;
}>;

export type CategoryTranslationDeleteMutation = {
  __typename: 'Mutations';
  categoryTranslationDelete?:
    | ({ __typename: 'Category' } & CategoryFieldsFragment)
    | null;
};

export type CategoryTranslationUpsertMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  languageId: LanguageId;
  title: Scalars['NonEmptyString']['input'];
}>;

export type CategoryTranslationUpsertMutation = {
  __typename: 'Mutations';
  categoryTranslationUpsert?:
    | ({ __typename: 'Category' } & CategoryFieldsFragment)
    | null;
};

export type CategoryUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CategoryUpdateMutation = {
  __typename: 'Mutations';
  categoryUpdate?: ({ __typename: 'Category' } & CategoryFieldsFragment) | null;
};

export type CollectionCreateMutationVariables = Exact<{
  title: Scalars['NonEmptyString']['input'];
  internalKbEnabled: Scalars['Boolean']['input'];
}>;

export type CollectionCreateMutation = {
  __typename: 'Mutations';
  collectionCreate?:
    | ({ __typename: 'Collection' } & CollectionFieldsFragment)
    | null;
};

export type CollectionDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CollectionDeleteMutation = {
  __typename: 'Mutations';
  collectionDelete?: string | null;
};

export type CollectionDetachMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CollectionDetachMutation = {
  __typename: 'Mutations';
  collectionUnlock?:
    | ({ __typename: 'Collection' } & CollectionFieldsFragment)
    | null;
};

export type CollectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CollectionQuery = {
  __typename: 'Queries';
  collection?: ({ __typename: 'Collection' } & CollectionFieldsFragment) | null;
};

export type CollectionFieldsFragment = {
  __typename: 'Collection';
  id: string;
  title: string;
  internalKbEnabled: boolean;
  description?: string | null;
  isSyncedWithElevio: boolean;
  themeColors: { __typename: 'CollectionThemeColors'; icon: string };
  linkedResources: Array<{ __typename: 'Queue'; id: string; name: string }>;
};

export type CollectionStatsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CollectionStatsQuery = {
  __typename: 'Queries';
  collection?: {
    __typename: 'Collection';
    id: string;
    statistics: {
      __typename: 'CollectionStats';
      categoryCount: number;
      articleCount: number;
      queueCount: number;
    };
  } | null;
};

export type CollectionTreeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CollectionTreeQuery = {
  __typename: 'Queries';
  collection?:
    | ({
        __typename: 'Collection';
        categories: Array<
          {
            __typename: 'Category';
            articles: Array<{ __typename: 'Article' } & ArticleFieldsFragment>;
            categories: Array<
              {
                __typename: 'Category';
                articles: Array<
                  { __typename: 'Article' } & ArticleFieldsFragment
                >;
                categories: Array<
                  {
                    __typename: 'Category';
                    articles: Array<
                      { __typename: 'Article' } & ArticleFieldsFragment
                    >;
                    categories: Array<
                      {
                        __typename: 'Category';
                        articles: Array<
                          { __typename: 'Article' } & ArticleFieldsFragment
                        >;
                        categories: Array<
                          {
                            __typename: 'Category';
                            articles: Array<
                              { __typename: 'Article' } & ArticleFieldsFragment
                            >;
                          } & CategoryFieldsFragment
                        >;
                      } & CategoryFieldsFragment
                    >;
                  } & CategoryFieldsFragment
                >;
              } & CategoryFieldsFragment
            >;
          } & CategoryFieldsFragment
        >;
      } & CollectionFieldsFragment)
    | null;
};

export type CollectionUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  externalResources?: InputMaybe<ResourcesUpdateInput>;
  internalKbEnabled: Scalars['Boolean']['input'];
  icon: Scalars['Color']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;

export type CollectionUpdateMutation = {
  __typename: 'Mutations';
  collectionUpdate?:
    | ({ __typename: 'Collection' } & CollectionFieldsFragment)
    | null;
};

export type CollectionsFetchQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Offset']['input']>;
  limit?: InputMaybe<Scalars['Limit']['input']>;
}>;

export type CollectionsFetchQuery = {
  __typename: 'Queries';
  collections: {
    __typename: 'CollectionList';
    results: Array<{
      __typename: 'CollectionListItem';
      id: string;
      title: string;
      internalKbEnabled: boolean;
      isSyncedWithElevio: boolean;
    }>;
  };
  settings: { __typename: 'SettingsPayload' } & SettingsFieldsFragment;
};

export type FileUploadMutationVariables = Exact<{
  fileName: Scalars['NonEmptyString']['input'];
}>;

export type FileUploadMutation = {
  __typename: 'Mutations';
  fileUploadRequest?: {
    __typename: 'PresignedUploadRequest';
    uploadUrl: string;
    method: HttpMethod;
    contentType: string;
    customHeaders: Array<string>;
    expiresAt: number;
    filename: string;
    availableAt: string;
  } | null;
};

export type LanguageFieldsFragment = {
  __typename: 'Language';
  languageId: LanguageId;
  description: string;
  nativeDescription: string;
};

export type OptimisticArticleParentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type OptimisticArticleParentQuery = {
  __typename: 'Queries';
  category?: {
    __typename: 'Category';
    id: string;
    articles: Array<{ __typename: 'Article'; id: string }>;
  } | null;
};

export type OptimisticCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type OptimisticCategoryQuery = {
  __typename: 'Queries';
  category?: {
    __typename: 'Category';
    id: string;
    categories: Array<{
      __typename: 'Category';
      id: string;
      parent?:
        | { __typename: 'Category'; id: string }
        | { __typename: 'Collection'; id: string }
        | null;
    }>;
  } | null;
};

export type OptimisticCollectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type OptimisticCollectionQuery = {
  __typename: 'Queries';
  collection?: {
    __typename: 'Collection';
    id: string;
    categories: Array<{
      __typename: 'Category';
      id: string;
      parent?:
        | { __typename: 'Category'; id: string }
        | { __typename: 'Collection'; id: string }
        | null;
    }>;
  } | null;
};

export type OrganizationEnableLanguagesMutationVariables = Exact<{
  languageIds: Array<LanguageId> | LanguageId;
}>;

export type OrganizationEnableLanguagesMutation = {
  __typename: 'Mutations';
  organisationEnableLanguages: {
    __typename: 'OrganisationSettingsPayload';
  } & ManagementOrganizationSettingsFragment;
};

export type OrganizationRemoveLanguageMutationVariables = Exact<{
  languageId: LanguageId;
}>;

export type OrganizationRemoveLanguageMutation = {
  __typename: 'Mutations';
  organisationDisableLanguage: {
    __typename: 'OrganisationSettingsPayload';
  } & ManagementOrganizationSettingsFragment;
};

export type OrganizationSetDefaultLanguageMutationVariables = Exact<{
  languageId: LanguageId;
}>;

export type OrganizationSetDefaultLanguageMutation = {
  __typename: 'Mutations';
  organisationSetDefaultLanguage: {
    __typename: 'OrganisationSettingsPayload';
  } & ManagementOrganizationSettingsFragment;
};

export type ManagementOrganizationSettingsFragment = {
  __typename: 'OrganisationSettingsPayload';
  availableLanguages: Array<
    { __typename: 'Language' } & LanguageFieldsFragment
  >;
  defaultLanguage: { __typename: 'Language' } & LanguageFieldsFragment;
  enabledLanguages: Array<{ __typename: 'Language' } & LanguageFieldsFragment>;
};

export type OrganizationSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type OrganizationSettingsQuery = {
  __typename: 'Queries';
  organisationSettings: {
    __typename: 'OrganisationSettingsPayload';
  } & ManagementOrganizationSettingsFragment;
};

export type OwnersQueryVariables = Exact<{ [key: string]: never }>;

export type OwnersQuery = {
  __typename: 'Queries';
  articles: {
    __typename: 'ArticleList';
    owners: Array<{
      __typename: 'User';
      id: string;
      name?: string | null;
      avatarUrl?: string | null;
      fullName?: {
        __typename: 'FullName';
        givenName?: string | null;
        middleNames?: Array<string> | null;
        familyName?: string | null;
      } | null;
    }>;
  };
};

export type ParentAddChildMutationVariables = Exact<{
  childId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
}>;

export type ParentAddChildMutation = {
  __typename: 'Mutations';
  parentAddChild?:
    | { __typename: 'Category'; id: string }
    | { __typename: 'Collection'; id: string }
    | null;
};

export type SettingsFieldsFragment = {
  __typename: 'SettingsPayload';
  isOrganisationSetup: boolean;
  canCreateCollections: boolean;
};

export type SettingsQueryVariables = Exact<{ [key: string]: never }>;

export type SettingsQuery = {
  __typename: 'Queries';
  settings: { __typename: 'SettingsPayload' } & SettingsFieldsFragment;
};

export type SetupOrganisationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type SetupOrganisationMutation = {
  __typename: 'Mutations';
  setupOrganisation?: {
    __typename: 'Collection';
    id: string;
    title: string;
  } | null;
};

export type AiDraftByCsidQueryVariables = Exact<{
  csid: Scalars['Long']['input'];
}>;

export type AiDraftByCsidQuery = {
  __typename: 'Queries';
  aiDraftByCsid?: ({ __typename: 'AiDraft' } & AiDraftListItemFragment) | null;
};

export type AiDraftDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type AiDraftDeleteMutation = {
  __typename: 'Mutations';
  aiDraftDelete?: string | null;
};

export type AiDraftGenerateMutationVariables = Exact<{
  csid: Scalars['Long']['input'];
  languageId: LanguageId;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AiDraftGenerateMutation = {
  __typename: 'Mutations';
  aiDraftGenerate?:
    | ({ __typename: 'AiDraft' } & AiDraftListItemFragment)
    | null;
};

export type AiDraftLiveUpdateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type AiDraftLiveUpdateQuery = {
  __typename: 'Queries';
  aiDraft?:
    | ({
        __typename: 'AiDraft';
        approvedAt?: number | null;
        rejectedAt?: number | null;
      } & AiDraftListItemFragment)
    | null;
};

export type AiSettingsAccessQueryVariables = Exact<{ [key: string]: never }>;

export type AiSettingsAccessQuery = {
  __typename: 'Queries';
  settings: {
    __typename: 'SettingsPayload';
    userPermissions: {
      __typename: 'UserPermissionsSettings';
      languageSettings: AccessLevel;
    };
  };
};

export type AiSettingsDraftUpdateMutationVariables = Exact<{
  judgeInstructions?: InputMaybe<Scalars['String']['input']>;
  writerInstructions?: InputMaybe<Scalars['String']['input']>;
  minSimilarConversations: Scalars['Int']['input'];
  similarity: SimilarityLevel;
}>;

export type AiSettingsDraftUpdateMutation = {
  __typename: 'Mutations';
  organisationUpdateAiSettingsDraft?:
    | ({ __typename: 'AiSettingsVersionPayload' } & AiSettingsVersionFragment)
    | null;
};

export type AiSettingsVersionActivateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type AiSettingsVersionActivateMutation = {
  __typename: 'Mutations';
  organisationActivateAiSettingsVersion?:
    | ({ __typename: 'AiSettingsVersionPayload' } & AiSettingsVersionFragment)
    | null;
};

export type AiSettingsVersionCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  activate: Scalars['Boolean']['input'];
}>;

export type AiSettingsVersionCreateMutation = {
  __typename: 'Mutations';
  organisationCreateAiSettingsVersion?:
    | ({ __typename: 'AiSettingsVersionPayload' } & AiSettingsVersionFragment)
    | null;
};

export type AiSettingsVersionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AiSettingsVersionQuery = {
  __typename: 'Queries';
  aiSettingsVersion?:
    | ({ __typename: 'AiSettingsVersionPayload' } & AiSettingsVersionFragment)
    | null;
};

export type AiSettingsVersionFragment = {
  __typename: 'AiSettingsVersionPayload';
  id?: string | null;
  version?: number | null;
  name?: string | null;
  isDraft: boolean;
  isActive: boolean;
  createdAt?: number | null;
  settings: {
    __typename: 'AiSettingsPayload';
    judgeInstructions?: string | null;
    writerInstructions?: string | null;
    similarity: SimilarityLevel;
    minSimilarConversations: number;
  };
};

export type AiSettingsVersionRenameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;

export type AiSettingsVersionRenameMutation = {
  __typename: 'Mutations';
  organisationRenameAiSettingsVersion?:
    | ({ __typename: 'AiSettingsVersionPayload' } & AiSettingsVersionFragment)
    | null;
};

export type AiSettingsVersionsQueryVariables = Exact<{ [key: string]: never }>;

export type AiSettingsVersionsQuery = {
  __typename: 'Queries';
  aiSettingsVersions?: Array<{
    __typename: 'AiSettingsVersionSummaryPayload';
    id: string;
    version: number;
    name: string;
    isActive: boolean;
    createdAt: number;
  }> | null;
};

export type ArticleEditorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ArticleEditorQuery = {
  __typename: 'Queries';
  article?: ({ __typename: 'Article' } & ArticleFullFieldsFragment) | null;
};

export type ArticleFullFieldsFragment = {
  __typename: 'Article';
  id: string;
  aiAssisted: boolean;
  createdAt: number;
  updatedAt: number;
  indexedAt?: number | null;
  isSyncedWithElevio: boolean;
  createdBy?: {
    __typename: 'User';
    name?: string | null;
    email?: string | null;
  } | null;
  updatedBy?: {
    __typename: 'User';
    name?: string | null;
    email?: string | null;
  } | null;
  indexedBy?: {
    __typename: 'User';
    name?: string | null;
    email?: string | null;
  } | null;
  parent?:
    | {
        __typename: 'Category';
        id: string;
        titles: Array<{
          __typename: 'TranslationTitle';
          title: string;
          languageId: LanguageId;
        }>;
      }
    | { __typename: 'Collection'; id: string }
    | null;
  tags: Array<{
    __typename: 'Tag';
    id: string;
    name: string;
    color?: string | null;
    type: TagType;
    isDeactivated: boolean;
  }>;
  titles: Array<{
    __typename: 'TranslationTitle';
    title: string;
    languageId: LanguageId;
  }>;
  translations: {
    __typename: 'TranslationListQuery';
    draft: Array<{
      __typename: 'ArticleTranslation';
      languageId: LanguageId;
      articleId: string;
      title: string;
      publicationStatus: PublicationStatus;
      version: { __typename: 'Draft' } | { __typename: 'Indexed' };
    }>;
  };
  parentCollections: Array<{
    __typename: 'Collection';
    id: string;
    title: string;
  }>;
};

export type ArticleHasChangesQueryVariables = Exact<{
  articleId: Scalars['ID']['input'];
}>;

export type ArticleHasChangesQuery = {
  __typename: 'Queries';
  article?: {
    __typename: 'Article';
    id: string;
    translations: {
      __typename: 'TranslationListQuery';
      draft: Array<{
        __typename: 'ArticleTranslation';
        articleId: string;
        languageId: LanguageId;
        publicationStatus: PublicationStatus;
      }>;
    };
  } | null;
};

export type ArticleLinkLookupQueryVariables = Exact<{
  languageId: LanguageId;
  filters?: InputMaybe<ArticleFiltersInput>;
  query?: InputMaybe<ArticleSearchInput>;
}>;

export type ArticleLinkLookupQuery = {
  __typename: 'Queries';
  articles: {
    __typename: 'ArticleList';
    query: {
      __typename: 'ArticleQueryPayload';
      results: Array<{
        __typename: 'ArticleListItem';
        id: string;
        title?: string | null;
        parentCategories: Array<{
          __typename: 'CategoryListItem';
          id: string;
          title?: string | null;
        }>;
      }>;
    };
  };
};

export type ArticlePublishMutationVariables = Exact<{
  articleId: Scalars['ID']['input'];
}>;

export type ArticlePublishMutation = {
  __typename: 'Mutations';
  articlePublish?:
    | ({ __typename: 'Article' } & ArticleFullFieldsFragment)
    | null;
};

export type ArticleTranslationDeleteMutationVariables = Exact<{
  articleId: Scalars['ID']['input'];
  languageId: LanguageId;
}>;

export type ArticleTranslationDeleteMutation = {
  __typename: 'Mutations';
  articleTranslationDelete?: string | null;
};

export type ArticleTranslationDraftCreateMutationVariables = Exact<{
  articleId: Scalars['ID']['input'];
  languageId: LanguageId;
  title: Scalars['NonEmptyString']['input'];
  content: Scalars['ContentJson']['input'];
}>;

export type ArticleTranslationDraftCreateMutation = {
  __typename: 'Mutations';
  articleTranslationCreate?:
    | ({ __typename: 'ArticleTranslation' } & ArticleTranslationFieldsFragment)
    | null;
};

export type ArticleTranslationDraftUpdateMutationVariables = Exact<{
  articleId: Scalars['ID']['input'];
  languageId: LanguageId;
  title: Scalars['NonEmptyString']['input'];
  content: Scalars['ContentJson']['input'];
  titleUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  titleTranslatedAt?: InputMaybe<Scalars['String']['input']>;
}>;

export type ArticleTranslationDraftUpdateMutation = {
  __typename: 'Mutations';
  articleTranslationUpdate?:
    | ({ __typename: 'ArticleTranslation' } & ArticleTranslationFieldsFragment)
    | null;
};

export type ArticleTranslationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  languageId: LanguageId;
}>;

export type ArticleTranslationQuery = {
  __typename: 'Queries';
  articleTranslation?: {
    __typename: 'TranslationQuery';
    articleId: string;
    publicationStatus: PublicationStatus;
    draft: {
      __typename: 'ArticleTranslation';
    } & ArticleTranslationFieldsFragment;
  } | null;
};

export type ArticleTranslationFieldsFragment = {
  __typename: 'ArticleTranslation';
  articleId: string;
  languageId: LanguageId;
  title: string;
  aiAssisted?: boolean | null;
  titleTranslatedAt?: string | null;
  titleUpdatedAt?: string | null;
  content: ArticleStructure | null;
  updatedAt: number;
  publicationStatus: PublicationStatus;
  version: { __typename: 'Draft' } | { __typename: 'Indexed' };
  updatedBy?: {
    __typename: 'User';
    name?: string | null;
    email?: string | null;
  } | null;
};

export type ArticleTranslationPublishMutationVariables = Exact<{
  articleId: Scalars['ID']['input'];
  languageId: LanguageId;
}>;

export type ArticleTranslationPublishMutation = {
  __typename: 'Mutations';
  articleTranslationPublish?: string | null;
};

export type ArticleTranslationRevertDraftMutationVariables = Exact<{
  articleId: Scalars['ID']['input'];
  languageId: LanguageId;
  version?: InputMaybe<Scalars['PositiveInt']['input']>;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ArticleTranslationRevertDraftMutation = {
  __typename: 'Mutations';
  articleTranslationRevertDraft?:
    | ({ __typename: 'ArticleTranslation' } & ArticleTranslationFieldsFragment)
    | null;
};

export type ArticleTranslationUnpublishMutationVariables = Exact<{
  articleId: Scalars['ID']['input'];
  languageId: LanguageId;
}>;

export type ArticleTranslationUnpublishMutation = {
  __typename: 'Mutations';
  articleTranslationUnpublish?: string | null;
};

export type ArticleTranslationVersionQueryVariables = Exact<{
  articleId: Scalars['ID']['input'];
  languageId: LanguageId;
  versionNumber: Scalars['PositiveInt']['input'];
}>;

export type ArticleTranslationVersionQuery = {
  __typename: 'Queries';
  article?: {
    __typename: 'Article';
    translation?: {
      __typename: 'TranslationQuery';
      version?: {
        __typename: 'ArticleTranslation';
        articleId: string;
        languageId: LanguageId;
        title: string;
        content: ArticleStructure | null;
        version: { __typename: 'Draft' } | { __typename: 'Indexed' };
      } | null;
    } | null;
  } | null;
};

export type ArticleTranslationVersionsQueryVariables = Exact<{
  articleId: Scalars['ID']['input'];
  languageId: LanguageId;
}>;

export type ArticleTranslationVersionsQuery = {
  __typename: 'Queries';
  article?: {
    __typename: 'Article';
    translations: {
      __typename: 'TranslationListQuery';
      versions: Array<{
        __typename: 'TranslationVersionSummaryPayload';
        publishedAt: number;
        title: string;
        isCurrentlyIndexed: boolean;
        aiAssisted?: boolean | null;
        referencedConversationIds?: Array<number> | null;
        publishedBy?: { __typename: 'User'; name?: string | null } | null;
        version:
          | { __typename: 'Draft' }
          | { __typename: 'Indexed'; versionNumber: number };
      }>;
    };
  } | null;
};

export type ArticleUnpublishMutationVariables = Exact<{
  articleId: Scalars['ID']['input'];
}>;

export type ArticleUnpublishMutation = {
  __typename: 'Mutations';
  articleUnpublish?:
    | ({ __typename: 'Article' } & ArticleFullFieldsFragment)
    | null;
};

export type ArticleUpdateMutationVariables = Exact<{
  articleId: Scalars['ID']['input'];
  tags?: InputMaybe<TagsInput>;
}>;

export type ArticleUpdateMutation = {
  __typename: 'Mutations';
  articleUpdate?:
    | ({ __typename: 'Article' } & ArticleFullFieldsFragment)
    | null;
};

export type HelpCenterAddCompanyLogoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  logo: Scalars['String']['input'];
}>;

export type HelpCenterAddCompanyLogoMutation = {
  __typename: 'Mutations';
  helpCenterUpdate?: {
    __typename: 'HelpCenter';
    id: string;
    logo?: {
      __typename: 'File';
      filename: string;
      fileType: FileType;
      availableAt: string;
      size: number;
      uploadedAt: number;
      originalFileName?: string | null;
    } | null;
  } | null;
};

export type HelpCenterAddFaviconMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  favicon: Scalars['String']['input'];
}>;

export type HelpCenterAddFaviconMutation = {
  __typename: 'Mutations';
  helpCenterUpdate?: {
    __typename: 'HelpCenter';
    id: string;
    favicon?: {
      __typename: 'File';
      filename: string;
      fileType: FileType;
      availableAt: string;
      size: number;
      uploadedAt: number;
      originalFileName?: string | null;
    } | null;
  } | null;
};

export type HelpCenterCreateMutationVariables = Exact<{
  subdomain: Scalars['String']['input'];
  translations: Array<HelpCenterTranslationInput> | HelpCenterTranslationInput;
  name: Scalars['NonEmptyString']['input'];
  collectionId: Scalars['ID']['input'];
  defaultLanguageId: LanguageId;
  isHelpCenterIndexable: Scalars['Boolean']['input'];
}>;

export type HelpCenterCreateMutation = {
  __typename: 'Mutations';
  helpCenterCreate?: {
    __typename: 'HelpCenter';
    id: string;
    name: string;
    subdomain: string;
    hostname: string;
    isHelpCenterIndexable: boolean;
    isActive: boolean;
    translation?: {
      __typename: 'HelpCenterTranslation';
      languageId: LanguageId;
      title?: string | null;
      tagline?: string | null;
    } | null;
    customHostname?: { __typename: 'CustomHostname'; hostname: string } | null;
    collection?: { __typename: 'Collection'; id: string; title: string } | null;
    favicon?: {
      __typename: 'File';
      filename: string;
      fileType: FileType;
      availableAt: string;
    } | null;
    logo?: {
      __typename: 'File';
      filename: string;
      fileType: FileType;
      availableAt: string;
    } | null;
  } | null;
};

export type HelpCenterCustomHostnameFetchQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type HelpCenterCustomHostnameFetchQuery = {
  __typename: 'Queries';
  helpCenter?:
    | ({ __typename: 'HelpCenter' } & HelpCenterCustomHostnameFragment)
    | null;
};

export type HelpCenterCustomHostnameFragment = {
  __typename: 'HelpCenter';
  id: string;
  customHostname?: {
    __typename: 'CustomHostname';
    hostname: string;
    records?: {
      __typename: 'HostnameRecords';
      cname: {
        __typename: 'CnameStatus';
        status: VerificationStatus;
        verificationErrors?: Array<string> | null;
        record?: {
          __typename: 'CnameRecord';
          aliasOf: string;
          hostname: string;
        } | null;
      };
      ssl: {
        __typename: 'SslStatus';
        status: VerificationStatus;
        records: Array<{
          __typename: 'SslTxtRecord';
          name: string;
          value: string;
        }>;
      };
    } | null;
  } | null;
};

export type HelpCenterCustomizationDeleteFaviconMutationVariables = Exact<{
  helpCenterId: Scalars['ID']['input'];
}>;

export type HelpCenterCustomizationDeleteFaviconMutation = {
  __typename: 'Mutations';
  helpCenterUpdate?: {
    __typename: 'HelpCenter';
    favicon?: {
      __typename: 'File';
      availableAt: string;
      filename: string;
    } | null;
  } | null;
};

export type HelpCenterCustomizationDeleteLogoMutationVariables = Exact<{
  helpCenterId: Scalars['ID']['input'];
}>;

export type HelpCenterCustomizationDeleteLogoMutation = {
  __typename: 'Mutations';
  helpCenterUpdate?: {
    __typename: 'HelpCenter';
    logo?: { __typename: 'File'; availableAt: string; filename: string } | null;
  } | null;
};

export type HelpCenterDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  deregisterCustomHostname?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type HelpCenterDeleteMutation = {
  __typename: 'Mutations';
  helpCenterDelete?: string | null;
};

export type HelpCenterDeregisterHostnameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type HelpCenterDeregisterHostnameMutation = {
  __typename: 'Mutations';
  helpCenterDeregisterHostname?:
    | ({ __typename: 'HelpCenter' } & HelpCenterCustomHostnameFragment)
    | null;
};

export type HelpCenterFetchQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type HelpCenterFetchQuery = {
  __typename: 'Queries';
  helpCenter?: ({ __typename: 'HelpCenter' } & HelpCenterFragment) | null;
};

export type HelpCenterFragment = {
  __typename: 'HelpCenter';
  id: string;
  name: string;
  subdomain: string;
  hostname: string;
  isHelpCenterIndexable: boolean;
  isActive: boolean;
  companyUrl?: string | null;
  collection?: { __typename: 'Collection'; id: string } | null;
  favicon?: {
    __typename: 'File';
    availableAt: string;
    filename: string;
    fileType: FileType;
    size: number;
    uploadedAt: number;
    originalFileName?: string | null;
  } | null;
  logo?: {
    __typename: 'File';
    filename: string;
    fileType: FileType;
    availableAt: string;
    size: number;
    uploadedAt: number;
    originalFileName?: string | null;
  } | null;
  translations: Array<{
    __typename: 'HelpCenterTranslation';
    languageId: LanguageId;
    title?: string | null;
    tagline?: string | null;
  }>;
  theme: {
    __typename: 'HelpCenterTheme';
    id: string;
    colors: {
      __typename: 'HelpCenterThemeColors';
      websiteBackground: string;
      pageBackground: string;
      text: string;
      link: string;
      accent: string;
      accentText: string;
    };
  };
  themeCustomization: {
    __typename: 'HelpCenterThemeCustomization';
    headerHtml: {
      __typename: 'ThemeCustomizationField';
      value?: string | null;
      enabled: boolean;
    };
    footerHtml: {
      __typename: 'ThemeCustomizationField';
      value?: string | null;
      enabled: boolean;
    };
    css: {
      __typename: 'ThemeCustomizationField';
      value?: string | null;
      enabled: boolean;
    };
    js: {
      __typename: 'ThemeCustomizationField';
      value?: string | null;
      enabled: boolean;
    };
  };
  enabledLanguages: Array<{ __typename: 'Language'; languageId: LanguageId }>;
  defaultLanguage: {
    __typename: 'Language';
    languageId: LanguageId;
    description: string;
  };
};

export type HelpCenterRegisterHostnameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  customHostname: Scalars['String']['input'];
}>;

export type HelpCenterRegisterHostnameMutation = {
  __typename: 'Mutations';
  helpCenterRegisterHostname?:
    | ({ __typename: 'HelpCenter' } & HelpCenterCustomHostnameFragment)
    | null;
};

export type HelpCenterUpdateAdvancedCustomizationMutationVariables = Exact<{
  helpCenterId: Scalars['ID']['input'];
  themeCustomization: HelpCenterThemeCustomizationInput;
}>;

export type HelpCenterUpdateAdvancedCustomizationMutation = {
  __typename: 'Mutations';
  helpCenterUpdate?: {
    __typename: 'HelpCenter';
    id: string;
    themeCustomization: {
      __typename: 'HelpCenterThemeCustomization';
      headerHtml: {
        __typename: 'ThemeCustomizationField';
        value?: string | null;
        enabled: boolean;
      };
      footerHtml: {
        __typename: 'ThemeCustomizationField';
        value?: string | null;
        enabled: boolean;
      };
      css: {
        __typename: 'ThemeCustomizationField';
        value?: string | null;
        enabled: boolean;
      };
      js: {
        __typename: 'ThemeCustomizationField';
        value?: string | null;
        enabled: boolean;
      };
    };
  } | null;
};

export type HelpCenterUpdateCustomizationMutationVariables = Exact<{
  helpCenterId: Scalars['ID']['input'];
  themeId: Scalars['ID']['input'];
  colors: HelpCenterThemeColorsUpdateInput;
  companyUrl: Scalars['URL']['input'];
}>;

export type HelpCenterUpdateCustomizationMutation = {
  __typename: 'Mutations';
  helpCenterUpdate?: ({ __typename: 'HelpCenter' } & HelpCenterFragment) | null;
  helpCenterThemeUpdate?: {
    __typename: 'HelpCenterTheme';
    id: string;
    name: string;
    colors: {
      __typename: 'HelpCenterThemeColors';
      websiteBackground: string;
      pageBackground: string;
      text: string;
      link: string;
      accent: string;
      accentText: string;
    };
  } | null;
};

export type HelpCenterUpdateCustomizationTranslationsMutationVariables = Exact<{
  helpCenterId: Scalars['ID']['input'];
  translation: HelpCenterTranslationInput;
}>;

export type HelpCenterUpdateCustomizationTranslationsMutation = {
  __typename: 'Mutations';
  helpCenterUpdate?: ({ __typename: 'HelpCenter' } & HelpCenterFragment) | null;
};

export type HelpCenterUpdateSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  subdomain?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  active: Scalars['Boolean']['input'];
  name: Scalars['NonEmptyString']['input'];
  isHelpCenterIndexable: Scalars['Boolean']['input'];
  enableLanguages?: InputMaybe<Array<LanguageId> | LanguageId>;
  disableLanguages?: InputMaybe<Array<LanguageId> | LanguageId>;
  defaultLanguage?: InputMaybe<LanguageId>;
}>;

export type HelpCenterUpdateSettingsMutation = {
  __typename: 'Mutations';
  helpCenterUpdate?: ({ __typename: 'HelpCenter' } & HelpCenterFragment) | null;
};

export type HelpCentersQueryVariables = Exact<{ [key: string]: never }>;

export type HelpCentersQuery = {
  __typename: 'Queries';
  helpCenters: {
    __typename: 'HelpCenterList';
    results: Array<{
      __typename: 'HelpCenter';
      id: string;
      name: string;
      hostname: string;
      isActive: boolean;
      customHostname?: {
        __typename: 'CustomHostname';
        hostname: string;
      } | null;
      collection?: {
        __typename: 'Collection';
        id: string;
        title: string;
      } | null;
    }>;
  };
};

export type SubdomainAvailabilityQueryVariables = Exact<{
  subdomain: Scalars['String']['input'];
}>;

export type SubdomainAvailabilityQuery = {
  __typename: 'Queries';
  subdomainAvailability?: {
    __typename: 'SubdomainAvailability';
    isAvailable: boolean;
    reason?: AvailabilityReason | null;
  } | null;
};

export type CategoryTitlesFragment = {
  __typename: 'Category';
  id: string;
  titles: Array<{
    __typename: 'TranslationTitle';
    title: string;
    languageId: LanguageId;
  }>;
};

export const AiDraftListItemFragmentDoc = gql`
  fragment AiDraftListItem on AiDraft {
    __typename
    id
    title
    type
    languageId
    createdAt
    modifiedAt
    initiatedFromConversation
    referencedConversationIds
    collectionId
    categoryId
    possibleCollectionIds
    forArticleId
    initiatedBy {
      id
      name
      email
      avatarUrl
    }
    summary
    htmlContent
  }
`;
export const ArticleNodeFragmentDoc = gql`
  fragment ArticleNode on Article {
    id
    parent {
      id
    }
    titles {
      title
      languageId
    }
  }
`;
export const ArticleListItemNodeFragmentDoc = gql`
  fragment ArticleListItemNode on ArticleListItem {
    id
    parentCategories {
      id
    }
    titles {
      title
      languageId
    }
  }
`;
export const ArticleListItemResultFragmentDoc = gql`
  fragment ArticleListItemResult on ArticleListItem {
    __typename
    id
    isSyncedWithElevio: isLocked
    title(languageId: $languageId)
    titles {
      languageId
      title
    }
    publicationStatus(languageId: $languageId)
    parentCollections {
      id
      internalKbEnabled
      title
      linkedResources {
        id
        name
        ... on Queue {
          id
          name
        }
      }
    }
    createdAt
    updatedAt
    createdBy {
      name
      deactivated
    }
    updatedBy {
      name
      deactivated
    }
    parentCategories {
      id
      title(languageId: $languageId)
      parentCollections {
        id
        title
      }
    }
  }
`;
export const CategoryFieldsFragmentDoc = gql`
  fragment CategoryFields on Category {
    id
    parent {
      id
    }
    titles {
      title
      languageId
    }
    restrictions {
      direct
      inherited {
        restriction
        from {
          id
        }
      }
    }
    isSyncedWithElevio: isLocked
  }
`;
export const ArticleFieldsFragmentDoc = gql`
  fragment ArticleFields on Article {
    id
    isSyncedWithElevio: isLocked
    updatedAt
    indexedAt
    parent {
      id
    }
    titles {
      title
      languageId
    }
    restrictions {
      direct
      inherited {
        restriction
        from {
          id
        }
      }
    }
  }
`;
export const CategoryChildFragmentDoc = gql`
  fragment CategoryChild on Category {
    ...CategoryFields
    articles {
      ...ArticleFields
    }
    categories {
      ...CategoryFields
    }
  }
  ${CategoryFieldsFragmentDoc}
  ${ArticleFieldsFragmentDoc}
`;
export const CategoryNodeFragmentDoc = gql`
  fragment CategoryNode on Category {
    id
    parent {
      id
    }
    restrictions {
      direct
    }
  }
`;
export const CollectionFieldsFragmentDoc = gql`
  fragment CollectionFields on Collection {
    id
    title
    internalKbEnabled
    isSyncedWithElevio: isLocked
    description
    themeColors {
      icon
    }
    linkedResources {
      id
      name
      ... on Queue {
        id
        name
      }
    }
  }
`;
export const LanguageFieldsFragmentDoc = gql`
  fragment LanguageFields on Language {
    languageId
    description
    nativeDescription
  }
`;
export const ManagementOrganizationSettingsFragmentDoc = gql`
  fragment ManagementOrganizationSettings on OrganisationSettingsPayload {
    availableLanguages {
      ...LanguageFields
    }
    defaultLanguage {
      ...LanguageFields
    }
    enabledLanguages {
      ...LanguageFields
    }
  }
  ${LanguageFieldsFragmentDoc}
`;
export const SettingsFieldsFragmentDoc = gql`
  fragment SettingsFields on SettingsPayload {
    isOrganisationSetup
    canCreateCollections
  }
`;
export const AiSettingsVersionFragmentDoc = gql`
  fragment AiSettingsVersion on AiSettingsVersionPayload {
    id
    version
    name
    isDraft
    isActive
    createdAt
    settings {
      judgeInstructions
      writerInstructions
      similarity
      minSimilarConversations
    }
  }
`;
export const ArticleFullFieldsFragmentDoc = gql`
  fragment ArticleFullFields on Article {
    id
    aiAssisted
    createdAt
    createdBy {
      name
      email
    }
    updatedAt
    updatedBy {
      name
      email
    }
    indexedAt
    indexedBy {
      name
      email
    }
    parent {
      id
      ... on Category {
        titles {
          title
          languageId
        }
      }
    }
    tags {
      id
      name
      color
      type
      isDeactivated
    }
    isSyncedWithElevio: isLocked
    titles {
      title
      languageId
    }
    translations {
      draft {
        languageId
        articleId
        title
        publicationStatus
        version {
          __typename
        }
      }
    }
    parentCollections {
      id
      title
    }
  }
`;
export const ArticleTranslationFieldsFragmentDoc = gql`
  fragment ArticleTranslationFields on ArticleTranslation {
    articleId
    languageId
    version {
      __typename
    }
    title
    aiAssisted
    titleTranslatedAt
    titleUpdatedAt
    content
    updatedAt
    updatedBy {
      name
      email
    }
    publicationStatus
  }
`;
export const HelpCenterCustomHostnameFragmentDoc = gql`
  fragment HelpCenterCustomHostname on HelpCenter {
    id
    customHostname {
      hostname
      records {
        cname {
          record {
            aliasOf
            hostname
          }
          status
          verificationErrors
        }
        ssl {
          records {
            name
            value
          }
          status
        }
      }
    }
  }
`;
export const HelpCenterFragmentDoc = gql`
  fragment HelpCenter on HelpCenter {
    id
    name
    subdomain
    hostname
    isHelpCenterIndexable
    collection {
      id
    }
    isActive
    favicon {
      availableAt
    }
    logo {
      filename
      fileType
      availableAt
      size
      uploadedAt
      originalFileName
    }
    companyUrl
    favicon {
      filename
      fileType
      availableAt
      size
      uploadedAt
      originalFileName
    }
    translations {
      languageId
      title
      tagline
    }
    theme {
      id
      colors {
        websiteBackground
        pageBackground
        text
        link
        accent
        accentText
      }
    }
    themeCustomization {
      headerHtml {
        value
        enabled
      }
      footerHtml {
        value
        enabled
      }
      css {
        value
        enabled
      }
      js {
        value
        enabled
      }
    }
    enabledLanguages {
      languageId
    }
    defaultLanguage {
      languageId
      description
    }
  }
`;
export const CategoryTitlesFragmentDoc = gql`
  fragment CategoryTitles on Category {
    id
    titles {
      title
      languageId
    }
  }
`;
export const AiDraftApproveDocument = gql`
  mutation AiDraftApprove($id: ID!, $alsoPublish: Boolean!) {
    aiDraftApprove(id: $id, alsoPublish: $alsoPublish) {
      id
    }
  }
`;
export type AiDraftApproveMutationFn = Apollo.MutationFunction<
  AiDraftApproveMutation,
  AiDraftApproveMutationVariables
>;

/**
 * __useAiDraftApproveMutation__
 *
 * To run a mutation, you first call `useAiDraftApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiDraftApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiDraftApproveMutation, { data, loading, error }] = useAiDraftApproveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      alsoPublish: // value for 'alsoPublish'
 *   },
 * });
 */
export function useAiDraftApproveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AiDraftApproveMutation,
    AiDraftApproveMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AiDraftApproveMutation,
    AiDraftApproveMutationVariables
  >(AiDraftApproveDocument, options);
}
export type AiDraftApproveMutationHookResult = ReturnType<
  typeof useAiDraftApproveMutation
>;
export type AiDraftApproveMutationResult =
  Apollo.MutationResult<AiDraftApproveMutation>;
export type AiDraftApproveMutationOptions = Apollo.BaseMutationOptions<
  AiDraftApproveMutation,
  AiDraftApproveMutationVariables
>;
export const AiDraftDocument = gql`
  query AiDraft($id: ID!) {
    aiDraft(id: $id) {
      ...AiDraftListItem
    }
  }
  ${AiDraftListItemFragmentDoc}
`;

/**
 * __useAiDraftQuery__
 *
 * To run a query within a React component, call `useAiDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDraftQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiDraftQuery(
  baseOptions: Apollo.QueryHookOptions<AiDraftQuery, AiDraftQueryVariables> &
    ({ variables: AiDraftQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiDraftQuery, AiDraftQueryVariables>(
    AiDraftDocument,
    options,
  );
}
export function useAiDraftLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiDraftQuery,
    AiDraftQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AiDraftQuery, AiDraftQueryVariables>(
    AiDraftDocument,
    options,
  );
}
// @ts-ignore
export function useAiDraftSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiDraftQuery,
    AiDraftQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AiDraftQuery, AiDraftQueryVariables>;
export function useAiDraftSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AiDraftQuery, AiDraftQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AiDraftQuery | undefined,
  AiDraftQueryVariables
>;
export function useAiDraftSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AiDraftQuery, AiDraftQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AiDraftQuery, AiDraftQueryVariables>(
    AiDraftDocument,
    options,
  );
}
export type AiDraftQueryHookResult = ReturnType<typeof useAiDraftQuery>;
export type AiDraftLazyQueryHookResult = ReturnType<typeof useAiDraftLazyQuery>;
export type AiDraftSuspenseQueryHookResult = ReturnType<
  typeof useAiDraftSuspenseQuery
>;
export type AiDraftQueryResult = Apollo.QueryResult<
  AiDraftQuery,
  AiDraftQueryVariables
>;
export const AiDraftRejectDocument = gql`
  mutation AiDraftReject($id: ID!) {
    aiDraftReject(id: $id) {
      id
    }
  }
`;
export type AiDraftRejectMutationFn = Apollo.MutationFunction<
  AiDraftRejectMutation,
  AiDraftRejectMutationVariables
>;

/**
 * __useAiDraftRejectMutation__
 *
 * To run a mutation, you first call `useAiDraftRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiDraftRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiDraftRejectMutation, { data, loading, error }] = useAiDraftRejectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiDraftRejectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AiDraftRejectMutation,
    AiDraftRejectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AiDraftRejectMutation,
    AiDraftRejectMutationVariables
  >(AiDraftRejectDocument, options);
}
export type AiDraftRejectMutationHookResult = ReturnType<
  typeof useAiDraftRejectMutation
>;
export type AiDraftRejectMutationResult =
  Apollo.MutationResult<AiDraftRejectMutation>;
export type AiDraftRejectMutationOptions = Apollo.BaseMutationOptions<
  AiDraftRejectMutation,
  AiDraftRejectMutationVariables
>;
export const AiDraftUpdateDocument = gql`
  mutation AiDraftUpdate(
    $id: ID!
    $feedback: NonEmptyString
    $collectionId: ID
    $categoryId: ID
  ) {
    aiDraftUpdate(
      id: $id
      feedback: $feedback
      collectionId: $collectionId
      categoryId: $categoryId
    ) {
      ...AiDraftListItem
    }
  }
  ${AiDraftListItemFragmentDoc}
`;
export type AiDraftUpdateMutationFn = Apollo.MutationFunction<
  AiDraftUpdateMutation,
  AiDraftUpdateMutationVariables
>;

/**
 * __useAiDraftUpdateMutation__
 *
 * To run a mutation, you first call `useAiDraftUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiDraftUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiDraftUpdateMutation, { data, loading, error }] = useAiDraftUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      feedback: // value for 'feedback'
 *      collectionId: // value for 'collectionId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useAiDraftUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AiDraftUpdateMutation,
    AiDraftUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AiDraftUpdateMutation,
    AiDraftUpdateMutationVariables
  >(AiDraftUpdateDocument, options);
}
export type AiDraftUpdateMutationHookResult = ReturnType<
  typeof useAiDraftUpdateMutation
>;
export type AiDraftUpdateMutationResult =
  Apollo.MutationResult<AiDraftUpdateMutation>;
export type AiDraftUpdateMutationOptions = Apollo.BaseMutationOptions<
  AiDraftUpdateMutation,
  AiDraftUpdateMutationVariables
>;
export const AiDraftsDocument = gql`
  query AiDrafts(
    $searchQuery: NonEmptyString
    $filters: AiDraftFiltersInput
    $limit: Limit
    $offset: Offset
  ) {
    aiDrafts(
      searchQuery: $searchQuery
      filters: $filters
      limit: $limit
      offset: $offset
    ) {
      results {
        ...AiDraftListItem
      }
      pagination {
        hasMore
        end
        total
      }
    }
  }
  ${AiDraftListItemFragmentDoc}
`;

/**
 * __useAiDraftsQuery__
 *
 * To run a query within a React component, call `useAiDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDraftsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAiDraftsQuery(
  baseOptions?: Apollo.QueryHookOptions<AiDraftsQuery, AiDraftsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiDraftsQuery, AiDraftsQueryVariables>(
    AiDraftsDocument,
    options,
  );
}
export function useAiDraftsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiDraftsQuery,
    AiDraftsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AiDraftsQuery, AiDraftsQueryVariables>(
    AiDraftsDocument,
    options,
  );
}
// @ts-ignore
export function useAiDraftsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiDraftsQuery,
    AiDraftsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AiDraftsQuery, AiDraftsQueryVariables>;
export function useAiDraftsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AiDraftsQuery, AiDraftsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AiDraftsQuery | undefined,
  AiDraftsQueryVariables
>;
export function useAiDraftsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AiDraftsQuery, AiDraftsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AiDraftsQuery, AiDraftsQueryVariables>(
    AiDraftsDocument,
    options,
  );
}
export type AiDraftsQueryHookResult = ReturnType<typeof useAiDraftsQuery>;
export type AiDraftsLazyQueryHookResult = ReturnType<
  typeof useAiDraftsLazyQuery
>;
export type AiDraftsSuspenseQueryHookResult = ReturnType<
  typeof useAiDraftsSuspenseQuery
>;
export type AiDraftsQueryResult = Apollo.QueryResult<
  AiDraftsQuery,
  AiDraftsQueryVariables
>;
export const ArticleCreateDocument = gql`
  mutation ArticleCreate(
    $translations: [ArticleTranslationInput!]!
    $parentId: ID!
  ) {
    articleCreate(translations: $translations, parentId: $parentId) {
      ...ArticleFields
    }
  }
  ${ArticleFieldsFragmentDoc}
`;
export type ArticleCreateMutationFn = Apollo.MutationFunction<
  ArticleCreateMutation,
  ArticleCreateMutationVariables
>;

/**
 * __useArticleCreateMutation__
 *
 * To run a mutation, you first call `useArticleCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleCreateMutation, { data, loading, error }] = useArticleCreateMutation({
 *   variables: {
 *      translations: // value for 'translations'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useArticleCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticleCreateMutation,
    ArticleCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArticleCreateMutation,
    ArticleCreateMutationVariables
  >(ArticleCreateDocument, options);
}
export type ArticleCreateMutationHookResult = ReturnType<
  typeof useArticleCreateMutation
>;
export type ArticleCreateMutationResult =
  Apollo.MutationResult<ArticleCreateMutation>;
export type ArticleCreateMutationOptions = Apollo.BaseMutationOptions<
  ArticleCreateMutation,
  ArticleCreateMutationVariables
>;
export const ArticleDeleteDocument = gql`
  mutation ArticleDelete($id: ID!) {
    articleDelete(id: $id)
  }
`;
export type ArticleDeleteMutationFn = Apollo.MutationFunction<
  ArticleDeleteMutation,
  ArticleDeleteMutationVariables
>;

/**
 * __useArticleDeleteMutation__
 *
 * To run a mutation, you first call `useArticleDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleDeleteMutation, { data, loading, error }] = useArticleDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticleDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticleDeleteMutation,
    ArticleDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArticleDeleteMutation,
    ArticleDeleteMutationVariables
  >(ArticleDeleteDocument, options);
}
export type ArticleDeleteMutationHookResult = ReturnType<
  typeof useArticleDeleteMutation
>;
export type ArticleDeleteMutationResult =
  Apollo.MutationResult<ArticleDeleteMutation>;
export type ArticleDeleteMutationOptions = Apollo.BaseMutationOptions<
  ArticleDeleteMutation,
  ArticleDeleteMutationVariables
>;
export const ArticleMoveDocument = gql`
  mutation ArticleMove(
    $entityId: ID!
    $currentParentId: ID!
    $newParentId: ID
    $newPosition: PositiveInt
  ) {
    contentMove(
      entityId: $entityId
      currentParentId: $currentParentId
      newParentId: $newParentId
      newPosition: $newPosition
    ) {
      id
    }
  }
`;
export type ArticleMoveMutationFn = Apollo.MutationFunction<
  ArticleMoveMutation,
  ArticleMoveMutationVariables
>;

/**
 * __useArticleMoveMutation__
 *
 * To run a mutation, you first call `useArticleMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleMoveMutation, { data, loading, error }] = useArticleMoveMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      currentParentId: // value for 'currentParentId'
 *      newParentId: // value for 'newParentId'
 *      newPosition: // value for 'newPosition'
 *   },
 * });
 */
export function useArticleMoveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticleMoveMutation,
    ArticleMoveMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArticleMoveMutation, ArticleMoveMutationVariables>(
    ArticleMoveDocument,
    options,
  );
}
export type ArticleMoveMutationHookResult = ReturnType<
  typeof useArticleMoveMutation
>;
export type ArticleMoveMutationResult =
  Apollo.MutationResult<ArticleMoveMutation>;
export type ArticleMoveMutationOptions = Apollo.BaseMutationOptions<
  ArticleMoveMutation,
  ArticleMoveMutationVariables
>;
export const ArticleTranslationUpdateDocument = gql`
  mutation ArticleTranslationUpdate(
    $articleId: ID!
    $languageId: LanguageId!
    $title: NonEmptyString
    $content: ContentJson
    $titleUpdatedAt: String
    $titleTranslatedAt: String
  ) {
    articleTranslationUpdate(
      articleId: $articleId
      languageId: $languageId
      title: $title
      content: $content
      titleUpdatedAt: $titleUpdatedAt
      titleTranslatedAt: $titleTranslatedAt
    ) {
      ...ArticleTranslationFields
    }
  }
  ${ArticleTranslationFieldsFragmentDoc}
`;
export type ArticleTranslationUpdateMutationFn = Apollo.MutationFunction<
  ArticleTranslationUpdateMutation,
  ArticleTranslationUpdateMutationVariables
>;

/**
 * __useArticleTranslationUpdateMutation__
 *
 * To run a mutation, you first call `useArticleTranslationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleTranslationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleTranslationUpdateMutation, { data, loading, error }] = useArticleTranslationUpdateMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      languageId: // value for 'languageId'
 *      title: // value for 'title'
 *      content: // value for 'content'
 *      titleUpdatedAt: // value for 'titleUpdatedAt'
 *      titleTranslatedAt: // value for 'titleTranslatedAt'
 *   },
 * });
 */
export function useArticleTranslationUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticleTranslationUpdateMutation,
    ArticleTranslationUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArticleTranslationUpdateMutation,
    ArticleTranslationUpdateMutationVariables
  >(ArticleTranslationUpdateDocument, options);
}
export type ArticleTranslationUpdateMutationHookResult = ReturnType<
  typeof useArticleTranslationUpdateMutation
>;
export type ArticleTranslationUpdateMutationResult =
  Apollo.MutationResult<ArticleTranslationUpdateMutation>;
export type ArticleTranslationUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    ArticleTranslationUpdateMutation,
    ArticleTranslationUpdateMutationVariables
  >;
export const ArticleDetachFromElevioDocument = gql`
  mutation ArticleDetachFromElevio($id: ID!) {
    articleUnlock(id: $id) {
      id
      isSyncedWithElevio: isLocked
    }
  }
`;
export type ArticleDetachFromElevioMutationFn = Apollo.MutationFunction<
  ArticleDetachFromElevioMutation,
  ArticleDetachFromElevioMutationVariables
>;

/**
 * __useArticleDetachFromElevioMutation__
 *
 * To run a mutation, you first call `useArticleDetachFromElevioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleDetachFromElevioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleDetachFromElevioMutation, { data, loading, error }] = useArticleDetachFromElevioMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticleDetachFromElevioMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticleDetachFromElevioMutation,
    ArticleDetachFromElevioMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArticleDetachFromElevioMutation,
    ArticleDetachFromElevioMutationVariables
  >(ArticleDetachFromElevioDocument, options);
}
export type ArticleDetachFromElevioMutationHookResult = ReturnType<
  typeof useArticleDetachFromElevioMutation
>;
export type ArticleDetachFromElevioMutationResult =
  Apollo.MutationResult<ArticleDetachFromElevioMutation>;
export type ArticleDetachFromElevioMutationOptions = Apollo.BaseMutationOptions<
  ArticleDetachFromElevioMutation,
  ArticleDetachFromElevioMutationVariables
>;
export const ArticlesDocument = gql`
  query Articles(
    $languageId: LanguageId!
    $limit: Limit
    $offset: Offset
    $filters: ArticleFiltersInput
    $query: ArticleSearchInput
  ) {
    articles(limit: $limit, offset: $offset) {
      query(query: $query, filters: $filters) {
        results {
          ...ArticleListItemResult
        }
        pagination {
          hasMore
          end
        }
      }
    }
  }
  ${ArticleListItemResultFragmentDoc}
`;

/**
 * __useArticlesQuery__
 *
 * To run a query within a React component, call `useArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesQuery({
 *   variables: {
 *      languageId: // value for 'languageId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useArticlesQuery(
  baseOptions: Apollo.QueryHookOptions<ArticlesQuery, ArticlesQueryVariables> &
    ({ variables: ArticlesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArticlesQuery, ArticlesQueryVariables>(
    ArticlesDocument,
    options,
  );
}
export function useArticlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticlesQuery,
    ArticlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArticlesQuery, ArticlesQueryVariables>(
    ArticlesDocument,
    options,
  );
}
// @ts-ignore
export function useArticlesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticlesQuery,
    ArticlesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ArticlesQuery, ArticlesQueryVariables>;
export function useArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ArticlesQuery, ArticlesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ArticlesQuery | undefined,
  ArticlesQueryVariables
>;
export function useArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ArticlesQuery, ArticlesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ArticlesQuery, ArticlesQueryVariables>(
    ArticlesDocument,
    options,
  );
}
export type ArticlesQueryHookResult = ReturnType<typeof useArticlesQuery>;
export type ArticlesLazyQueryHookResult = ReturnType<
  typeof useArticlesLazyQuery
>;
export type ArticlesSuspenseQueryHookResult = ReturnType<
  typeof useArticlesSuspenseQuery
>;
export type ArticlesQueryResult = Apollo.QueryResult<
  ArticlesQuery,
  ArticlesQueryVariables
>;
export const CategoryCreateDocument = gql`
  mutation CategoryCreate(
    $parentId: ID!
    $translations: [CategoryTranslationInputInput!]!
  ) {
    categoryCreate(parentId: $parentId, translations: $translations) {
      ...CategoryFields
    }
  }
  ${CategoryFieldsFragmentDoc}
`;
export type CategoryCreateMutationFn = Apollo.MutationFunction<
  CategoryCreateMutation,
  CategoryCreateMutationVariables
>;

/**
 * __useCategoryCreateMutation__
 *
 * To run a mutation, you first call `useCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [categoryCreateMutation, { data, loading, error }] = useCategoryCreateMutation({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      translations: // value for 'translations'
 *   },
 * });
 */
export function useCategoryCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CategoryCreateMutation,
    CategoryCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CategoryCreateMutation,
    CategoryCreateMutationVariables
  >(CategoryCreateDocument, options);
}
export type CategoryCreateMutationHookResult = ReturnType<
  typeof useCategoryCreateMutation
>;
export type CategoryCreateMutationResult =
  Apollo.MutationResult<CategoryCreateMutation>;
export type CategoryCreateMutationOptions = Apollo.BaseMutationOptions<
  CategoryCreateMutation,
  CategoryCreateMutationVariables
>;
export const CategoryDeleteDocument = gql`
  mutation CategoryDelete($categoryId: ID!) {
    categoryDelete(id: $categoryId)
  }
`;
export type CategoryDeleteMutationFn = Apollo.MutationFunction<
  CategoryDeleteMutation,
  CategoryDeleteMutationVariables
>;

/**
 * __useCategoryDeleteMutation__
 *
 * To run a mutation, you first call `useCategoryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCategoryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [categoryDeleteMutation, { data, loading, error }] = useCategoryDeleteMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useCategoryDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CategoryDeleteMutation,
    CategoryDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CategoryDeleteMutation,
    CategoryDeleteMutationVariables
  >(CategoryDeleteDocument, options);
}
export type CategoryDeleteMutationHookResult = ReturnType<
  typeof useCategoryDeleteMutation
>;
export type CategoryDeleteMutationResult =
  Apollo.MutationResult<CategoryDeleteMutation>;
export type CategoryDeleteMutationOptions = Apollo.BaseMutationOptions<
  CategoryDeleteMutation,
  CategoryDeleteMutationVariables
>;
export const CategoryDropdownDocument = gql`
  query CategoryDropdown($collectionId: ID!) {
    collection(id: $collectionId) {
      categories {
        id
        isSyncedWithElevio: isLocked
        titles {
          title
          languageId
        }
        categories {
          id
          isSyncedWithElevio: isLocked
          titles {
            title
            languageId
          }
          categories {
            id
            isSyncedWithElevio: isLocked
            titles {
              title
              languageId
            }
            categories {
              id
              isSyncedWithElevio: isLocked
              titles {
                title
                languageId
              }
              categories {
                id
                isSyncedWithElevio: isLocked
                titles {
                  title
                  languageId
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useCategoryDropdownQuery__
 *
 * To run a query within a React component, call `useCategoryDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryDropdownQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useCategoryDropdownQuery(
  baseOptions: Apollo.QueryHookOptions<
    CategoryDropdownQuery,
    CategoryDropdownQueryVariables
  > &
    (
      | { variables: CategoryDropdownQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CategoryDropdownQuery, CategoryDropdownQueryVariables>(
    CategoryDropdownDocument,
    options,
  );
}
export function useCategoryDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryDropdownQuery,
    CategoryDropdownQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CategoryDropdownQuery,
    CategoryDropdownQueryVariables
  >(CategoryDropdownDocument, options);
}
// @ts-ignore
export function useCategoryDropdownSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CategoryDropdownQuery,
    CategoryDropdownQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CategoryDropdownQuery,
  CategoryDropdownQueryVariables
>;
export function useCategoryDropdownSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryDropdownQuery,
        CategoryDropdownQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CategoryDropdownQuery | undefined,
  CategoryDropdownQueryVariables
>;
export function useCategoryDropdownSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryDropdownQuery,
        CategoryDropdownQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CategoryDropdownQuery,
    CategoryDropdownQueryVariables
  >(CategoryDropdownDocument, options);
}
export type CategoryDropdownQueryHookResult = ReturnType<
  typeof useCategoryDropdownQuery
>;
export type CategoryDropdownLazyQueryHookResult = ReturnType<
  typeof useCategoryDropdownLazyQuery
>;
export type CategoryDropdownSuspenseQueryHookResult = ReturnType<
  typeof useCategoryDropdownSuspenseQuery
>;
export type CategoryDropdownQueryResult = Apollo.QueryResult<
  CategoryDropdownQuery,
  CategoryDropdownQueryVariables
>;
export const CategoryMoveDocument = gql`
  mutation CategoryMove(
    $entityId: ID!
    $currentParentId: ID!
    $newParentId: ID
    $newPosition: PositiveInt
  ) {
    contentMove(
      entityId: $entityId
      currentParentId: $currentParentId
      newParentId: $newParentId
      newPosition: $newPosition
    ) {
      id
      categories {
        id
        parent {
          id
        }
      }
    }
  }
`;
export type CategoryMoveMutationFn = Apollo.MutationFunction<
  CategoryMoveMutation,
  CategoryMoveMutationVariables
>;

/**
 * __useCategoryMoveMutation__
 *
 * To run a mutation, you first call `useCategoryMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCategoryMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [categoryMoveMutation, { data, loading, error }] = useCategoryMoveMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      currentParentId: // value for 'currentParentId'
 *      newParentId: // value for 'newParentId'
 *      newPosition: // value for 'newPosition'
 *   },
 * });
 */
export function useCategoryMoveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CategoryMoveMutation,
    CategoryMoveMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CategoryMoveMutation,
    CategoryMoveMutationVariables
  >(CategoryMoveDocument, options);
}
export type CategoryMoveMutationHookResult = ReturnType<
  typeof useCategoryMoveMutation
>;
export type CategoryMoveMutationResult =
  Apollo.MutationResult<CategoryMoveMutation>;
export type CategoryMoveMutationOptions = Apollo.BaseMutationOptions<
  CategoryMoveMutation,
  CategoryMoveMutationVariables
>;
export const CategoryMoveQDocument = gql`
  query CategoryMoveQ($id: ID!) {
    category(id: $id) {
      id
      parent {
        id
      }
    }
  }
`;

/**
 * __useCategoryMoveQQuery__
 *
 * To run a query within a React component, call `useCategoryMoveQQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryMoveQQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryMoveQQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCategoryMoveQQuery(
  baseOptions: Apollo.QueryHookOptions<
    CategoryMoveQQuery,
    CategoryMoveQQueryVariables
  > &
    (
      | { variables: CategoryMoveQQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CategoryMoveQQuery, CategoryMoveQQueryVariables>(
    CategoryMoveQDocument,
    options,
  );
}
export function useCategoryMoveQLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryMoveQQuery,
    CategoryMoveQQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CategoryMoveQQuery, CategoryMoveQQueryVariables>(
    CategoryMoveQDocument,
    options,
  );
}
// @ts-ignore
export function useCategoryMoveQSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CategoryMoveQQuery,
    CategoryMoveQQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CategoryMoveQQuery,
  CategoryMoveQQueryVariables
>;
export function useCategoryMoveQSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryMoveQQuery,
        CategoryMoveQQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CategoryMoveQQuery | undefined,
  CategoryMoveQQueryVariables
>;
export function useCategoryMoveQSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryMoveQQuery,
        CategoryMoveQQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CategoryMoveQQuery,
    CategoryMoveQQueryVariables
  >(CategoryMoveQDocument, options);
}
export type CategoryMoveQQueryHookResult = ReturnType<
  typeof useCategoryMoveQQuery
>;
export type CategoryMoveQLazyQueryHookResult = ReturnType<
  typeof useCategoryMoveQLazyQuery
>;
export type CategoryMoveQSuspenseQueryHookResult = ReturnType<
  typeof useCategoryMoveQSuspenseQuery
>;
export type CategoryMoveQQueryResult = Apollo.QueryResult<
  CategoryMoveQQuery,
  CategoryMoveQQueryVariables
>;
export const CategoryNodeDocument = gql`
  query CategoryNode($id: ID!) {
    category(id: $id) {
      ...CategoryChild
    }
  }
  ${CategoryChildFragmentDoc}
`;

/**
 * __useCategoryNodeQuery__
 *
 * To run a query within a React component, call `useCategoryNodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryNodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryNodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCategoryNodeQuery(
  baseOptions: Apollo.QueryHookOptions<
    CategoryNodeQuery,
    CategoryNodeQueryVariables
  > &
    (
      | { variables: CategoryNodeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CategoryNodeQuery, CategoryNodeQueryVariables>(
    CategoryNodeDocument,
    options,
  );
}
export function useCategoryNodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryNodeQuery,
    CategoryNodeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CategoryNodeQuery, CategoryNodeQueryVariables>(
    CategoryNodeDocument,
    options,
  );
}
// @ts-ignore
export function useCategoryNodeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CategoryNodeQuery,
    CategoryNodeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CategoryNodeQuery, CategoryNodeQueryVariables>;
export function useCategoryNodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryNodeQuery,
        CategoryNodeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CategoryNodeQuery | undefined,
  CategoryNodeQueryVariables
>;
export function useCategoryNodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryNodeQuery,
        CategoryNodeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CategoryNodeQuery, CategoryNodeQueryVariables>(
    CategoryNodeDocument,
    options,
  );
}
export type CategoryNodeQueryHookResult = ReturnType<
  typeof useCategoryNodeQuery
>;
export type CategoryNodeLazyQueryHookResult = ReturnType<
  typeof useCategoryNodeLazyQuery
>;
export type CategoryNodeSuspenseQueryHookResult = ReturnType<
  typeof useCategoryNodeSuspenseQuery
>;
export type CategoryNodeQueryResult = Apollo.QueryResult<
  CategoryNodeQuery,
  CategoryNodeQueryVariables
>;
export const CategoryDocument = gql`
  query Category($id: ID!) {
    category(id: $id) {
      id
      titles {
        languageId
        title
      }
      parent {
        id
      }
      restrictions {
        direct
      }
      isSyncedWithElevio: isLocked
    }
  }
`;

/**
 * __useCategoryQuery__
 *
 * To run a query within a React component, call `useCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCategoryQuery(
  baseOptions: Apollo.QueryHookOptions<CategoryQuery, CategoryQueryVariables> &
    ({ variables: CategoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CategoryQuery, CategoryQueryVariables>(
    CategoryDocument,
    options,
  );
}
export function useCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryQuery,
    CategoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CategoryQuery, CategoryQueryVariables>(
    CategoryDocument,
    options,
  );
}
// @ts-ignore
export function useCategorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CategoryQuery,
    CategoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CategoryQuery, CategoryQueryVariables>;
export function useCategorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CategoryQuery, CategoryQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  CategoryQuery | undefined,
  CategoryQueryVariables
>;
export function useCategorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CategoryQuery, CategoryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CategoryQuery, CategoryQueryVariables>(
    CategoryDocument,
    options,
  );
}
export type CategoryQueryHookResult = ReturnType<typeof useCategoryQuery>;
export type CategoryLazyQueryHookResult = ReturnType<
  typeof useCategoryLazyQuery
>;
export type CategorySuspenseQueryHookResult = ReturnType<
  typeof useCategorySuspenseQuery
>;
export type CategoryQueryResult = Apollo.QueryResult<
  CategoryQuery,
  CategoryQueryVariables
>;
export const CategoryTranslationDeleteDocument = gql`
  mutation CategoryTranslationDelete($id: ID!, $languageId: LanguageId!) {
    categoryTranslationDelete(id: $id, languageId: $languageId) {
      ...CategoryFields
    }
  }
  ${CategoryFieldsFragmentDoc}
`;
export type CategoryTranslationDeleteMutationFn = Apollo.MutationFunction<
  CategoryTranslationDeleteMutation,
  CategoryTranslationDeleteMutationVariables
>;

/**
 * __useCategoryTranslationDeleteMutation__
 *
 * To run a mutation, you first call `useCategoryTranslationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCategoryTranslationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [categoryTranslationDeleteMutation, { data, loading, error }] = useCategoryTranslationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      languageId: // value for 'languageId'
 *   },
 * });
 */
export function useCategoryTranslationDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CategoryTranslationDeleteMutation,
    CategoryTranslationDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CategoryTranslationDeleteMutation,
    CategoryTranslationDeleteMutationVariables
  >(CategoryTranslationDeleteDocument, options);
}
export type CategoryTranslationDeleteMutationHookResult = ReturnType<
  typeof useCategoryTranslationDeleteMutation
>;
export type CategoryTranslationDeleteMutationResult =
  Apollo.MutationResult<CategoryTranslationDeleteMutation>;
export type CategoryTranslationDeleteMutationOptions =
  Apollo.BaseMutationOptions<
    CategoryTranslationDeleteMutation,
    CategoryTranslationDeleteMutationVariables
  >;
export const CategoryTranslationUpsertDocument = gql`
  mutation CategoryTranslationUpsert(
    $id: ID!
    $languageId: LanguageId!
    $title: NonEmptyString!
  ) {
    categoryTranslationUpsert(id: $id, languageId: $languageId, title: $title) {
      ...CategoryFields
    }
  }
  ${CategoryFieldsFragmentDoc}
`;
export type CategoryTranslationUpsertMutationFn = Apollo.MutationFunction<
  CategoryTranslationUpsertMutation,
  CategoryTranslationUpsertMutationVariables
>;

/**
 * __useCategoryTranslationUpsertMutation__
 *
 * To run a mutation, you first call `useCategoryTranslationUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCategoryTranslationUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [categoryTranslationUpsertMutation, { data, loading, error }] = useCategoryTranslationUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      languageId: // value for 'languageId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCategoryTranslationUpsertMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CategoryTranslationUpsertMutation,
    CategoryTranslationUpsertMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CategoryTranslationUpsertMutation,
    CategoryTranslationUpsertMutationVariables
  >(CategoryTranslationUpsertDocument, options);
}
export type CategoryTranslationUpsertMutationHookResult = ReturnType<
  typeof useCategoryTranslationUpsertMutation
>;
export type CategoryTranslationUpsertMutationResult =
  Apollo.MutationResult<CategoryTranslationUpsertMutation>;
export type CategoryTranslationUpsertMutationOptions =
  Apollo.BaseMutationOptions<
    CategoryTranslationUpsertMutation,
    CategoryTranslationUpsertMutationVariables
  >;
export const CategoryUpdateDocument = gql`
  mutation CategoryUpdate($id: ID!) {
    categoryUpdate(id: $id) {
      ...CategoryFields
    }
  }
  ${CategoryFieldsFragmentDoc}
`;
export type CategoryUpdateMutationFn = Apollo.MutationFunction<
  CategoryUpdateMutation,
  CategoryUpdateMutationVariables
>;

/**
 * __useCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [categoryUpdateMutation, { data, loading, error }] = useCategoryUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCategoryUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CategoryUpdateMutation,
    CategoryUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CategoryUpdateMutation,
    CategoryUpdateMutationVariables
  >(CategoryUpdateDocument, options);
}
export type CategoryUpdateMutationHookResult = ReturnType<
  typeof useCategoryUpdateMutation
>;
export type CategoryUpdateMutationResult =
  Apollo.MutationResult<CategoryUpdateMutation>;
export type CategoryUpdateMutationOptions = Apollo.BaseMutationOptions<
  CategoryUpdateMutation,
  CategoryUpdateMutationVariables
>;
export const CollectionCreateDocument = gql`
  mutation CollectionCreate(
    $title: NonEmptyString!
    $internalKbEnabled: Boolean!
  ) {
    collectionCreate(title: $title, internalKbEnabled: $internalKbEnabled) {
      ...CollectionFields
    }
  }
  ${CollectionFieldsFragmentDoc}
`;
export type CollectionCreateMutationFn = Apollo.MutationFunction<
  CollectionCreateMutation,
  CollectionCreateMutationVariables
>;

/**
 * __useCollectionCreateMutation__
 *
 * To run a mutation, you first call `useCollectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectionCreateMutation, { data, loading, error }] = useCollectionCreateMutation({
 *   variables: {
 *      title: // value for 'title'
 *      internalKbEnabled: // value for 'internalKbEnabled'
 *   },
 * });
 */
export function useCollectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CollectionCreateMutation,
    CollectionCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CollectionCreateMutation,
    CollectionCreateMutationVariables
  >(CollectionCreateDocument, options);
}
export type CollectionCreateMutationHookResult = ReturnType<
  typeof useCollectionCreateMutation
>;
export type CollectionCreateMutationResult =
  Apollo.MutationResult<CollectionCreateMutation>;
export type CollectionCreateMutationOptions = Apollo.BaseMutationOptions<
  CollectionCreateMutation,
  CollectionCreateMutationVariables
>;
export const CollectionDeleteDocument = gql`
  mutation CollectionDelete($id: ID!) {
    collectionDelete(id: $id)
  }
`;
export type CollectionDeleteMutationFn = Apollo.MutationFunction<
  CollectionDeleteMutation,
  CollectionDeleteMutationVariables
>;

/**
 * __useCollectionDeleteMutation__
 *
 * To run a mutation, you first call `useCollectionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectionDeleteMutation, { data, loading, error }] = useCollectionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCollectionDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CollectionDeleteMutation,
    CollectionDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CollectionDeleteMutation,
    CollectionDeleteMutationVariables
  >(CollectionDeleteDocument, options);
}
export type CollectionDeleteMutationHookResult = ReturnType<
  typeof useCollectionDeleteMutation
>;
export type CollectionDeleteMutationResult =
  Apollo.MutationResult<CollectionDeleteMutation>;
export type CollectionDeleteMutationOptions = Apollo.BaseMutationOptions<
  CollectionDeleteMutation,
  CollectionDeleteMutationVariables
>;
export const CollectionDetachDocument = gql`
  mutation CollectionDetach($id: ID!) {
    collectionUnlock(id: $id) {
      ...CollectionFields
    }
  }
  ${CollectionFieldsFragmentDoc}
`;
export type CollectionDetachMutationFn = Apollo.MutationFunction<
  CollectionDetachMutation,
  CollectionDetachMutationVariables
>;

/**
 * __useCollectionDetachMutation__
 *
 * To run a mutation, you first call `useCollectionDetachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectionDetachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectionDetachMutation, { data, loading, error }] = useCollectionDetachMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCollectionDetachMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CollectionDetachMutation,
    CollectionDetachMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CollectionDetachMutation,
    CollectionDetachMutationVariables
  >(CollectionDetachDocument, options);
}
export type CollectionDetachMutationHookResult = ReturnType<
  typeof useCollectionDetachMutation
>;
export type CollectionDetachMutationResult =
  Apollo.MutationResult<CollectionDetachMutation>;
export type CollectionDetachMutationOptions = Apollo.BaseMutationOptions<
  CollectionDetachMutation,
  CollectionDetachMutationVariables
>;
export const CollectionDocument = gql`
  query Collection($id: ID!) {
    collection(id: $id) {
      ...CollectionFields
    }
  }
  ${CollectionFieldsFragmentDoc}
`;

/**
 * __useCollectionQuery__
 *
 * To run a query within a React component, call `useCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectionQuery,
    CollectionQueryVariables
  > &
    (
      | { variables: CollectionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CollectionQuery, CollectionQueryVariables>(
    CollectionDocument,
    options,
  );
}
export function useCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionQuery,
    CollectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CollectionQuery, CollectionQueryVariables>(
    CollectionDocument,
    options,
  );
}
// @ts-ignore
export function useCollectionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollectionQuery,
    CollectionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CollectionQuery, CollectionQueryVariables>;
export function useCollectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionQuery,
        CollectionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CollectionQuery | undefined,
  CollectionQueryVariables
>;
export function useCollectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionQuery,
        CollectionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CollectionQuery, CollectionQueryVariables>(
    CollectionDocument,
    options,
  );
}
export type CollectionQueryHookResult = ReturnType<typeof useCollectionQuery>;
export type CollectionLazyQueryHookResult = ReturnType<
  typeof useCollectionLazyQuery
>;
export type CollectionSuspenseQueryHookResult = ReturnType<
  typeof useCollectionSuspenseQuery
>;
export type CollectionQueryResult = Apollo.QueryResult<
  CollectionQuery,
  CollectionQueryVariables
>;
export const CollectionStatsDocument = gql`
  query CollectionStats($id: ID!) {
    collection(id: $id) {
      id
      statistics {
        categoryCount
        articleCount
        queueCount
      }
    }
  }
`;

/**
 * __useCollectionStatsQuery__
 *
 * To run a query within a React component, call `useCollectionStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCollectionStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectionStatsQuery,
    CollectionStatsQueryVariables
  > &
    (
      | { variables: CollectionStatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CollectionStatsQuery, CollectionStatsQueryVariables>(
    CollectionStatsDocument,
    options,
  );
}
export function useCollectionStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionStatsQuery,
    CollectionStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollectionStatsQuery,
    CollectionStatsQueryVariables
  >(CollectionStatsDocument, options);
}
// @ts-ignore
export function useCollectionStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollectionStatsQuery,
    CollectionStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CollectionStatsQuery,
  CollectionStatsQueryVariables
>;
export function useCollectionStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionStatsQuery,
        CollectionStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CollectionStatsQuery | undefined,
  CollectionStatsQueryVariables
>;
export function useCollectionStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionStatsQuery,
        CollectionStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CollectionStatsQuery,
    CollectionStatsQueryVariables
  >(CollectionStatsDocument, options);
}
export type CollectionStatsQueryHookResult = ReturnType<
  typeof useCollectionStatsQuery
>;
export type CollectionStatsLazyQueryHookResult = ReturnType<
  typeof useCollectionStatsLazyQuery
>;
export type CollectionStatsSuspenseQueryHookResult = ReturnType<
  typeof useCollectionStatsSuspenseQuery
>;
export type CollectionStatsQueryResult = Apollo.QueryResult<
  CollectionStatsQuery,
  CollectionStatsQueryVariables
>;
export const CollectionTreeDocument = gql`
  query CollectionTree($id: ID!) {
    collection(id: $id) {
      ...CollectionFields
      categories {
        ...CategoryFields
        articles {
          ...ArticleFields
        }
        categories {
          ...CategoryFields
          articles {
            ...ArticleFields
          }
          categories {
            ...CategoryFields
            articles {
              ...ArticleFields
            }
            categories {
              ...CategoryFields
              articles {
                ...ArticleFields
              }
              categories {
                ...CategoryFields
                articles {
                  ...ArticleFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${CollectionFieldsFragmentDoc}
  ${CategoryFieldsFragmentDoc}
  ${ArticleFieldsFragmentDoc}
`;

/**
 * __useCollectionTreeQuery__
 *
 * To run a query within a React component, call `useCollectionTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionTreeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCollectionTreeQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectionTreeQuery,
    CollectionTreeQueryVariables
  > &
    (
      | { variables: CollectionTreeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CollectionTreeQuery, CollectionTreeQueryVariables>(
    CollectionTreeDocument,
    options,
  );
}
export function useCollectionTreeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionTreeQuery,
    CollectionTreeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CollectionTreeQuery, CollectionTreeQueryVariables>(
    CollectionTreeDocument,
    options,
  );
}
// @ts-ignore
export function useCollectionTreeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollectionTreeQuery,
    CollectionTreeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CollectionTreeQuery,
  CollectionTreeQueryVariables
>;
export function useCollectionTreeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionTreeQuery,
        CollectionTreeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CollectionTreeQuery | undefined,
  CollectionTreeQueryVariables
>;
export function useCollectionTreeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionTreeQuery,
        CollectionTreeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CollectionTreeQuery,
    CollectionTreeQueryVariables
  >(CollectionTreeDocument, options);
}
export type CollectionTreeQueryHookResult = ReturnType<
  typeof useCollectionTreeQuery
>;
export type CollectionTreeLazyQueryHookResult = ReturnType<
  typeof useCollectionTreeLazyQuery
>;
export type CollectionTreeSuspenseQueryHookResult = ReturnType<
  typeof useCollectionTreeSuspenseQuery
>;
export type CollectionTreeQueryResult = Apollo.QueryResult<
  CollectionTreeQuery,
  CollectionTreeQueryVariables
>;
export const CollectionUpdateDocument = gql`
  mutation CollectionUpdate(
    $id: ID!
    $title: NonEmptyString
    $externalResources: ResourcesUpdateInput
    $internalKbEnabled: Boolean!
    $icon: Color!
    $description: String
  ) {
    collectionUpdate(
      id: $id
      title: $title
      externalResources: $externalResources
      internalKbEnabled: $internalKbEnabled
      themeColors: { icon: $icon }
      description: $description
    ) {
      ...CollectionFields
    }
  }
  ${CollectionFieldsFragmentDoc}
`;
export type CollectionUpdateMutationFn = Apollo.MutationFunction<
  CollectionUpdateMutation,
  CollectionUpdateMutationVariables
>;

/**
 * __useCollectionUpdateMutation__
 *
 * To run a mutation, you first call `useCollectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectionUpdateMutation, { data, loading, error }] = useCollectionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      externalResources: // value for 'externalResources'
 *      internalKbEnabled: // value for 'internalKbEnabled'
 *      icon: // value for 'icon'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCollectionUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CollectionUpdateMutation,
    CollectionUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CollectionUpdateMutation,
    CollectionUpdateMutationVariables
  >(CollectionUpdateDocument, options);
}
export type CollectionUpdateMutationHookResult = ReturnType<
  typeof useCollectionUpdateMutation
>;
export type CollectionUpdateMutationResult =
  Apollo.MutationResult<CollectionUpdateMutation>;
export type CollectionUpdateMutationOptions = Apollo.BaseMutationOptions<
  CollectionUpdateMutation,
  CollectionUpdateMutationVariables
>;
export const CollectionsFetchDocument = gql`
  query CollectionsFetch($offset: Offset, $limit: Limit) {
    collections(offset: $offset, limit: $limit) {
      results {
        id
        title
        internalKbEnabled
        isSyncedWithElevio: isLocked
      }
    }
    settings {
      ...SettingsFields
    }
  }
  ${SettingsFieldsFragmentDoc}
`;

/**
 * __useCollectionsFetchQuery__
 *
 * To run a query within a React component, call `useCollectionsFetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsFetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionsFetchQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCollectionsFetchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CollectionsFetchQuery,
    CollectionsFetchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CollectionsFetchQuery, CollectionsFetchQueryVariables>(
    CollectionsFetchDocument,
    options,
  );
}
export function useCollectionsFetchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionsFetchQuery,
    CollectionsFetchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollectionsFetchQuery,
    CollectionsFetchQueryVariables
  >(CollectionsFetchDocument, options);
}
// @ts-ignore
export function useCollectionsFetchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollectionsFetchQuery,
    CollectionsFetchQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CollectionsFetchQuery,
  CollectionsFetchQueryVariables
>;
export function useCollectionsFetchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionsFetchQuery,
        CollectionsFetchQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CollectionsFetchQuery | undefined,
  CollectionsFetchQueryVariables
>;
export function useCollectionsFetchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionsFetchQuery,
        CollectionsFetchQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CollectionsFetchQuery,
    CollectionsFetchQueryVariables
  >(CollectionsFetchDocument, options);
}
export type CollectionsFetchQueryHookResult = ReturnType<
  typeof useCollectionsFetchQuery
>;
export type CollectionsFetchLazyQueryHookResult = ReturnType<
  typeof useCollectionsFetchLazyQuery
>;
export type CollectionsFetchSuspenseQueryHookResult = ReturnType<
  typeof useCollectionsFetchSuspenseQuery
>;
export type CollectionsFetchQueryResult = Apollo.QueryResult<
  CollectionsFetchQuery,
  CollectionsFetchQueryVariables
>;
export const FileUploadDocument = gql`
  mutation FileUpload($fileName: NonEmptyString!) {
    fileUploadRequest(filename: $fileName) {
      uploadUrl
      method
      contentType
      customHeaders
      expiresAt
      filename
      availableAt
    }
  }
`;
export type FileUploadMutationFn = Apollo.MutationFunction<
  FileUploadMutation,
  FileUploadMutationVariables
>;

/**
 * __useFileUploadMutation__
 *
 * To run a mutation, you first call `useFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileUploadMutation, { data, loading, error }] = useFileUploadMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useFileUploadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FileUploadMutation,
    FileUploadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FileUploadMutation, FileUploadMutationVariables>(
    FileUploadDocument,
    options,
  );
}
export type FileUploadMutationHookResult = ReturnType<
  typeof useFileUploadMutation
>;
export type FileUploadMutationResult =
  Apollo.MutationResult<FileUploadMutation>;
export type FileUploadMutationOptions = Apollo.BaseMutationOptions<
  FileUploadMutation,
  FileUploadMutationVariables
>;
export const OptimisticArticleParentDocument = gql`
  query OptimisticArticleParent($id: ID!) {
    category(id: $id) {
      id
      articles {
        id
      }
    }
  }
`;

/**
 * __useOptimisticArticleParentQuery__
 *
 * To run a query within a React component, call `useOptimisticArticleParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptimisticArticleParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptimisticArticleParentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOptimisticArticleParentQuery(
  baseOptions: Apollo.QueryHookOptions<
    OptimisticArticleParentQuery,
    OptimisticArticleParentQueryVariables
  > &
    (
      | { variables: OptimisticArticleParentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OptimisticArticleParentQuery,
    OptimisticArticleParentQueryVariables
  >(OptimisticArticleParentDocument, options);
}
export function useOptimisticArticleParentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OptimisticArticleParentQuery,
    OptimisticArticleParentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OptimisticArticleParentQuery,
    OptimisticArticleParentQueryVariables
  >(OptimisticArticleParentDocument, options);
}
// @ts-ignore
export function useOptimisticArticleParentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OptimisticArticleParentQuery,
    OptimisticArticleParentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OptimisticArticleParentQuery,
  OptimisticArticleParentQueryVariables
>;
export function useOptimisticArticleParentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OptimisticArticleParentQuery,
        OptimisticArticleParentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OptimisticArticleParentQuery | undefined,
  OptimisticArticleParentQueryVariables
>;
export function useOptimisticArticleParentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OptimisticArticleParentQuery,
        OptimisticArticleParentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OptimisticArticleParentQuery,
    OptimisticArticleParentQueryVariables
  >(OptimisticArticleParentDocument, options);
}
export type OptimisticArticleParentQueryHookResult = ReturnType<
  typeof useOptimisticArticleParentQuery
>;
export type OptimisticArticleParentLazyQueryHookResult = ReturnType<
  typeof useOptimisticArticleParentLazyQuery
>;
export type OptimisticArticleParentSuspenseQueryHookResult = ReturnType<
  typeof useOptimisticArticleParentSuspenseQuery
>;
export type OptimisticArticleParentQueryResult = Apollo.QueryResult<
  OptimisticArticleParentQuery,
  OptimisticArticleParentQueryVariables
>;
export const OptimisticCategoryDocument = gql`
  query OptimisticCategory($id: ID!) {
    category(id: $id) {
      id
      categories {
        id
        parent {
          id
        }
      }
    }
  }
`;

/**
 * __useOptimisticCategoryQuery__
 *
 * To run a query within a React component, call `useOptimisticCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptimisticCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptimisticCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOptimisticCategoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    OptimisticCategoryQuery,
    OptimisticCategoryQueryVariables
  > &
    (
      | { variables: OptimisticCategoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OptimisticCategoryQuery,
    OptimisticCategoryQueryVariables
  >(OptimisticCategoryDocument, options);
}
export function useOptimisticCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OptimisticCategoryQuery,
    OptimisticCategoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OptimisticCategoryQuery,
    OptimisticCategoryQueryVariables
  >(OptimisticCategoryDocument, options);
}
// @ts-ignore
export function useOptimisticCategorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OptimisticCategoryQuery,
    OptimisticCategoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OptimisticCategoryQuery,
  OptimisticCategoryQueryVariables
>;
export function useOptimisticCategorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OptimisticCategoryQuery,
        OptimisticCategoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OptimisticCategoryQuery | undefined,
  OptimisticCategoryQueryVariables
>;
export function useOptimisticCategorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OptimisticCategoryQuery,
        OptimisticCategoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OptimisticCategoryQuery,
    OptimisticCategoryQueryVariables
  >(OptimisticCategoryDocument, options);
}
export type OptimisticCategoryQueryHookResult = ReturnType<
  typeof useOptimisticCategoryQuery
>;
export type OptimisticCategoryLazyQueryHookResult = ReturnType<
  typeof useOptimisticCategoryLazyQuery
>;
export type OptimisticCategorySuspenseQueryHookResult = ReturnType<
  typeof useOptimisticCategorySuspenseQuery
>;
export type OptimisticCategoryQueryResult = Apollo.QueryResult<
  OptimisticCategoryQuery,
  OptimisticCategoryQueryVariables
>;
export const OptimisticCollectionDocument = gql`
  query OptimisticCollection($id: ID!) {
    collection(id: $id) {
      id
      categories {
        id
        parent {
          id
        }
      }
    }
  }
`;

/**
 * __useOptimisticCollectionQuery__
 *
 * To run a query within a React component, call `useOptimisticCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptimisticCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptimisticCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOptimisticCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    OptimisticCollectionQuery,
    OptimisticCollectionQueryVariables
  > &
    (
      | { variables: OptimisticCollectionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OptimisticCollectionQuery,
    OptimisticCollectionQueryVariables
  >(OptimisticCollectionDocument, options);
}
export function useOptimisticCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OptimisticCollectionQuery,
    OptimisticCollectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OptimisticCollectionQuery,
    OptimisticCollectionQueryVariables
  >(OptimisticCollectionDocument, options);
}
// @ts-ignore
export function useOptimisticCollectionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OptimisticCollectionQuery,
    OptimisticCollectionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OptimisticCollectionQuery,
  OptimisticCollectionQueryVariables
>;
export function useOptimisticCollectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OptimisticCollectionQuery,
        OptimisticCollectionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OptimisticCollectionQuery | undefined,
  OptimisticCollectionQueryVariables
>;
export function useOptimisticCollectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OptimisticCollectionQuery,
        OptimisticCollectionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OptimisticCollectionQuery,
    OptimisticCollectionQueryVariables
  >(OptimisticCollectionDocument, options);
}
export type OptimisticCollectionQueryHookResult = ReturnType<
  typeof useOptimisticCollectionQuery
>;
export type OptimisticCollectionLazyQueryHookResult = ReturnType<
  typeof useOptimisticCollectionLazyQuery
>;
export type OptimisticCollectionSuspenseQueryHookResult = ReturnType<
  typeof useOptimisticCollectionSuspenseQuery
>;
export type OptimisticCollectionQueryResult = Apollo.QueryResult<
  OptimisticCollectionQuery,
  OptimisticCollectionQueryVariables
>;
export const OrganizationEnableLanguagesDocument = gql`
  mutation OrganizationEnableLanguages($languageIds: [LanguageId!]!) {
    organisationEnableLanguages(languageIds: $languageIds) {
      ...ManagementOrganizationSettings
    }
  }
  ${ManagementOrganizationSettingsFragmentDoc}
`;
export type OrganizationEnableLanguagesMutationFn = Apollo.MutationFunction<
  OrganizationEnableLanguagesMutation,
  OrganizationEnableLanguagesMutationVariables
>;

/**
 * __useOrganizationEnableLanguagesMutation__
 *
 * To run a mutation, you first call `useOrganizationEnableLanguagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEnableLanguagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationEnableLanguagesMutation, { data, loading, error }] = useOrganizationEnableLanguagesMutation({
 *   variables: {
 *      languageIds: // value for 'languageIds'
 *   },
 * });
 */
export function useOrganizationEnableLanguagesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OrganizationEnableLanguagesMutation,
    OrganizationEnableLanguagesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    OrganizationEnableLanguagesMutation,
    OrganizationEnableLanguagesMutationVariables
  >(OrganizationEnableLanguagesDocument, options);
}
export type OrganizationEnableLanguagesMutationHookResult = ReturnType<
  typeof useOrganizationEnableLanguagesMutation
>;
export type OrganizationEnableLanguagesMutationResult =
  Apollo.MutationResult<OrganizationEnableLanguagesMutation>;
export type OrganizationEnableLanguagesMutationOptions =
  Apollo.BaseMutationOptions<
    OrganizationEnableLanguagesMutation,
    OrganizationEnableLanguagesMutationVariables
  >;
export const OrganizationRemoveLanguageDocument = gql`
  mutation OrganizationRemoveLanguage($languageId: LanguageId!) {
    organisationDisableLanguage(languageId: $languageId) {
      ...ManagementOrganizationSettings
    }
  }
  ${ManagementOrganizationSettingsFragmentDoc}
`;
export type OrganizationRemoveLanguageMutationFn = Apollo.MutationFunction<
  OrganizationRemoveLanguageMutation,
  OrganizationRemoveLanguageMutationVariables
>;

/**
 * __useOrganizationRemoveLanguageMutation__
 *
 * To run a mutation, you first call `useOrganizationRemoveLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRemoveLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationRemoveLanguageMutation, { data, loading, error }] = useOrganizationRemoveLanguageMutation({
 *   variables: {
 *      languageId: // value for 'languageId'
 *   },
 * });
 */
export function useOrganizationRemoveLanguageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OrganizationRemoveLanguageMutation,
    OrganizationRemoveLanguageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    OrganizationRemoveLanguageMutation,
    OrganizationRemoveLanguageMutationVariables
  >(OrganizationRemoveLanguageDocument, options);
}
export type OrganizationRemoveLanguageMutationHookResult = ReturnType<
  typeof useOrganizationRemoveLanguageMutation
>;
export type OrganizationRemoveLanguageMutationResult =
  Apollo.MutationResult<OrganizationRemoveLanguageMutation>;
export type OrganizationRemoveLanguageMutationOptions =
  Apollo.BaseMutationOptions<
    OrganizationRemoveLanguageMutation,
    OrganizationRemoveLanguageMutationVariables
  >;
export const OrganizationSetDefaultLanguageDocument = gql`
  mutation OrganizationSetDefaultLanguage($languageId: LanguageId!) {
    organisationSetDefaultLanguage(languageId: $languageId) {
      ...ManagementOrganizationSettings
    }
  }
  ${ManagementOrganizationSettingsFragmentDoc}
`;
export type OrganizationSetDefaultLanguageMutationFn = Apollo.MutationFunction<
  OrganizationSetDefaultLanguageMutation,
  OrganizationSetDefaultLanguageMutationVariables
>;

/**
 * __useOrganizationSetDefaultLanguageMutation__
 *
 * To run a mutation, you first call `useOrganizationSetDefaultLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSetDefaultLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationSetDefaultLanguageMutation, { data, loading, error }] = useOrganizationSetDefaultLanguageMutation({
 *   variables: {
 *      languageId: // value for 'languageId'
 *   },
 * });
 */
export function useOrganizationSetDefaultLanguageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OrganizationSetDefaultLanguageMutation,
    OrganizationSetDefaultLanguageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    OrganizationSetDefaultLanguageMutation,
    OrganizationSetDefaultLanguageMutationVariables
  >(OrganizationSetDefaultLanguageDocument, options);
}
export type OrganizationSetDefaultLanguageMutationHookResult = ReturnType<
  typeof useOrganizationSetDefaultLanguageMutation
>;
export type OrganizationSetDefaultLanguageMutationResult =
  Apollo.MutationResult<OrganizationSetDefaultLanguageMutation>;
export type OrganizationSetDefaultLanguageMutationOptions =
  Apollo.BaseMutationOptions<
    OrganizationSetDefaultLanguageMutation,
    OrganizationSetDefaultLanguageMutationVariables
  >;
export const OrganizationSettingsDocument = gql`
  query OrganizationSettings {
    organisationSettings {
      ...ManagementOrganizationSettings
    }
  }
  ${ManagementOrganizationSettingsFragmentDoc}
`;

/**
 * __useOrganizationSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OrganizationSettingsQuery,
    OrganizationSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OrganizationSettingsQuery,
    OrganizationSettingsQueryVariables
  >(OrganizationSettingsDocument, options);
}
export function useOrganizationSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationSettingsQuery,
    OrganizationSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrganizationSettingsQuery,
    OrganizationSettingsQueryVariables
  >(OrganizationSettingsDocument, options);
}
// @ts-ignore
export function useOrganizationSettingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrganizationSettingsQuery,
    OrganizationSettingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OrganizationSettingsQuery,
  OrganizationSettingsQueryVariables
>;
export function useOrganizationSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationSettingsQuery,
        OrganizationSettingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OrganizationSettingsQuery | undefined,
  OrganizationSettingsQueryVariables
>;
export function useOrganizationSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationSettingsQuery,
        OrganizationSettingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OrganizationSettingsQuery,
    OrganizationSettingsQueryVariables
  >(OrganizationSettingsDocument, options);
}
export type OrganizationSettingsQueryHookResult = ReturnType<
  typeof useOrganizationSettingsQuery
>;
export type OrganizationSettingsLazyQueryHookResult = ReturnType<
  typeof useOrganizationSettingsLazyQuery
>;
export type OrganizationSettingsSuspenseQueryHookResult = ReturnType<
  typeof useOrganizationSettingsSuspenseQuery
>;
export type OrganizationSettingsQueryResult = Apollo.QueryResult<
  OrganizationSettingsQuery,
  OrganizationSettingsQueryVariables
>;
export const OwnersDocument = gql`
  query Owners {
    articles {
      owners {
        id
        name
        fullName {
          givenName
          middleNames
          familyName
        }
        avatarUrl
      }
    }
  }
`;

/**
 * __useOwnersQuery__
 *
 * To run a query within a React component, call `useOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOwnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useOwnersQuery(
  baseOptions?: Apollo.QueryHookOptions<OwnersQuery, OwnersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OwnersQuery, OwnersQueryVariables>(
    OwnersDocument,
    options,
  );
}
export function useOwnersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OwnersQuery, OwnersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OwnersQuery, OwnersQueryVariables>(
    OwnersDocument,
    options,
  );
}
// @ts-ignore
export function useOwnersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OwnersQuery,
    OwnersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<OwnersQuery, OwnersQueryVariables>;
export function useOwnersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OwnersQuery, OwnersQueryVariables>,
): Apollo.UseSuspenseQueryResult<OwnersQuery | undefined, OwnersQueryVariables>;
export function useOwnersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OwnersQuery, OwnersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OwnersQuery, OwnersQueryVariables>(
    OwnersDocument,
    options,
  );
}
export type OwnersQueryHookResult = ReturnType<typeof useOwnersQuery>;
export type OwnersLazyQueryHookResult = ReturnType<typeof useOwnersLazyQuery>;
export type OwnersSuspenseQueryHookResult = ReturnType<
  typeof useOwnersSuspenseQuery
>;
export type OwnersQueryResult = Apollo.QueryResult<
  OwnersQuery,
  OwnersQueryVariables
>;
export const ParentAddChildDocument = gql`
  mutation ParentAddChild($childId: ID!, $parentId: ID!) {
    parentAddChild(childId: $childId, parentId: $parentId) {
      id
    }
  }
`;
export type ParentAddChildMutationFn = Apollo.MutationFunction<
  ParentAddChildMutation,
  ParentAddChildMutationVariables
>;

/**
 * __useParentAddChildMutation__
 *
 * To run a mutation, you first call `useParentAddChildMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParentAddChildMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parentAddChildMutation, { data, loading, error }] = useParentAddChildMutation({
 *   variables: {
 *      childId: // value for 'childId'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useParentAddChildMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ParentAddChildMutation,
    ParentAddChildMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ParentAddChildMutation,
    ParentAddChildMutationVariables
  >(ParentAddChildDocument, options);
}
export type ParentAddChildMutationHookResult = ReturnType<
  typeof useParentAddChildMutation
>;
export type ParentAddChildMutationResult =
  Apollo.MutationResult<ParentAddChildMutation>;
export type ParentAddChildMutationOptions = Apollo.BaseMutationOptions<
  ParentAddChildMutation,
  ParentAddChildMutationVariables
>;
export const SettingsDocument = gql`
  query Settings {
    settings {
      ...SettingsFields
    }
  }
  ${SettingsFieldsFragmentDoc}
`;

/**
 * __useSettingsQuery__
 *
 * To run a query within a React component, call `useSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<SettingsQuery, SettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SettingsQuery, SettingsQueryVariables>(
    SettingsDocument,
    options,
  );
}
export function useSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SettingsQuery,
    SettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SettingsQuery, SettingsQueryVariables>(
    SettingsDocument,
    options,
  );
}
// @ts-ignore
export function useSettingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SettingsQuery,
    SettingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SettingsQuery, SettingsQueryVariables>;
export function useSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SettingsQuery, SettingsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  SettingsQuery | undefined,
  SettingsQueryVariables
>;
export function useSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SettingsQuery, SettingsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SettingsQuery, SettingsQueryVariables>(
    SettingsDocument,
    options,
  );
}
export type SettingsQueryHookResult = ReturnType<typeof useSettingsQuery>;
export type SettingsLazyQueryHookResult = ReturnType<
  typeof useSettingsLazyQuery
>;
export type SettingsSuspenseQueryHookResult = ReturnType<
  typeof useSettingsSuspenseQuery
>;
export type SettingsQueryResult = Apollo.QueryResult<
  SettingsQuery,
  SettingsQueryVariables
>;
export const SetupOrganisationDocument = gql`
  mutation SetupOrganisation {
    setupOrganisation {
      id
      title
    }
  }
`;
export type SetupOrganisationMutationFn = Apollo.MutationFunction<
  SetupOrganisationMutation,
  SetupOrganisationMutationVariables
>;

/**
 * __useSetupOrganisationMutation__
 *
 * To run a mutation, you first call `useSetupOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupOrganisationMutation, { data, loading, error }] = useSetupOrganisationMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetupOrganisationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetupOrganisationMutation,
    SetupOrganisationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetupOrganisationMutation,
    SetupOrganisationMutationVariables
  >(SetupOrganisationDocument, options);
}
export type SetupOrganisationMutationHookResult = ReturnType<
  typeof useSetupOrganisationMutation
>;
export type SetupOrganisationMutationResult =
  Apollo.MutationResult<SetupOrganisationMutation>;
export type SetupOrganisationMutationOptions = Apollo.BaseMutationOptions<
  SetupOrganisationMutation,
  SetupOrganisationMutationVariables
>;
export const AiDraftByCsidDocument = gql`
  query AiDraftByCsid($csid: Long!) {
    aiDraftByCsid(csid: $csid) {
      ...AiDraftListItem
    }
  }
  ${AiDraftListItemFragmentDoc}
`;

/**
 * __useAiDraftByCsidQuery__
 *
 * To run a query within a React component, call `useAiDraftByCsidQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiDraftByCsidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDraftByCsidQuery({
 *   variables: {
 *      csid: // value for 'csid'
 *   },
 * });
 */
export function useAiDraftByCsidQuery(
  baseOptions: Apollo.QueryHookOptions<
    AiDraftByCsidQuery,
    AiDraftByCsidQueryVariables
  > &
    (
      | { variables: AiDraftByCsidQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiDraftByCsidQuery, AiDraftByCsidQueryVariables>(
    AiDraftByCsidDocument,
    options,
  );
}
export function useAiDraftByCsidLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiDraftByCsidQuery,
    AiDraftByCsidQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AiDraftByCsidQuery, AiDraftByCsidQueryVariables>(
    AiDraftByCsidDocument,
    options,
  );
}
// @ts-ignore
export function useAiDraftByCsidSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiDraftByCsidQuery,
    AiDraftByCsidQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AiDraftByCsidQuery,
  AiDraftByCsidQueryVariables
>;
export function useAiDraftByCsidSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiDraftByCsidQuery,
        AiDraftByCsidQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AiDraftByCsidQuery | undefined,
  AiDraftByCsidQueryVariables
>;
export function useAiDraftByCsidSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiDraftByCsidQuery,
        AiDraftByCsidQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AiDraftByCsidQuery,
    AiDraftByCsidQueryVariables
  >(AiDraftByCsidDocument, options);
}
export type AiDraftByCsidQueryHookResult = ReturnType<
  typeof useAiDraftByCsidQuery
>;
export type AiDraftByCsidLazyQueryHookResult = ReturnType<
  typeof useAiDraftByCsidLazyQuery
>;
export type AiDraftByCsidSuspenseQueryHookResult = ReturnType<
  typeof useAiDraftByCsidSuspenseQuery
>;
export type AiDraftByCsidQueryResult = Apollo.QueryResult<
  AiDraftByCsidQuery,
  AiDraftByCsidQueryVariables
>;
export const AiDraftDeleteDocument = gql`
  mutation AiDraftDelete($id: ID!) {
    aiDraftDelete(id: $id)
  }
`;
export type AiDraftDeleteMutationFn = Apollo.MutationFunction<
  AiDraftDeleteMutation,
  AiDraftDeleteMutationVariables
>;

/**
 * __useAiDraftDeleteMutation__
 *
 * To run a mutation, you first call `useAiDraftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiDraftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiDraftDeleteMutation, { data, loading, error }] = useAiDraftDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiDraftDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AiDraftDeleteMutation,
    AiDraftDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AiDraftDeleteMutation,
    AiDraftDeleteMutationVariables
  >(AiDraftDeleteDocument, options);
}
export type AiDraftDeleteMutationHookResult = ReturnType<
  typeof useAiDraftDeleteMutation
>;
export type AiDraftDeleteMutationResult =
  Apollo.MutationResult<AiDraftDeleteMutation>;
export type AiDraftDeleteMutationOptions = Apollo.BaseMutationOptions<
  AiDraftDeleteMutation,
  AiDraftDeleteMutationVariables
>;
export const AiDraftGenerateDocument = gql`
  mutation AiDraftGenerate(
    $csid: Long!
    $languageId: LanguageId!
    $collectionId: ID
    $categoryId: ID
  ) {
    aiDraftGenerate(
      csid: $csid
      languageId: $languageId
      collectionId: $collectionId
      categoryId: $categoryId
    ) {
      ...AiDraftListItem
    }
  }
  ${AiDraftListItemFragmentDoc}
`;
export type AiDraftGenerateMutationFn = Apollo.MutationFunction<
  AiDraftGenerateMutation,
  AiDraftGenerateMutationVariables
>;

/**
 * __useAiDraftGenerateMutation__
 *
 * To run a mutation, you first call `useAiDraftGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiDraftGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiDraftGenerateMutation, { data, loading, error }] = useAiDraftGenerateMutation({
 *   variables: {
 *      csid: // value for 'csid'
 *      languageId: // value for 'languageId'
 *      collectionId: // value for 'collectionId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useAiDraftGenerateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AiDraftGenerateMutation,
    AiDraftGenerateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AiDraftGenerateMutation,
    AiDraftGenerateMutationVariables
  >(AiDraftGenerateDocument, options);
}
export type AiDraftGenerateMutationHookResult = ReturnType<
  typeof useAiDraftGenerateMutation
>;
export type AiDraftGenerateMutationResult =
  Apollo.MutationResult<AiDraftGenerateMutation>;
export type AiDraftGenerateMutationOptions = Apollo.BaseMutationOptions<
  AiDraftGenerateMutation,
  AiDraftGenerateMutationVariables
>;
export const AiDraftLiveUpdateDocument = gql`
  query AiDraftLiveUpdate($id: ID!) {
    aiDraft(id: $id) {
      ...AiDraftListItem
      approvedAt
      rejectedAt
    }
  }
  ${AiDraftListItemFragmentDoc}
`;

/**
 * __useAiDraftLiveUpdateQuery__
 *
 * To run a query within a React component, call `useAiDraftLiveUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiDraftLiveUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDraftLiveUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiDraftLiveUpdateQuery(
  baseOptions: Apollo.QueryHookOptions<
    AiDraftLiveUpdateQuery,
    AiDraftLiveUpdateQueryVariables
  > &
    (
      | { variables: AiDraftLiveUpdateQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AiDraftLiveUpdateQuery,
    AiDraftLiveUpdateQueryVariables
  >(AiDraftLiveUpdateDocument, options);
}
export function useAiDraftLiveUpdateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiDraftLiveUpdateQuery,
    AiDraftLiveUpdateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AiDraftLiveUpdateQuery,
    AiDraftLiveUpdateQueryVariables
  >(AiDraftLiveUpdateDocument, options);
}
// @ts-ignore
export function useAiDraftLiveUpdateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiDraftLiveUpdateQuery,
    AiDraftLiveUpdateQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AiDraftLiveUpdateQuery,
  AiDraftLiveUpdateQueryVariables
>;
export function useAiDraftLiveUpdateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiDraftLiveUpdateQuery,
        AiDraftLiveUpdateQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AiDraftLiveUpdateQuery | undefined,
  AiDraftLiveUpdateQueryVariables
>;
export function useAiDraftLiveUpdateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiDraftLiveUpdateQuery,
        AiDraftLiveUpdateQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AiDraftLiveUpdateQuery,
    AiDraftLiveUpdateQueryVariables
  >(AiDraftLiveUpdateDocument, options);
}
export type AiDraftLiveUpdateQueryHookResult = ReturnType<
  typeof useAiDraftLiveUpdateQuery
>;
export type AiDraftLiveUpdateLazyQueryHookResult = ReturnType<
  typeof useAiDraftLiveUpdateLazyQuery
>;
export type AiDraftLiveUpdateSuspenseQueryHookResult = ReturnType<
  typeof useAiDraftLiveUpdateSuspenseQuery
>;
export type AiDraftLiveUpdateQueryResult = Apollo.QueryResult<
  AiDraftLiveUpdateQuery,
  AiDraftLiveUpdateQueryVariables
>;
export const AiSettingsAccessDocument = gql`
  query AiSettingsAccess {
    settings {
      userPermissions {
        languageSettings
      }
    }
  }
`;

/**
 * __useAiSettingsAccessQuery__
 *
 * To run a query within a React component, call `useAiSettingsAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiSettingsAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSettingsAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useAiSettingsAccessQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AiSettingsAccessQuery,
    AiSettingsAccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiSettingsAccessQuery, AiSettingsAccessQueryVariables>(
    AiSettingsAccessDocument,
    options,
  );
}
export function useAiSettingsAccessLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiSettingsAccessQuery,
    AiSettingsAccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AiSettingsAccessQuery,
    AiSettingsAccessQueryVariables
  >(AiSettingsAccessDocument, options);
}
// @ts-ignore
export function useAiSettingsAccessSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiSettingsAccessQuery,
    AiSettingsAccessQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AiSettingsAccessQuery,
  AiSettingsAccessQueryVariables
>;
export function useAiSettingsAccessSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiSettingsAccessQuery,
        AiSettingsAccessQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AiSettingsAccessQuery | undefined,
  AiSettingsAccessQueryVariables
>;
export function useAiSettingsAccessSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiSettingsAccessQuery,
        AiSettingsAccessQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AiSettingsAccessQuery,
    AiSettingsAccessQueryVariables
  >(AiSettingsAccessDocument, options);
}
export type AiSettingsAccessQueryHookResult = ReturnType<
  typeof useAiSettingsAccessQuery
>;
export type AiSettingsAccessLazyQueryHookResult = ReturnType<
  typeof useAiSettingsAccessLazyQuery
>;
export type AiSettingsAccessSuspenseQueryHookResult = ReturnType<
  typeof useAiSettingsAccessSuspenseQuery
>;
export type AiSettingsAccessQueryResult = Apollo.QueryResult<
  AiSettingsAccessQuery,
  AiSettingsAccessQueryVariables
>;
export const AiSettingsDraftUpdateDocument = gql`
  mutation AiSettingsDraftUpdate(
    $judgeInstructions: String
    $writerInstructions: String
    $minSimilarConversations: Int!
    $similarity: SimilarityLevel!
  ) {
    organisationUpdateAiSettingsDraft(
      judgeInstructions: $judgeInstructions
      writerInstructions: $writerInstructions
      minSimilarConversations: $minSimilarConversations
      similarity: $similarity
    ) {
      ...AiSettingsVersion
    }
  }
  ${AiSettingsVersionFragmentDoc}
`;
export type AiSettingsDraftUpdateMutationFn = Apollo.MutationFunction<
  AiSettingsDraftUpdateMutation,
  AiSettingsDraftUpdateMutationVariables
>;

/**
 * __useAiSettingsDraftUpdateMutation__
 *
 * To run a mutation, you first call `useAiSettingsDraftUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiSettingsDraftUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiSettingsDraftUpdateMutation, { data, loading, error }] = useAiSettingsDraftUpdateMutation({
 *   variables: {
 *      judgeInstructions: // value for 'judgeInstructions'
 *      writerInstructions: // value for 'writerInstructions'
 *      minSimilarConversations: // value for 'minSimilarConversations'
 *      similarity: // value for 'similarity'
 *   },
 * });
 */
export function useAiSettingsDraftUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AiSettingsDraftUpdateMutation,
    AiSettingsDraftUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AiSettingsDraftUpdateMutation,
    AiSettingsDraftUpdateMutationVariables
  >(AiSettingsDraftUpdateDocument, options);
}
export type AiSettingsDraftUpdateMutationHookResult = ReturnType<
  typeof useAiSettingsDraftUpdateMutation
>;
export type AiSettingsDraftUpdateMutationResult =
  Apollo.MutationResult<AiSettingsDraftUpdateMutation>;
export type AiSettingsDraftUpdateMutationOptions = Apollo.BaseMutationOptions<
  AiSettingsDraftUpdateMutation,
  AiSettingsDraftUpdateMutationVariables
>;
export const AiSettingsVersionActivateDocument = gql`
  mutation AiSettingsVersionActivate($id: ID!) {
    organisationActivateAiSettingsVersion(id: $id) {
      ...AiSettingsVersion
    }
  }
  ${AiSettingsVersionFragmentDoc}
`;
export type AiSettingsVersionActivateMutationFn = Apollo.MutationFunction<
  AiSettingsVersionActivateMutation,
  AiSettingsVersionActivateMutationVariables
>;

/**
 * __useAiSettingsVersionActivateMutation__
 *
 * To run a mutation, you first call `useAiSettingsVersionActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiSettingsVersionActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiSettingsVersionActivateMutation, { data, loading, error }] = useAiSettingsVersionActivateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiSettingsVersionActivateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AiSettingsVersionActivateMutation,
    AiSettingsVersionActivateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AiSettingsVersionActivateMutation,
    AiSettingsVersionActivateMutationVariables
  >(AiSettingsVersionActivateDocument, options);
}
export type AiSettingsVersionActivateMutationHookResult = ReturnType<
  typeof useAiSettingsVersionActivateMutation
>;
export type AiSettingsVersionActivateMutationResult =
  Apollo.MutationResult<AiSettingsVersionActivateMutation>;
export type AiSettingsVersionActivateMutationOptions =
  Apollo.BaseMutationOptions<
    AiSettingsVersionActivateMutation,
    AiSettingsVersionActivateMutationVariables
  >;
export const AiSettingsVersionCreateDocument = gql`
  mutation AiSettingsVersionCreate($name: String!, $activate: Boolean!) {
    organisationCreateAiSettingsVersion(name: $name, activate: $activate) {
      ...AiSettingsVersion
    }
  }
  ${AiSettingsVersionFragmentDoc}
`;
export type AiSettingsVersionCreateMutationFn = Apollo.MutationFunction<
  AiSettingsVersionCreateMutation,
  AiSettingsVersionCreateMutationVariables
>;

/**
 * __useAiSettingsVersionCreateMutation__
 *
 * To run a mutation, you first call `useAiSettingsVersionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiSettingsVersionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiSettingsVersionCreateMutation, { data, loading, error }] = useAiSettingsVersionCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      activate: // value for 'activate'
 *   },
 * });
 */
export function useAiSettingsVersionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AiSettingsVersionCreateMutation,
    AiSettingsVersionCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AiSettingsVersionCreateMutation,
    AiSettingsVersionCreateMutationVariables
  >(AiSettingsVersionCreateDocument, options);
}
export type AiSettingsVersionCreateMutationHookResult = ReturnType<
  typeof useAiSettingsVersionCreateMutation
>;
export type AiSettingsVersionCreateMutationResult =
  Apollo.MutationResult<AiSettingsVersionCreateMutation>;
export type AiSettingsVersionCreateMutationOptions = Apollo.BaseMutationOptions<
  AiSettingsVersionCreateMutation,
  AiSettingsVersionCreateMutationVariables
>;
export const AiSettingsVersionDocument = gql`
  query AiSettingsVersion($id: ID) {
    aiSettingsVersion(id: $id) {
      ...AiSettingsVersion
    }
  }
  ${AiSettingsVersionFragmentDoc}
`;

/**
 * __useAiSettingsVersionQuery__
 *
 * To run a query within a React component, call `useAiSettingsVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiSettingsVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSettingsVersionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiSettingsVersionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AiSettingsVersionQuery,
    AiSettingsVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AiSettingsVersionQuery,
    AiSettingsVersionQueryVariables
  >(AiSettingsVersionDocument, options);
}
export function useAiSettingsVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiSettingsVersionQuery,
    AiSettingsVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AiSettingsVersionQuery,
    AiSettingsVersionQueryVariables
  >(AiSettingsVersionDocument, options);
}
// @ts-ignore
export function useAiSettingsVersionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiSettingsVersionQuery,
    AiSettingsVersionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AiSettingsVersionQuery,
  AiSettingsVersionQueryVariables
>;
export function useAiSettingsVersionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiSettingsVersionQuery,
        AiSettingsVersionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AiSettingsVersionQuery | undefined,
  AiSettingsVersionQueryVariables
>;
export function useAiSettingsVersionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiSettingsVersionQuery,
        AiSettingsVersionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AiSettingsVersionQuery,
    AiSettingsVersionQueryVariables
  >(AiSettingsVersionDocument, options);
}
export type AiSettingsVersionQueryHookResult = ReturnType<
  typeof useAiSettingsVersionQuery
>;
export type AiSettingsVersionLazyQueryHookResult = ReturnType<
  typeof useAiSettingsVersionLazyQuery
>;
export type AiSettingsVersionSuspenseQueryHookResult = ReturnType<
  typeof useAiSettingsVersionSuspenseQuery
>;
export type AiSettingsVersionQueryResult = Apollo.QueryResult<
  AiSettingsVersionQuery,
  AiSettingsVersionQueryVariables
>;
export const AiSettingsVersionRenameDocument = gql`
  mutation AiSettingsVersionRename($id: ID!, $name: String!) {
    organisationRenameAiSettingsVersion(id: $id, name: $name) {
      ...AiSettingsVersion
    }
  }
  ${AiSettingsVersionFragmentDoc}
`;
export type AiSettingsVersionRenameMutationFn = Apollo.MutationFunction<
  AiSettingsVersionRenameMutation,
  AiSettingsVersionRenameMutationVariables
>;

/**
 * __useAiSettingsVersionRenameMutation__
 *
 * To run a mutation, you first call `useAiSettingsVersionRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiSettingsVersionRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiSettingsVersionRenameMutation, { data, loading, error }] = useAiSettingsVersionRenameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAiSettingsVersionRenameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AiSettingsVersionRenameMutation,
    AiSettingsVersionRenameMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AiSettingsVersionRenameMutation,
    AiSettingsVersionRenameMutationVariables
  >(AiSettingsVersionRenameDocument, options);
}
export type AiSettingsVersionRenameMutationHookResult = ReturnType<
  typeof useAiSettingsVersionRenameMutation
>;
export type AiSettingsVersionRenameMutationResult =
  Apollo.MutationResult<AiSettingsVersionRenameMutation>;
export type AiSettingsVersionRenameMutationOptions = Apollo.BaseMutationOptions<
  AiSettingsVersionRenameMutation,
  AiSettingsVersionRenameMutationVariables
>;
export const AiSettingsVersionsDocument = gql`
  query AiSettingsVersions {
    aiSettingsVersions {
      id
      version
      name
      isActive
      createdAt
    }
  }
`;

/**
 * __useAiSettingsVersionsQuery__
 *
 * To run a query within a React component, call `useAiSettingsVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiSettingsVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSettingsVersionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAiSettingsVersionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AiSettingsVersionsQuery,
    AiSettingsVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AiSettingsVersionsQuery,
    AiSettingsVersionsQueryVariables
  >(AiSettingsVersionsDocument, options);
}
export function useAiSettingsVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiSettingsVersionsQuery,
    AiSettingsVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AiSettingsVersionsQuery,
    AiSettingsVersionsQueryVariables
  >(AiSettingsVersionsDocument, options);
}
// @ts-ignore
export function useAiSettingsVersionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiSettingsVersionsQuery,
    AiSettingsVersionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AiSettingsVersionsQuery,
  AiSettingsVersionsQueryVariables
>;
export function useAiSettingsVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiSettingsVersionsQuery,
        AiSettingsVersionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AiSettingsVersionsQuery | undefined,
  AiSettingsVersionsQueryVariables
>;
export function useAiSettingsVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiSettingsVersionsQuery,
        AiSettingsVersionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AiSettingsVersionsQuery,
    AiSettingsVersionsQueryVariables
  >(AiSettingsVersionsDocument, options);
}
export type AiSettingsVersionsQueryHookResult = ReturnType<
  typeof useAiSettingsVersionsQuery
>;
export type AiSettingsVersionsLazyQueryHookResult = ReturnType<
  typeof useAiSettingsVersionsLazyQuery
>;
export type AiSettingsVersionsSuspenseQueryHookResult = ReturnType<
  typeof useAiSettingsVersionsSuspenseQuery
>;
export type AiSettingsVersionsQueryResult = Apollo.QueryResult<
  AiSettingsVersionsQuery,
  AiSettingsVersionsQueryVariables
>;
export const ArticleEditorDocument = gql`
  query ArticleEditor($id: ID!) {
    article(id: $id) {
      ...ArticleFullFields
    }
  }
  ${ArticleFullFieldsFragmentDoc}
`;

/**
 * __useArticleEditorQuery__
 *
 * To run a query within a React component, call `useArticleEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleEditorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticleEditorQuery(
  baseOptions: Apollo.QueryHookOptions<
    ArticleEditorQuery,
    ArticleEditorQueryVariables
  > &
    (
      | { variables: ArticleEditorQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArticleEditorQuery, ArticleEditorQueryVariables>(
    ArticleEditorDocument,
    options,
  );
}
export function useArticleEditorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticleEditorQuery,
    ArticleEditorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArticleEditorQuery, ArticleEditorQueryVariables>(
    ArticleEditorDocument,
    options,
  );
}
// @ts-ignore
export function useArticleEditorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticleEditorQuery,
    ArticleEditorQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ArticleEditorQuery,
  ArticleEditorQueryVariables
>;
export function useArticleEditorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleEditorQuery,
        ArticleEditorQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ArticleEditorQuery | undefined,
  ArticleEditorQueryVariables
>;
export function useArticleEditorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleEditorQuery,
        ArticleEditorQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ArticleEditorQuery,
    ArticleEditorQueryVariables
  >(ArticleEditorDocument, options);
}
export type ArticleEditorQueryHookResult = ReturnType<
  typeof useArticleEditorQuery
>;
export type ArticleEditorLazyQueryHookResult = ReturnType<
  typeof useArticleEditorLazyQuery
>;
export type ArticleEditorSuspenseQueryHookResult = ReturnType<
  typeof useArticleEditorSuspenseQuery
>;
export type ArticleEditorQueryResult = Apollo.QueryResult<
  ArticleEditorQuery,
  ArticleEditorQueryVariables
>;
export const ArticleHasChangesDocument = gql`
  query ArticleHasChanges($articleId: ID!) {
    article(id: $articleId) {
      id
      translations {
        draft {
          articleId
          languageId
          publicationStatus
        }
      }
    }
  }
`;

/**
 * __useArticleHasChangesQuery__
 *
 * To run a query within a React component, call `useArticleHasChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleHasChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleHasChangesQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useArticleHasChangesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ArticleHasChangesQuery,
    ArticleHasChangesQueryVariables
  > &
    (
      | { variables: ArticleHasChangesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ArticleHasChangesQuery,
    ArticleHasChangesQueryVariables
  >(ArticleHasChangesDocument, options);
}
export function useArticleHasChangesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticleHasChangesQuery,
    ArticleHasChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ArticleHasChangesQuery,
    ArticleHasChangesQueryVariables
  >(ArticleHasChangesDocument, options);
}
// @ts-ignore
export function useArticleHasChangesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticleHasChangesQuery,
    ArticleHasChangesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ArticleHasChangesQuery,
  ArticleHasChangesQueryVariables
>;
export function useArticleHasChangesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleHasChangesQuery,
        ArticleHasChangesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ArticleHasChangesQuery | undefined,
  ArticleHasChangesQueryVariables
>;
export function useArticleHasChangesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleHasChangesQuery,
        ArticleHasChangesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ArticleHasChangesQuery,
    ArticleHasChangesQueryVariables
  >(ArticleHasChangesDocument, options);
}
export type ArticleHasChangesQueryHookResult = ReturnType<
  typeof useArticleHasChangesQuery
>;
export type ArticleHasChangesLazyQueryHookResult = ReturnType<
  typeof useArticleHasChangesLazyQuery
>;
export type ArticleHasChangesSuspenseQueryHookResult = ReturnType<
  typeof useArticleHasChangesSuspenseQuery
>;
export type ArticleHasChangesQueryResult = Apollo.QueryResult<
  ArticleHasChangesQuery,
  ArticleHasChangesQueryVariables
>;
export const ArticleLinkLookupDocument = gql`
  query ArticleLinkLookup(
    $languageId: LanguageId!
    $filters: ArticleFiltersInput
    $query: ArticleSearchInput
  ) {
    articles(limit: 15, offset: 0) {
      query(query: $query, filters: $filters) {
        results {
          id
          title(languageId: $languageId)
          parentCategories {
            id
            title(languageId: $languageId)
          }
        }
      }
    }
  }
`;

/**
 * __useArticleLinkLookupQuery__
 *
 * To run a query within a React component, call `useArticleLinkLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleLinkLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleLinkLookupQuery({
 *   variables: {
 *      languageId: // value for 'languageId'
 *      filters: // value for 'filters'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useArticleLinkLookupQuery(
  baseOptions: Apollo.QueryHookOptions<
    ArticleLinkLookupQuery,
    ArticleLinkLookupQueryVariables
  > &
    (
      | { variables: ArticleLinkLookupQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ArticleLinkLookupQuery,
    ArticleLinkLookupQueryVariables
  >(ArticleLinkLookupDocument, options);
}
export function useArticleLinkLookupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticleLinkLookupQuery,
    ArticleLinkLookupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ArticleLinkLookupQuery,
    ArticleLinkLookupQueryVariables
  >(ArticleLinkLookupDocument, options);
}
// @ts-ignore
export function useArticleLinkLookupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticleLinkLookupQuery,
    ArticleLinkLookupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ArticleLinkLookupQuery,
  ArticleLinkLookupQueryVariables
>;
export function useArticleLinkLookupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleLinkLookupQuery,
        ArticleLinkLookupQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ArticleLinkLookupQuery | undefined,
  ArticleLinkLookupQueryVariables
>;
export function useArticleLinkLookupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleLinkLookupQuery,
        ArticleLinkLookupQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ArticleLinkLookupQuery,
    ArticleLinkLookupQueryVariables
  >(ArticleLinkLookupDocument, options);
}
export type ArticleLinkLookupQueryHookResult = ReturnType<
  typeof useArticleLinkLookupQuery
>;
export type ArticleLinkLookupLazyQueryHookResult = ReturnType<
  typeof useArticleLinkLookupLazyQuery
>;
export type ArticleLinkLookupSuspenseQueryHookResult = ReturnType<
  typeof useArticleLinkLookupSuspenseQuery
>;
export type ArticleLinkLookupQueryResult = Apollo.QueryResult<
  ArticleLinkLookupQuery,
  ArticleLinkLookupQueryVariables
>;
export const ArticlePublishDocument = gql`
  mutation ArticlePublish($articleId: ID!) {
    articlePublish(articleId: $articleId) {
      ...ArticleFullFields
    }
  }
  ${ArticleFullFieldsFragmentDoc}
`;
export type ArticlePublishMutationFn = Apollo.MutationFunction<
  ArticlePublishMutation,
  ArticlePublishMutationVariables
>;

/**
 * __useArticlePublishMutation__
 *
 * To run a mutation, you first call `useArticlePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticlePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articlePublishMutation, { data, loading, error }] = useArticlePublishMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useArticlePublishMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticlePublishMutation,
    ArticlePublishMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArticlePublishMutation,
    ArticlePublishMutationVariables
  >(ArticlePublishDocument, options);
}
export type ArticlePublishMutationHookResult = ReturnType<
  typeof useArticlePublishMutation
>;
export type ArticlePublishMutationResult =
  Apollo.MutationResult<ArticlePublishMutation>;
export type ArticlePublishMutationOptions = Apollo.BaseMutationOptions<
  ArticlePublishMutation,
  ArticlePublishMutationVariables
>;
export const ArticleTranslationDeleteDocument = gql`
  mutation ArticleTranslationDelete($articleId: ID!, $languageId: LanguageId!) {
    articleTranslationDelete(articleId: $articleId, languageId: $languageId)
  }
`;
export type ArticleTranslationDeleteMutationFn = Apollo.MutationFunction<
  ArticleTranslationDeleteMutation,
  ArticleTranslationDeleteMutationVariables
>;

/**
 * __useArticleTranslationDeleteMutation__
 *
 * To run a mutation, you first call `useArticleTranslationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleTranslationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleTranslationDeleteMutation, { data, loading, error }] = useArticleTranslationDeleteMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      languageId: // value for 'languageId'
 *   },
 * });
 */
export function useArticleTranslationDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticleTranslationDeleteMutation,
    ArticleTranslationDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArticleTranslationDeleteMutation,
    ArticleTranslationDeleteMutationVariables
  >(ArticleTranslationDeleteDocument, options);
}
export type ArticleTranslationDeleteMutationHookResult = ReturnType<
  typeof useArticleTranslationDeleteMutation
>;
export type ArticleTranslationDeleteMutationResult =
  Apollo.MutationResult<ArticleTranslationDeleteMutation>;
export type ArticleTranslationDeleteMutationOptions =
  Apollo.BaseMutationOptions<
    ArticleTranslationDeleteMutation,
    ArticleTranslationDeleteMutationVariables
  >;
export const ArticleTranslationDraftCreateDocument = gql`
  mutation ArticleTranslationDraftCreate(
    $articleId: ID!
    $languageId: LanguageId!
    $title: NonEmptyString!
    $content: ContentJson!
  ) {
    articleTranslationCreate(
      articleId: $articleId
      languageId: $languageId
      title: $title
      content: $content
    ) {
      ...ArticleTranslationFields
    }
  }
  ${ArticleTranslationFieldsFragmentDoc}
`;
export type ArticleTranslationDraftCreateMutationFn = Apollo.MutationFunction<
  ArticleTranslationDraftCreateMutation,
  ArticleTranslationDraftCreateMutationVariables
>;

/**
 * __useArticleTranslationDraftCreateMutation__
 *
 * To run a mutation, you first call `useArticleTranslationDraftCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleTranslationDraftCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleTranslationDraftCreateMutation, { data, loading, error }] = useArticleTranslationDraftCreateMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      languageId: // value for 'languageId'
 *      title: // value for 'title'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useArticleTranslationDraftCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticleTranslationDraftCreateMutation,
    ArticleTranslationDraftCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArticleTranslationDraftCreateMutation,
    ArticleTranslationDraftCreateMutationVariables
  >(ArticleTranslationDraftCreateDocument, options);
}
export type ArticleTranslationDraftCreateMutationHookResult = ReturnType<
  typeof useArticleTranslationDraftCreateMutation
>;
export type ArticleTranslationDraftCreateMutationResult =
  Apollo.MutationResult<ArticleTranslationDraftCreateMutation>;
export type ArticleTranslationDraftCreateMutationOptions =
  Apollo.BaseMutationOptions<
    ArticleTranslationDraftCreateMutation,
    ArticleTranslationDraftCreateMutationVariables
  >;
export const ArticleTranslationDraftUpdateDocument = gql`
  mutation ArticleTranslationDraftUpdate(
    $articleId: ID!
    $languageId: LanguageId!
    $title: NonEmptyString!
    $content: ContentJson!
    $titleUpdatedAt: String
    $titleTranslatedAt: String
  ) {
    articleTranslationUpdate(
      articleId: $articleId
      languageId: $languageId
      title: $title
      content: $content
      titleUpdatedAt: $titleUpdatedAt
      titleTranslatedAt: $titleTranslatedAt
    ) {
      ...ArticleTranslationFields
    }
  }
  ${ArticleTranslationFieldsFragmentDoc}
`;
export type ArticleTranslationDraftUpdateMutationFn = Apollo.MutationFunction<
  ArticleTranslationDraftUpdateMutation,
  ArticleTranslationDraftUpdateMutationVariables
>;

/**
 * __useArticleTranslationDraftUpdateMutation__
 *
 * To run a mutation, you first call `useArticleTranslationDraftUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleTranslationDraftUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleTranslationDraftUpdateMutation, { data, loading, error }] = useArticleTranslationDraftUpdateMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      languageId: // value for 'languageId'
 *      title: // value for 'title'
 *      content: // value for 'content'
 *      titleUpdatedAt: // value for 'titleUpdatedAt'
 *      titleTranslatedAt: // value for 'titleTranslatedAt'
 *   },
 * });
 */
export function useArticleTranslationDraftUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticleTranslationDraftUpdateMutation,
    ArticleTranslationDraftUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArticleTranslationDraftUpdateMutation,
    ArticleTranslationDraftUpdateMutationVariables
  >(ArticleTranslationDraftUpdateDocument, options);
}
export type ArticleTranslationDraftUpdateMutationHookResult = ReturnType<
  typeof useArticleTranslationDraftUpdateMutation
>;
export type ArticleTranslationDraftUpdateMutationResult =
  Apollo.MutationResult<ArticleTranslationDraftUpdateMutation>;
export type ArticleTranslationDraftUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    ArticleTranslationDraftUpdateMutation,
    ArticleTranslationDraftUpdateMutationVariables
  >;
export const ArticleTranslationDocument = gql`
  query ArticleTranslation($id: ID!, $languageId: LanguageId!) {
    articleTranslation(id: $id, languageId: $languageId) {
      articleId
      publicationStatus
      draft {
        ...ArticleTranslationFields
      }
    }
  }
  ${ArticleTranslationFieldsFragmentDoc}
`;

/**
 * __useArticleTranslationQuery__
 *
 * To run a query within a React component, call `useArticleTranslationQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleTranslationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleTranslationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      languageId: // value for 'languageId'
 *   },
 * });
 */
export function useArticleTranslationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ArticleTranslationQuery,
    ArticleTranslationQueryVariables
  > &
    (
      | { variables: ArticleTranslationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ArticleTranslationQuery,
    ArticleTranslationQueryVariables
  >(ArticleTranslationDocument, options);
}
export function useArticleTranslationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticleTranslationQuery,
    ArticleTranslationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ArticleTranslationQuery,
    ArticleTranslationQueryVariables
  >(ArticleTranslationDocument, options);
}
// @ts-ignore
export function useArticleTranslationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticleTranslationQuery,
    ArticleTranslationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ArticleTranslationQuery,
  ArticleTranslationQueryVariables
>;
export function useArticleTranslationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleTranslationQuery,
        ArticleTranslationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ArticleTranslationQuery | undefined,
  ArticleTranslationQueryVariables
>;
export function useArticleTranslationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleTranslationQuery,
        ArticleTranslationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ArticleTranslationQuery,
    ArticleTranslationQueryVariables
  >(ArticleTranslationDocument, options);
}
export type ArticleTranslationQueryHookResult = ReturnType<
  typeof useArticleTranslationQuery
>;
export type ArticleTranslationLazyQueryHookResult = ReturnType<
  typeof useArticleTranslationLazyQuery
>;
export type ArticleTranslationSuspenseQueryHookResult = ReturnType<
  typeof useArticleTranslationSuspenseQuery
>;
export type ArticleTranslationQueryResult = Apollo.QueryResult<
  ArticleTranslationQuery,
  ArticleTranslationQueryVariables
>;
export const ArticleTranslationPublishDocument = gql`
  mutation ArticleTranslationPublish(
    $articleId: ID!
    $languageId: LanguageId!
  ) {
    articleTranslationPublish(articleId: $articleId, languageId: $languageId)
  }
`;
export type ArticleTranslationPublishMutationFn = Apollo.MutationFunction<
  ArticleTranslationPublishMutation,
  ArticleTranslationPublishMutationVariables
>;

/**
 * __useArticleTranslationPublishMutation__
 *
 * To run a mutation, you first call `useArticleTranslationPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleTranslationPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleTranslationPublishMutation, { data, loading, error }] = useArticleTranslationPublishMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      languageId: // value for 'languageId'
 *   },
 * });
 */
export function useArticleTranslationPublishMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticleTranslationPublishMutation,
    ArticleTranslationPublishMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArticleTranslationPublishMutation,
    ArticleTranslationPublishMutationVariables
  >(ArticleTranslationPublishDocument, options);
}
export type ArticleTranslationPublishMutationHookResult = ReturnType<
  typeof useArticleTranslationPublishMutation
>;
export type ArticleTranslationPublishMutationResult =
  Apollo.MutationResult<ArticleTranslationPublishMutation>;
export type ArticleTranslationPublishMutationOptions =
  Apollo.BaseMutationOptions<
    ArticleTranslationPublishMutation,
    ArticleTranslationPublishMutationVariables
  >;
export const ArticleTranslationRevertDraftDocument = gql`
  mutation ArticleTranslationRevertDraft(
    $articleId: ID!
    $languageId: LanguageId!
    $version: PositiveInt
    $publish: Boolean
  ) {
    articleTranslationRevertDraft(
      articleId: $articleId
      languageId: $languageId
      version: $version
      publish: $publish
    ) {
      ...ArticleTranslationFields
    }
  }
  ${ArticleTranslationFieldsFragmentDoc}
`;
export type ArticleTranslationRevertDraftMutationFn = Apollo.MutationFunction<
  ArticleTranslationRevertDraftMutation,
  ArticleTranslationRevertDraftMutationVariables
>;

/**
 * __useArticleTranslationRevertDraftMutation__
 *
 * To run a mutation, you first call `useArticleTranslationRevertDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleTranslationRevertDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleTranslationRevertDraftMutation, { data, loading, error }] = useArticleTranslationRevertDraftMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      languageId: // value for 'languageId'
 *      version: // value for 'version'
 *      publish: // value for 'publish'
 *   },
 * });
 */
export function useArticleTranslationRevertDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticleTranslationRevertDraftMutation,
    ArticleTranslationRevertDraftMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArticleTranslationRevertDraftMutation,
    ArticleTranslationRevertDraftMutationVariables
  >(ArticleTranslationRevertDraftDocument, options);
}
export type ArticleTranslationRevertDraftMutationHookResult = ReturnType<
  typeof useArticleTranslationRevertDraftMutation
>;
export type ArticleTranslationRevertDraftMutationResult =
  Apollo.MutationResult<ArticleTranslationRevertDraftMutation>;
export type ArticleTranslationRevertDraftMutationOptions =
  Apollo.BaseMutationOptions<
    ArticleTranslationRevertDraftMutation,
    ArticleTranslationRevertDraftMutationVariables
  >;
export const ArticleTranslationUnpublishDocument = gql`
  mutation ArticleTranslationUnpublish(
    $articleId: ID!
    $languageId: LanguageId!
  ) {
    articleTranslationUnpublish(articleId: $articleId, languageId: $languageId)
  }
`;
export type ArticleTranslationUnpublishMutationFn = Apollo.MutationFunction<
  ArticleTranslationUnpublishMutation,
  ArticleTranslationUnpublishMutationVariables
>;

/**
 * __useArticleTranslationUnpublishMutation__
 *
 * To run a mutation, you first call `useArticleTranslationUnpublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleTranslationUnpublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleTranslationUnpublishMutation, { data, loading, error }] = useArticleTranslationUnpublishMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      languageId: // value for 'languageId'
 *   },
 * });
 */
export function useArticleTranslationUnpublishMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticleTranslationUnpublishMutation,
    ArticleTranslationUnpublishMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArticleTranslationUnpublishMutation,
    ArticleTranslationUnpublishMutationVariables
  >(ArticleTranslationUnpublishDocument, options);
}
export type ArticleTranslationUnpublishMutationHookResult = ReturnType<
  typeof useArticleTranslationUnpublishMutation
>;
export type ArticleTranslationUnpublishMutationResult =
  Apollo.MutationResult<ArticleTranslationUnpublishMutation>;
export type ArticleTranslationUnpublishMutationOptions =
  Apollo.BaseMutationOptions<
    ArticleTranslationUnpublishMutation,
    ArticleTranslationUnpublishMutationVariables
  >;
export const ArticleTranslationVersionDocument = gql`
  query ArticleTranslationVersion(
    $articleId: ID!
    $languageId: LanguageId!
    $versionNumber: PositiveInt!
  ) {
    article(id: $articleId) {
      translation(languageId: $languageId) {
        version(versionNumber: $versionNumber) {
          articleId
          languageId
          version {
            __typename
          }
          title
          content
        }
      }
    }
  }
`;

/**
 * __useArticleTranslationVersionQuery__
 *
 * To run a query within a React component, call `useArticleTranslationVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleTranslationVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleTranslationVersionQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      languageId: // value for 'languageId'
 *      versionNumber: // value for 'versionNumber'
 *   },
 * });
 */
export function useArticleTranslationVersionQuery(
  baseOptions: Apollo.QueryHookOptions<
    ArticleTranslationVersionQuery,
    ArticleTranslationVersionQueryVariables
  > &
    (
      | { variables: ArticleTranslationVersionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ArticleTranslationVersionQuery,
    ArticleTranslationVersionQueryVariables
  >(ArticleTranslationVersionDocument, options);
}
export function useArticleTranslationVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticleTranslationVersionQuery,
    ArticleTranslationVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ArticleTranslationVersionQuery,
    ArticleTranslationVersionQueryVariables
  >(ArticleTranslationVersionDocument, options);
}
// @ts-ignore
export function useArticleTranslationVersionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticleTranslationVersionQuery,
    ArticleTranslationVersionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ArticleTranslationVersionQuery,
  ArticleTranslationVersionQueryVariables
>;
export function useArticleTranslationVersionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleTranslationVersionQuery,
        ArticleTranslationVersionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ArticleTranslationVersionQuery | undefined,
  ArticleTranslationVersionQueryVariables
>;
export function useArticleTranslationVersionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleTranslationVersionQuery,
        ArticleTranslationVersionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ArticleTranslationVersionQuery,
    ArticleTranslationVersionQueryVariables
  >(ArticleTranslationVersionDocument, options);
}
export type ArticleTranslationVersionQueryHookResult = ReturnType<
  typeof useArticleTranslationVersionQuery
>;
export type ArticleTranslationVersionLazyQueryHookResult = ReturnType<
  typeof useArticleTranslationVersionLazyQuery
>;
export type ArticleTranslationVersionSuspenseQueryHookResult = ReturnType<
  typeof useArticleTranslationVersionSuspenseQuery
>;
export type ArticleTranslationVersionQueryResult = Apollo.QueryResult<
  ArticleTranslationVersionQuery,
  ArticleTranslationVersionQueryVariables
>;
export const ArticleTranslationVersionsDocument = gql`
  query ArticleTranslationVersions($articleId: ID!, $languageId: LanguageId!) {
    article(id: $articleId) {
      translations {
        versions(languageId: $languageId) {
          publishedAt
          publishedBy {
            name
          }
          title
          version {
            __typename
            ... on Indexed {
              versionNumber
            }
          }
          isCurrentlyIndexed
          aiAssisted
          referencedConversationIds
        }
      }
    }
  }
`;

/**
 * __useArticleTranslationVersionsQuery__
 *
 * To run a query within a React component, call `useArticleTranslationVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleTranslationVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleTranslationVersionsQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      languageId: // value for 'languageId'
 *   },
 * });
 */
export function useArticleTranslationVersionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ArticleTranslationVersionsQuery,
    ArticleTranslationVersionsQueryVariables
  > &
    (
      | { variables: ArticleTranslationVersionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ArticleTranslationVersionsQuery,
    ArticleTranslationVersionsQueryVariables
  >(ArticleTranslationVersionsDocument, options);
}
export function useArticleTranslationVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticleTranslationVersionsQuery,
    ArticleTranslationVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ArticleTranslationVersionsQuery,
    ArticleTranslationVersionsQueryVariables
  >(ArticleTranslationVersionsDocument, options);
}
// @ts-ignore
export function useArticleTranslationVersionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticleTranslationVersionsQuery,
    ArticleTranslationVersionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ArticleTranslationVersionsQuery,
  ArticleTranslationVersionsQueryVariables
>;
export function useArticleTranslationVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleTranslationVersionsQuery,
        ArticleTranslationVersionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ArticleTranslationVersionsQuery | undefined,
  ArticleTranslationVersionsQueryVariables
>;
export function useArticleTranslationVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleTranslationVersionsQuery,
        ArticleTranslationVersionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ArticleTranslationVersionsQuery,
    ArticleTranslationVersionsQueryVariables
  >(ArticleTranslationVersionsDocument, options);
}
export type ArticleTranslationVersionsQueryHookResult = ReturnType<
  typeof useArticleTranslationVersionsQuery
>;
export type ArticleTranslationVersionsLazyQueryHookResult = ReturnType<
  typeof useArticleTranslationVersionsLazyQuery
>;
export type ArticleTranslationVersionsSuspenseQueryHookResult = ReturnType<
  typeof useArticleTranslationVersionsSuspenseQuery
>;
export type ArticleTranslationVersionsQueryResult = Apollo.QueryResult<
  ArticleTranslationVersionsQuery,
  ArticleTranslationVersionsQueryVariables
>;
export const ArticleUnpublishDocument = gql`
  mutation ArticleUnpublish($articleId: ID!) {
    articleUnpublish(articleId: $articleId) {
      ...ArticleFullFields
    }
  }
  ${ArticleFullFieldsFragmentDoc}
`;
export type ArticleUnpublishMutationFn = Apollo.MutationFunction<
  ArticleUnpublishMutation,
  ArticleUnpublishMutationVariables
>;

/**
 * __useArticleUnpublishMutation__
 *
 * To run a mutation, you first call `useArticleUnpublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleUnpublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleUnpublishMutation, { data, loading, error }] = useArticleUnpublishMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useArticleUnpublishMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticleUnpublishMutation,
    ArticleUnpublishMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArticleUnpublishMutation,
    ArticleUnpublishMutationVariables
  >(ArticleUnpublishDocument, options);
}
export type ArticleUnpublishMutationHookResult = ReturnType<
  typeof useArticleUnpublishMutation
>;
export type ArticleUnpublishMutationResult =
  Apollo.MutationResult<ArticleUnpublishMutation>;
export type ArticleUnpublishMutationOptions = Apollo.BaseMutationOptions<
  ArticleUnpublishMutation,
  ArticleUnpublishMutationVariables
>;
export const ArticleUpdateDocument = gql`
  mutation ArticleUpdate($articleId: ID!, $tags: TagsInput) {
    articleUpdate(id: $articleId, tags: $tags) {
      ...ArticleFullFields
    }
  }
  ${ArticleFullFieldsFragmentDoc}
`;
export type ArticleUpdateMutationFn = Apollo.MutationFunction<
  ArticleUpdateMutation,
  ArticleUpdateMutationVariables
>;

/**
 * __useArticleUpdateMutation__
 *
 * To run a mutation, you first call `useArticleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleUpdateMutation, { data, loading, error }] = useArticleUpdateMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useArticleUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArticleUpdateMutation,
    ArticleUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArticleUpdateMutation,
    ArticleUpdateMutationVariables
  >(ArticleUpdateDocument, options);
}
export type ArticleUpdateMutationHookResult = ReturnType<
  typeof useArticleUpdateMutation
>;
export type ArticleUpdateMutationResult =
  Apollo.MutationResult<ArticleUpdateMutation>;
export type ArticleUpdateMutationOptions = Apollo.BaseMutationOptions<
  ArticleUpdateMutation,
  ArticleUpdateMutationVariables
>;
export const HelpCenterAddCompanyLogoDocument = gql`
  mutation HelpCenterAddCompanyLogo($id: ID!, $logo: String!) {
    helpCenterUpdate(id: $id, logo: $logo) {
      id
      logo {
        filename
        fileType
        availableAt
        size
        uploadedAt
        originalFileName
      }
    }
  }
`;
export type HelpCenterAddCompanyLogoMutationFn = Apollo.MutationFunction<
  HelpCenterAddCompanyLogoMutation,
  HelpCenterAddCompanyLogoMutationVariables
>;

/**
 * __useHelpCenterAddCompanyLogoMutation__
 *
 * To run a mutation, you first call `useHelpCenterAddCompanyLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterAddCompanyLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpCenterAddCompanyLogoMutation, { data, loading, error }] = useHelpCenterAddCompanyLogoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      logo: // value for 'logo'
 *   },
 * });
 */
export function useHelpCenterAddCompanyLogoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HelpCenterAddCompanyLogoMutation,
    HelpCenterAddCompanyLogoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HelpCenterAddCompanyLogoMutation,
    HelpCenterAddCompanyLogoMutationVariables
  >(HelpCenterAddCompanyLogoDocument, options);
}
export type HelpCenterAddCompanyLogoMutationHookResult = ReturnType<
  typeof useHelpCenterAddCompanyLogoMutation
>;
export type HelpCenterAddCompanyLogoMutationResult =
  Apollo.MutationResult<HelpCenterAddCompanyLogoMutation>;
export type HelpCenterAddCompanyLogoMutationOptions =
  Apollo.BaseMutationOptions<
    HelpCenterAddCompanyLogoMutation,
    HelpCenterAddCompanyLogoMutationVariables
  >;
export const HelpCenterAddFaviconDocument = gql`
  mutation HelpCenterAddFavicon($id: ID!, $favicon: String!) {
    helpCenterUpdate(id: $id, favicon: $favicon) {
      id
      favicon {
        filename
        fileType
        availableAt
        size
        uploadedAt
        originalFileName
      }
    }
  }
`;
export type HelpCenterAddFaviconMutationFn = Apollo.MutationFunction<
  HelpCenterAddFaviconMutation,
  HelpCenterAddFaviconMutationVariables
>;

/**
 * __useHelpCenterAddFaviconMutation__
 *
 * To run a mutation, you first call `useHelpCenterAddFaviconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterAddFaviconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpCenterAddFaviconMutation, { data, loading, error }] = useHelpCenterAddFaviconMutation({
 *   variables: {
 *      id: // value for 'id'
 *      favicon: // value for 'favicon'
 *   },
 * });
 */
export function useHelpCenterAddFaviconMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HelpCenterAddFaviconMutation,
    HelpCenterAddFaviconMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HelpCenterAddFaviconMutation,
    HelpCenterAddFaviconMutationVariables
  >(HelpCenterAddFaviconDocument, options);
}
export type HelpCenterAddFaviconMutationHookResult = ReturnType<
  typeof useHelpCenterAddFaviconMutation
>;
export type HelpCenterAddFaviconMutationResult =
  Apollo.MutationResult<HelpCenterAddFaviconMutation>;
export type HelpCenterAddFaviconMutationOptions = Apollo.BaseMutationOptions<
  HelpCenterAddFaviconMutation,
  HelpCenterAddFaviconMutationVariables
>;
export const HelpCenterCreateDocument = gql`
  mutation HelpCenterCreate(
    $subdomain: String!
    $translations: [HelpCenterTranslationInput!]!
    $name: NonEmptyString!
    $collectionId: ID!
    $defaultLanguageId: LanguageId!
    $isHelpCenterIndexable: Boolean!
  ) {
    helpCenterCreate(
      subdomain: $subdomain
      translations: $translations
      name: $name
      collectionId: $collectionId
      defaultLanguage: $defaultLanguageId
      isHelpCenterIndexable: $isHelpCenterIndexable
    ) {
      id
      name
      translation(languageId: $defaultLanguageId) {
        languageId
        title
        tagline
      }
      subdomain
      hostname
      customHostname {
        hostname
      }
      isHelpCenterIndexable
      collection {
        id
        title
      }
      isActive
      favicon {
        filename
        fileType
        availableAt
      }
      logo {
        filename
        fileType
        availableAt
      }
    }
  }
`;
export type HelpCenterCreateMutationFn = Apollo.MutationFunction<
  HelpCenterCreateMutation,
  HelpCenterCreateMutationVariables
>;

/**
 * __useHelpCenterCreateMutation__
 *
 * To run a mutation, you first call `useHelpCenterCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpCenterCreateMutation, { data, loading, error }] = useHelpCenterCreateMutation({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *      translations: // value for 'translations'
 *      name: // value for 'name'
 *      collectionId: // value for 'collectionId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      isHelpCenterIndexable: // value for 'isHelpCenterIndexable'
 *   },
 * });
 */
export function useHelpCenterCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HelpCenterCreateMutation,
    HelpCenterCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HelpCenterCreateMutation,
    HelpCenterCreateMutationVariables
  >(HelpCenterCreateDocument, options);
}
export type HelpCenterCreateMutationHookResult = ReturnType<
  typeof useHelpCenterCreateMutation
>;
export type HelpCenterCreateMutationResult =
  Apollo.MutationResult<HelpCenterCreateMutation>;
export type HelpCenterCreateMutationOptions = Apollo.BaseMutationOptions<
  HelpCenterCreateMutation,
  HelpCenterCreateMutationVariables
>;
export const HelpCenterCustomHostnameFetchDocument = gql`
  query HelpCenterCustomHostnameFetch($id: ID!) {
    helpCenter(id: $id) {
      ...HelpCenterCustomHostname
    }
  }
  ${HelpCenterCustomHostnameFragmentDoc}
`;

/**
 * __useHelpCenterCustomHostnameFetchQuery__
 *
 * To run a query within a React component, call `useHelpCenterCustomHostnameFetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterCustomHostnameFetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpCenterCustomHostnameFetchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHelpCenterCustomHostnameFetchQuery(
  baseOptions: Apollo.QueryHookOptions<
    HelpCenterCustomHostnameFetchQuery,
    HelpCenterCustomHostnameFetchQueryVariables
  > &
    (
      | {
          variables: HelpCenterCustomHostnameFetchQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HelpCenterCustomHostnameFetchQuery,
    HelpCenterCustomHostnameFetchQueryVariables
  >(HelpCenterCustomHostnameFetchDocument, options);
}
export function useHelpCenterCustomHostnameFetchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HelpCenterCustomHostnameFetchQuery,
    HelpCenterCustomHostnameFetchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HelpCenterCustomHostnameFetchQuery,
    HelpCenterCustomHostnameFetchQueryVariables
  >(HelpCenterCustomHostnameFetchDocument, options);
}
// @ts-ignore
export function useHelpCenterCustomHostnameFetchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HelpCenterCustomHostnameFetchQuery,
    HelpCenterCustomHostnameFetchQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  HelpCenterCustomHostnameFetchQuery,
  HelpCenterCustomHostnameFetchQueryVariables
>;
export function useHelpCenterCustomHostnameFetchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HelpCenterCustomHostnameFetchQuery,
        HelpCenterCustomHostnameFetchQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  HelpCenterCustomHostnameFetchQuery | undefined,
  HelpCenterCustomHostnameFetchQueryVariables
>;
export function useHelpCenterCustomHostnameFetchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HelpCenterCustomHostnameFetchQuery,
        HelpCenterCustomHostnameFetchQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    HelpCenterCustomHostnameFetchQuery,
    HelpCenterCustomHostnameFetchQueryVariables
  >(HelpCenterCustomHostnameFetchDocument, options);
}
export type HelpCenterCustomHostnameFetchQueryHookResult = ReturnType<
  typeof useHelpCenterCustomHostnameFetchQuery
>;
export type HelpCenterCustomHostnameFetchLazyQueryHookResult = ReturnType<
  typeof useHelpCenterCustomHostnameFetchLazyQuery
>;
export type HelpCenterCustomHostnameFetchSuspenseQueryHookResult = ReturnType<
  typeof useHelpCenterCustomHostnameFetchSuspenseQuery
>;
export type HelpCenterCustomHostnameFetchQueryResult = Apollo.QueryResult<
  HelpCenterCustomHostnameFetchQuery,
  HelpCenterCustomHostnameFetchQueryVariables
>;
export const HelpCenterCustomizationDeleteFaviconDocument = gql`
  mutation HelpCenterCustomizationDeleteFavicon($helpCenterId: ID!) {
    helpCenterUpdate(id: $helpCenterId, favicon: "") {
      favicon {
        availableAt
        filename
      }
    }
  }
`;
export type HelpCenterCustomizationDeleteFaviconMutationFn =
  Apollo.MutationFunction<
    HelpCenterCustomizationDeleteFaviconMutation,
    HelpCenterCustomizationDeleteFaviconMutationVariables
  >;

/**
 * __useHelpCenterCustomizationDeleteFaviconMutation__
 *
 * To run a mutation, you first call `useHelpCenterCustomizationDeleteFaviconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterCustomizationDeleteFaviconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpCenterCustomizationDeleteFaviconMutation, { data, loading, error }] = useHelpCenterCustomizationDeleteFaviconMutation({
 *   variables: {
 *      helpCenterId: // value for 'helpCenterId'
 *   },
 * });
 */
export function useHelpCenterCustomizationDeleteFaviconMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HelpCenterCustomizationDeleteFaviconMutation,
    HelpCenterCustomizationDeleteFaviconMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HelpCenterCustomizationDeleteFaviconMutation,
    HelpCenterCustomizationDeleteFaviconMutationVariables
  >(HelpCenterCustomizationDeleteFaviconDocument, options);
}
export type HelpCenterCustomizationDeleteFaviconMutationHookResult = ReturnType<
  typeof useHelpCenterCustomizationDeleteFaviconMutation
>;
export type HelpCenterCustomizationDeleteFaviconMutationResult =
  Apollo.MutationResult<HelpCenterCustomizationDeleteFaviconMutation>;
export type HelpCenterCustomizationDeleteFaviconMutationOptions =
  Apollo.BaseMutationOptions<
    HelpCenterCustomizationDeleteFaviconMutation,
    HelpCenterCustomizationDeleteFaviconMutationVariables
  >;
export const HelpCenterCustomizationDeleteLogoDocument = gql`
  mutation HelpCenterCustomizationDeleteLogo($helpCenterId: ID!) {
    helpCenterUpdate(id: $helpCenterId, logo: "") {
      logo {
        availableAt
        filename
      }
    }
  }
`;
export type HelpCenterCustomizationDeleteLogoMutationFn =
  Apollo.MutationFunction<
    HelpCenterCustomizationDeleteLogoMutation,
    HelpCenterCustomizationDeleteLogoMutationVariables
  >;

/**
 * __useHelpCenterCustomizationDeleteLogoMutation__
 *
 * To run a mutation, you first call `useHelpCenterCustomizationDeleteLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterCustomizationDeleteLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpCenterCustomizationDeleteLogoMutation, { data, loading, error }] = useHelpCenterCustomizationDeleteLogoMutation({
 *   variables: {
 *      helpCenterId: // value for 'helpCenterId'
 *   },
 * });
 */
export function useHelpCenterCustomizationDeleteLogoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HelpCenterCustomizationDeleteLogoMutation,
    HelpCenterCustomizationDeleteLogoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HelpCenterCustomizationDeleteLogoMutation,
    HelpCenterCustomizationDeleteLogoMutationVariables
  >(HelpCenterCustomizationDeleteLogoDocument, options);
}
export type HelpCenterCustomizationDeleteLogoMutationHookResult = ReturnType<
  typeof useHelpCenterCustomizationDeleteLogoMutation
>;
export type HelpCenterCustomizationDeleteLogoMutationResult =
  Apollo.MutationResult<HelpCenterCustomizationDeleteLogoMutation>;
export type HelpCenterCustomizationDeleteLogoMutationOptions =
  Apollo.BaseMutationOptions<
    HelpCenterCustomizationDeleteLogoMutation,
    HelpCenterCustomizationDeleteLogoMutationVariables
  >;
export const HelpCenterDeleteDocument = gql`
  mutation HelpCenterDelete($id: ID!, $deregisterCustomHostname: Boolean) {
    helpCenterDelete(
      id: $id
      deregisterCustomHostname: $deregisterCustomHostname
    )
  }
`;
export type HelpCenterDeleteMutationFn = Apollo.MutationFunction<
  HelpCenterDeleteMutation,
  HelpCenterDeleteMutationVariables
>;

/**
 * __useHelpCenterDeleteMutation__
 *
 * To run a mutation, you first call `useHelpCenterDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpCenterDeleteMutation, { data, loading, error }] = useHelpCenterDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deregisterCustomHostname: // value for 'deregisterCustomHostname'
 *   },
 * });
 */
export function useHelpCenterDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HelpCenterDeleteMutation,
    HelpCenterDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HelpCenterDeleteMutation,
    HelpCenterDeleteMutationVariables
  >(HelpCenterDeleteDocument, options);
}
export type HelpCenterDeleteMutationHookResult = ReturnType<
  typeof useHelpCenterDeleteMutation
>;
export type HelpCenterDeleteMutationResult =
  Apollo.MutationResult<HelpCenterDeleteMutation>;
export type HelpCenterDeleteMutationOptions = Apollo.BaseMutationOptions<
  HelpCenterDeleteMutation,
  HelpCenterDeleteMutationVariables
>;
export const HelpCenterDeregisterHostnameDocument = gql`
  mutation HelpCenterDeregisterHostname($id: ID!) {
    helpCenterDeregisterHostname(id: $id) {
      ...HelpCenterCustomHostname
    }
  }
  ${HelpCenterCustomHostnameFragmentDoc}
`;
export type HelpCenterDeregisterHostnameMutationFn = Apollo.MutationFunction<
  HelpCenterDeregisterHostnameMutation,
  HelpCenterDeregisterHostnameMutationVariables
>;

/**
 * __useHelpCenterDeregisterHostnameMutation__
 *
 * To run a mutation, you first call `useHelpCenterDeregisterHostnameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterDeregisterHostnameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpCenterDeregisterHostnameMutation, { data, loading, error }] = useHelpCenterDeregisterHostnameMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHelpCenterDeregisterHostnameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HelpCenterDeregisterHostnameMutation,
    HelpCenterDeregisterHostnameMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HelpCenterDeregisterHostnameMutation,
    HelpCenterDeregisterHostnameMutationVariables
  >(HelpCenterDeregisterHostnameDocument, options);
}
export type HelpCenterDeregisterHostnameMutationHookResult = ReturnType<
  typeof useHelpCenterDeregisterHostnameMutation
>;
export type HelpCenterDeregisterHostnameMutationResult =
  Apollo.MutationResult<HelpCenterDeregisterHostnameMutation>;
export type HelpCenterDeregisterHostnameMutationOptions =
  Apollo.BaseMutationOptions<
    HelpCenterDeregisterHostnameMutation,
    HelpCenterDeregisterHostnameMutationVariables
  >;
export const HelpCenterFetchDocument = gql`
  query HelpCenterFetch($id: ID!) {
    helpCenter(id: $id) {
      ...HelpCenter
    }
  }
  ${HelpCenterFragmentDoc}
`;

/**
 * __useHelpCenterFetchQuery__
 *
 * To run a query within a React component, call `useHelpCenterFetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterFetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpCenterFetchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHelpCenterFetchQuery(
  baseOptions: Apollo.QueryHookOptions<
    HelpCenterFetchQuery,
    HelpCenterFetchQueryVariables
  > &
    (
      | { variables: HelpCenterFetchQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HelpCenterFetchQuery, HelpCenterFetchQueryVariables>(
    HelpCenterFetchDocument,
    options,
  );
}
export function useHelpCenterFetchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HelpCenterFetchQuery,
    HelpCenterFetchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HelpCenterFetchQuery,
    HelpCenterFetchQueryVariables
  >(HelpCenterFetchDocument, options);
}
// @ts-ignore
export function useHelpCenterFetchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HelpCenterFetchQuery,
    HelpCenterFetchQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  HelpCenterFetchQuery,
  HelpCenterFetchQueryVariables
>;
export function useHelpCenterFetchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HelpCenterFetchQuery,
        HelpCenterFetchQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  HelpCenterFetchQuery | undefined,
  HelpCenterFetchQueryVariables
>;
export function useHelpCenterFetchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HelpCenterFetchQuery,
        HelpCenterFetchQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    HelpCenterFetchQuery,
    HelpCenterFetchQueryVariables
  >(HelpCenterFetchDocument, options);
}
export type HelpCenterFetchQueryHookResult = ReturnType<
  typeof useHelpCenterFetchQuery
>;
export type HelpCenterFetchLazyQueryHookResult = ReturnType<
  typeof useHelpCenterFetchLazyQuery
>;
export type HelpCenterFetchSuspenseQueryHookResult = ReturnType<
  typeof useHelpCenterFetchSuspenseQuery
>;
export type HelpCenterFetchQueryResult = Apollo.QueryResult<
  HelpCenterFetchQuery,
  HelpCenterFetchQueryVariables
>;
export const HelpCenterRegisterHostnameDocument = gql`
  mutation HelpCenterRegisterHostname($id: ID!, $customHostname: String!) {
    helpCenterRegisterHostname(id: $id, customHostname: $customHostname) {
      ...HelpCenterCustomHostname
    }
  }
  ${HelpCenterCustomHostnameFragmentDoc}
`;
export type HelpCenterRegisterHostnameMutationFn = Apollo.MutationFunction<
  HelpCenterRegisterHostnameMutation,
  HelpCenterRegisterHostnameMutationVariables
>;

/**
 * __useHelpCenterRegisterHostnameMutation__
 *
 * To run a mutation, you first call `useHelpCenterRegisterHostnameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterRegisterHostnameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpCenterRegisterHostnameMutation, { data, loading, error }] = useHelpCenterRegisterHostnameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customHostname: // value for 'customHostname'
 *   },
 * });
 */
export function useHelpCenterRegisterHostnameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HelpCenterRegisterHostnameMutation,
    HelpCenterRegisterHostnameMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HelpCenterRegisterHostnameMutation,
    HelpCenterRegisterHostnameMutationVariables
  >(HelpCenterRegisterHostnameDocument, options);
}
export type HelpCenterRegisterHostnameMutationHookResult = ReturnType<
  typeof useHelpCenterRegisterHostnameMutation
>;
export type HelpCenterRegisterHostnameMutationResult =
  Apollo.MutationResult<HelpCenterRegisterHostnameMutation>;
export type HelpCenterRegisterHostnameMutationOptions =
  Apollo.BaseMutationOptions<
    HelpCenterRegisterHostnameMutation,
    HelpCenterRegisterHostnameMutationVariables
  >;
export const HelpCenterUpdateAdvancedCustomizationDocument = gql`
  mutation HelpCenterUpdateAdvancedCustomization(
    $helpCenterId: ID!
    $themeCustomization: HelpCenterThemeCustomizationInput!
  ) {
    helpCenterUpdate(
      id: $helpCenterId
      themeCustomization: $themeCustomization
    ) {
      id
      themeCustomization {
        headerHtml {
          value
          enabled
        }
        footerHtml {
          value
          enabled
        }
        css {
          value
          enabled
        }
        js {
          value
          enabled
        }
      }
    }
  }
`;
export type HelpCenterUpdateAdvancedCustomizationMutationFn =
  Apollo.MutationFunction<
    HelpCenterUpdateAdvancedCustomizationMutation,
    HelpCenterUpdateAdvancedCustomizationMutationVariables
  >;

/**
 * __useHelpCenterUpdateAdvancedCustomizationMutation__
 *
 * To run a mutation, you first call `useHelpCenterUpdateAdvancedCustomizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterUpdateAdvancedCustomizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpCenterUpdateAdvancedCustomizationMutation, { data, loading, error }] = useHelpCenterUpdateAdvancedCustomizationMutation({
 *   variables: {
 *      helpCenterId: // value for 'helpCenterId'
 *      themeCustomization: // value for 'themeCustomization'
 *   },
 * });
 */
export function useHelpCenterUpdateAdvancedCustomizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HelpCenterUpdateAdvancedCustomizationMutation,
    HelpCenterUpdateAdvancedCustomizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HelpCenterUpdateAdvancedCustomizationMutation,
    HelpCenterUpdateAdvancedCustomizationMutationVariables
  >(HelpCenterUpdateAdvancedCustomizationDocument, options);
}
export type HelpCenterUpdateAdvancedCustomizationMutationHookResult =
  ReturnType<typeof useHelpCenterUpdateAdvancedCustomizationMutation>;
export type HelpCenterUpdateAdvancedCustomizationMutationResult =
  Apollo.MutationResult<HelpCenterUpdateAdvancedCustomizationMutation>;
export type HelpCenterUpdateAdvancedCustomizationMutationOptions =
  Apollo.BaseMutationOptions<
    HelpCenterUpdateAdvancedCustomizationMutation,
    HelpCenterUpdateAdvancedCustomizationMutationVariables
  >;
export const HelpCenterUpdateCustomizationDocument = gql`
  mutation HelpCenterUpdateCustomization(
    $helpCenterId: ID!
    $themeId: ID!
    $colors: HelpCenterThemeColorsUpdateInput!
    $companyUrl: URL!
  ) {
    helpCenterUpdate(id: $helpCenterId, companyUrl: $companyUrl) {
      ...HelpCenter
    }
    helpCenterThemeUpdate(id: $themeId, colors: $colors) {
      id
      name
      colors {
        websiteBackground
        pageBackground
        text
        link
        accent
        accentText
      }
    }
  }
  ${HelpCenterFragmentDoc}
`;
export type HelpCenterUpdateCustomizationMutationFn = Apollo.MutationFunction<
  HelpCenterUpdateCustomizationMutation,
  HelpCenterUpdateCustomizationMutationVariables
>;

/**
 * __useHelpCenterUpdateCustomizationMutation__
 *
 * To run a mutation, you first call `useHelpCenterUpdateCustomizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterUpdateCustomizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpCenterUpdateCustomizationMutation, { data, loading, error }] = useHelpCenterUpdateCustomizationMutation({
 *   variables: {
 *      helpCenterId: // value for 'helpCenterId'
 *      themeId: // value for 'themeId'
 *      colors: // value for 'colors'
 *      companyUrl: // value for 'companyUrl'
 *   },
 * });
 */
export function useHelpCenterUpdateCustomizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HelpCenterUpdateCustomizationMutation,
    HelpCenterUpdateCustomizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HelpCenterUpdateCustomizationMutation,
    HelpCenterUpdateCustomizationMutationVariables
  >(HelpCenterUpdateCustomizationDocument, options);
}
export type HelpCenterUpdateCustomizationMutationHookResult = ReturnType<
  typeof useHelpCenterUpdateCustomizationMutation
>;
export type HelpCenterUpdateCustomizationMutationResult =
  Apollo.MutationResult<HelpCenterUpdateCustomizationMutation>;
export type HelpCenterUpdateCustomizationMutationOptions =
  Apollo.BaseMutationOptions<
    HelpCenterUpdateCustomizationMutation,
    HelpCenterUpdateCustomizationMutationVariables
  >;
export const HelpCenterUpdateCustomizationTranslationsDocument = gql`
  mutation HelpCenterUpdateCustomizationTranslations(
    $helpCenterId: ID!
    $translation: HelpCenterTranslationInput!
  ) {
    helpCenterUpdate(id: $helpCenterId, translation: $translation) {
      ...HelpCenter
    }
  }
  ${HelpCenterFragmentDoc}
`;
export type HelpCenterUpdateCustomizationTranslationsMutationFn =
  Apollo.MutationFunction<
    HelpCenterUpdateCustomizationTranslationsMutation,
    HelpCenterUpdateCustomizationTranslationsMutationVariables
  >;

/**
 * __useHelpCenterUpdateCustomizationTranslationsMutation__
 *
 * To run a mutation, you first call `useHelpCenterUpdateCustomizationTranslationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterUpdateCustomizationTranslationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpCenterUpdateCustomizationTranslationsMutation, { data, loading, error }] = useHelpCenterUpdateCustomizationTranslationsMutation({
 *   variables: {
 *      helpCenterId: // value for 'helpCenterId'
 *      translation: // value for 'translation'
 *   },
 * });
 */
export function useHelpCenterUpdateCustomizationTranslationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HelpCenterUpdateCustomizationTranslationsMutation,
    HelpCenterUpdateCustomizationTranslationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HelpCenterUpdateCustomizationTranslationsMutation,
    HelpCenterUpdateCustomizationTranslationsMutationVariables
  >(HelpCenterUpdateCustomizationTranslationsDocument, options);
}
export type HelpCenterUpdateCustomizationTranslationsMutationHookResult =
  ReturnType<typeof useHelpCenterUpdateCustomizationTranslationsMutation>;
export type HelpCenterUpdateCustomizationTranslationsMutationResult =
  Apollo.MutationResult<HelpCenterUpdateCustomizationTranslationsMutation>;
export type HelpCenterUpdateCustomizationTranslationsMutationOptions =
  Apollo.BaseMutationOptions<
    HelpCenterUpdateCustomizationTranslationsMutation,
    HelpCenterUpdateCustomizationTranslationsMutationVariables
  >;
export const HelpCenterUpdateSettingsDocument = gql`
  mutation HelpCenterUpdateSettings(
    $id: ID!
    $subdomain: String
    $collectionId: ID
    $active: Boolean!
    $name: NonEmptyString!
    $isHelpCenterIndexable: Boolean!
    $enableLanguages: [LanguageId!]
    $disableLanguages: [LanguageId!]
    $defaultLanguage: LanguageId
  ) {
    helpCenterUpdate(
      id: $id
      subdomain: $subdomain
      collectionId: $collectionId
      active: $active
      name: $name
      isHelpCenterIndexable: $isHelpCenterIndexable
      enableLanguages: $enableLanguages
      disableLanguages: $disableLanguages
      defaultLanguage: $defaultLanguage
    ) {
      ...HelpCenter
    }
  }
  ${HelpCenterFragmentDoc}
`;
export type HelpCenterUpdateSettingsMutationFn = Apollo.MutationFunction<
  HelpCenterUpdateSettingsMutation,
  HelpCenterUpdateSettingsMutationVariables
>;

/**
 * __useHelpCenterUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useHelpCenterUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpCenterUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpCenterUpdateSettingsMutation, { data, loading, error }] = useHelpCenterUpdateSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      subdomain: // value for 'subdomain'
 *      collectionId: // value for 'collectionId'
 *      active: // value for 'active'
 *      name: // value for 'name'
 *      isHelpCenterIndexable: // value for 'isHelpCenterIndexable'
 *      enableLanguages: // value for 'enableLanguages'
 *      disableLanguages: // value for 'disableLanguages'
 *      defaultLanguage: // value for 'defaultLanguage'
 *   },
 * });
 */
export function useHelpCenterUpdateSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HelpCenterUpdateSettingsMutation,
    HelpCenterUpdateSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HelpCenterUpdateSettingsMutation,
    HelpCenterUpdateSettingsMutationVariables
  >(HelpCenterUpdateSettingsDocument, options);
}
export type HelpCenterUpdateSettingsMutationHookResult = ReturnType<
  typeof useHelpCenterUpdateSettingsMutation
>;
export type HelpCenterUpdateSettingsMutationResult =
  Apollo.MutationResult<HelpCenterUpdateSettingsMutation>;
export type HelpCenterUpdateSettingsMutationOptions =
  Apollo.BaseMutationOptions<
    HelpCenterUpdateSettingsMutation,
    HelpCenterUpdateSettingsMutationVariables
  >;
export const HelpCentersDocument = gql`
  query HelpCenters {
    helpCenters(offset: 0, limit: 50) {
      results {
        id
        name
        hostname
        customHostname {
          hostname
        }
        isActive
        collection {
          id
          title
        }
      }
    }
  }
`;

/**
 * __useHelpCentersQuery__
 *
 * To run a query within a React component, call `useHelpCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpCentersQuery({
 *   variables: {
 *   },
 * });
 */
export function useHelpCentersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HelpCentersQuery,
    HelpCentersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HelpCentersQuery, HelpCentersQueryVariables>(
    HelpCentersDocument,
    options,
  );
}
export function useHelpCentersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HelpCentersQuery,
    HelpCentersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HelpCentersQuery, HelpCentersQueryVariables>(
    HelpCentersDocument,
    options,
  );
}
// @ts-ignore
export function useHelpCentersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HelpCentersQuery,
    HelpCentersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<HelpCentersQuery, HelpCentersQueryVariables>;
export function useHelpCentersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HelpCentersQuery,
        HelpCentersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  HelpCentersQuery | undefined,
  HelpCentersQueryVariables
>;
export function useHelpCentersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HelpCentersQuery,
        HelpCentersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HelpCentersQuery, HelpCentersQueryVariables>(
    HelpCentersDocument,
    options,
  );
}
export type HelpCentersQueryHookResult = ReturnType<typeof useHelpCentersQuery>;
export type HelpCentersLazyQueryHookResult = ReturnType<
  typeof useHelpCentersLazyQuery
>;
export type HelpCentersSuspenseQueryHookResult = ReturnType<
  typeof useHelpCentersSuspenseQuery
>;
export type HelpCentersQueryResult = Apollo.QueryResult<
  HelpCentersQuery,
  HelpCentersQueryVariables
>;
export const SubdomainAvailabilityDocument = gql`
  query SubdomainAvailability($subdomain: String!) {
    subdomainAvailability(subdomain: $subdomain) {
      isAvailable
      reason
    }
  }
`;

/**
 * __useSubdomainAvailabilityQuery__
 *
 * To run a query within a React component, call `useSubdomainAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubdomainAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubdomainAvailabilityQuery({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *   },
 * });
 */
export function useSubdomainAvailabilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    SubdomainAvailabilityQuery,
    SubdomainAvailabilityQueryVariables
  > &
    (
      | { variables: SubdomainAvailabilityQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SubdomainAvailabilityQuery,
    SubdomainAvailabilityQueryVariables
  >(SubdomainAvailabilityDocument, options);
}
export function useSubdomainAvailabilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubdomainAvailabilityQuery,
    SubdomainAvailabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SubdomainAvailabilityQuery,
    SubdomainAvailabilityQueryVariables
  >(SubdomainAvailabilityDocument, options);
}
// @ts-ignore
export function useSubdomainAvailabilitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SubdomainAvailabilityQuery,
    SubdomainAvailabilityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SubdomainAvailabilityQuery,
  SubdomainAvailabilityQueryVariables
>;
export function useSubdomainAvailabilitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubdomainAvailabilityQuery,
        SubdomainAvailabilityQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SubdomainAvailabilityQuery | undefined,
  SubdomainAvailabilityQueryVariables
>;
export function useSubdomainAvailabilitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubdomainAvailabilityQuery,
        SubdomainAvailabilityQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SubdomainAvailabilityQuery,
    SubdomainAvailabilityQueryVariables
  >(SubdomainAvailabilityDocument, options);
}
export type SubdomainAvailabilityQueryHookResult = ReturnType<
  typeof useSubdomainAvailabilityQuery
>;
export type SubdomainAvailabilityLazyQueryHookResult = ReturnType<
  typeof useSubdomainAvailabilityLazyQuery
>;
export type SubdomainAvailabilitySuspenseQueryHookResult = ReturnType<
  typeof useSubdomainAvailabilitySuspenseQuery
>;
export type SubdomainAvailabilityQueryResult = Apollo.QueryResult<
  SubdomainAvailabilityQuery,
  SubdomainAvailabilityQueryVariables
>;
export type AiDraftKeySpecifier = (
  | 'approvedAt'
  | 'category'
  | 'categoryId'
  | 'collection'
  | 'collectionId'
  | 'createdAt'
  | 'createdFromLastMessageAt'
  | 'forArticleId'
  | 'htmlContent'
  | 'id'
  | 'initiatedBy'
  | 'initiatedFromConversation'
  | 'languageId'
  | 'modifiedAt'
  | 'possibleCollectionIds'
  | 'possibleCollections'
  | 'referencedConversationIds'
  | 'rejectedAt'
  | 'replacesExistingDraft'
  | 'summary'
  | 'title'
  | 'type'
  | AiDraftKeySpecifier
)[];
export type AiDraftFieldPolicy = {
  approvedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  category?: FieldPolicy<any> | FieldReadFunction<any>;
  categoryId?: FieldPolicy<any> | FieldReadFunction<any>;
  collection?: FieldPolicy<any> | FieldReadFunction<any>;
  collectionId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  createdFromLastMessageAt?: FieldPolicy<any> | FieldReadFunction<any>;
  forArticleId?: FieldPolicy<any> | FieldReadFunction<any>;
  htmlContent?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  initiatedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  initiatedFromConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  languageId?: FieldPolicy<any> | FieldReadFunction<any>;
  modifiedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  possibleCollectionIds?: FieldPolicy<any> | FieldReadFunction<any>;
  possibleCollections?: FieldPolicy<any> | FieldReadFunction<any>;
  referencedConversationIds?: FieldPolicy<any> | FieldReadFunction<any>;
  rejectedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  replacesExistingDraft?: FieldPolicy<any> | FieldReadFunction<any>;
  summary?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AiDraftCategoryKeySpecifier = (
  | 'id'
  | 'name'
  | AiDraftCategoryKeySpecifier
)[];
export type AiDraftCategoryFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AiDraftCollectionKeySpecifier = (
  | 'id'
  | 'name'
  | AiDraftCollectionKeySpecifier
)[];
export type AiDraftCollectionFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AiDraftQueryPayloadKeySpecifier = (
  | 'pagination'
  | 'results'
  | AiDraftQueryPayloadKeySpecifier
)[];
export type AiDraftQueryPayloadFieldPolicy = {
  pagination?: FieldPolicy<any> | FieldReadFunction<any>;
  results?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AiSettingsPayloadKeySpecifier = (
  | 'judgeInstructions'
  | 'minSimilarConversations'
  | 'similarity'
  | 'writerInstructions'
  | AiSettingsPayloadKeySpecifier
)[];
export type AiSettingsPayloadFieldPolicy = {
  judgeInstructions?: FieldPolicy<any> | FieldReadFunction<any>;
  minSimilarConversations?: FieldPolicy<any> | FieldReadFunction<any>;
  similarity?: FieldPolicy<any> | FieldReadFunction<any>;
  writerInstructions?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AiSettingsVersionPayloadKeySpecifier = (
  | 'createdAt'
  | 'id'
  | 'isActive'
  | 'isDraft'
  | 'name'
  | 'settings'
  | 'version'
  | AiSettingsVersionPayloadKeySpecifier
)[];
export type AiSettingsVersionPayloadFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isDraft?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  settings?: FieldPolicy<any> | FieldReadFunction<any>;
  version?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AiSettingsVersionSummaryPayloadKeySpecifier = (
  | 'createdAt'
  | 'id'
  | 'isActive'
  | 'name'
  | 'version'
  | AiSettingsVersionSummaryPayloadKeySpecifier
)[];
export type AiSettingsVersionSummaryPayloadFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  version?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ArticleKeySpecifier = (
  | 'aiAssisted'
  | 'availableInPreRelease'
  | 'createdAt'
  | 'createdBy'
  | 'defaultLocation'
  | 'fields'
  | 'id'
  | 'indexedAt'
  | 'indexedBy'
  | 'interlinkedBy'
  | 'invalidInterlinks'
  | 'isDefaultLocation'
  | 'isLocked'
  | 'isPreRelease'
  | 'locationHash'
  | 'ownedBy'
  | 'parent'
  | 'parentCollections'
  | 'parents'
  | 'referencedConversationIds'
  | 'restrictions'
  | 'shortId'
  | 'tags'
  | 'title'
  | 'titleDefault'
  | 'titles'
  | 'translation'
  | 'translations'
  | 'updatedAt'
  | 'updatedBy'
  | ArticleKeySpecifier
)[];
export type ArticleFieldPolicy = {
  aiAssisted?: FieldPolicy<any> | FieldReadFunction<any>;
  availableInPreRelease?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  createdBy?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultLocation?: FieldPolicy<any> | FieldReadFunction<any>;
  fields?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  indexedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  indexedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  interlinkedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  invalidInterlinks?: FieldPolicy<any> | FieldReadFunction<any>;
  isDefaultLocation?: FieldPolicy<any> | FieldReadFunction<any>;
  isLocked?: FieldPolicy<any> | FieldReadFunction<any>;
  isPreRelease?: FieldPolicy<any> | FieldReadFunction<any>;
  locationHash?: FieldPolicy<any> | FieldReadFunction<any>;
  ownedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  parent?: FieldPolicy<any> | FieldReadFunction<any>;
  parentCollections?: FieldPolicy<any> | FieldReadFunction<any>;
  parents?: FieldPolicy<any> | FieldReadFunction<any>;
  referencedConversationIds?: FieldPolicy<any> | FieldReadFunction<any>;
  restrictions?: FieldPolicy<any> | FieldReadFunction<any>;
  shortId?: FieldPolicy<any> | FieldReadFunction<any>;
  tags?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  titleDefault?: FieldPolicy<any> | FieldReadFunction<any>;
  titles?: FieldPolicy<any> | FieldReadFunction<any>;
  translation?: FieldPolicy<any> | FieldReadFunction<any>;
  translations?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedBy?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ArticleListKeySpecifier = (
  | 'orphans'
  | 'owners'
  | 'query'
  | 'results'
  | ArticleListKeySpecifier
)[];
export type ArticleListFieldPolicy = {
  orphans?: FieldPolicy<any> | FieldReadFunction<any>;
  owners?: FieldPolicy<any> | FieldReadFunction<any>;
  query?: FieldPolicy<any> | FieldReadFunction<any>;
  results?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ArticleListItemKeySpecifier = (
  | 'archived'
  | 'availableInPrerelease'
  | 'createdAt'
  | 'createdBy'
  | 'fields'
  | 'id'
  | 'indexedAt'
  | 'indexedBy'
  | 'isLocked'
  | 'isPreRelease'
  | 'ownedBy'
  | 'parentCategories'
  | 'parentCollections'
  | 'publicationStatus'
  | 'restrictions'
  | 'title'
  | 'titleDefault'
  | 'titles'
  | 'updatedAt'
  | 'updatedBy'
  | ArticleListItemKeySpecifier
)[];
export type ArticleListItemFieldPolicy = {
  archived?: FieldPolicy<any> | FieldReadFunction<any>;
  availableInPrerelease?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  createdBy?: FieldPolicy<any> | FieldReadFunction<any>;
  fields?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  indexedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  indexedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  isLocked?: FieldPolicy<any> | FieldReadFunction<any>;
  isPreRelease?: FieldPolicy<any> | FieldReadFunction<any>;
  ownedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  parentCategories?: FieldPolicy<any> | FieldReadFunction<any>;
  parentCollections?: FieldPolicy<any> | FieldReadFunction<any>;
  publicationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  restrictions?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  titleDefault?: FieldPolicy<any> | FieldReadFunction<any>;
  titles?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedBy?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ArticleQueryPayloadKeySpecifier = (
  | 'pagination'
  | 'results'
  | ArticleQueryPayloadKeySpecifier
)[];
export type ArticleQueryPayloadFieldPolicy = {
  pagination?: FieldPolicy<any> | FieldReadFunction<any>;
  results?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ArticleTranslationKeySpecifier = (
  | 'aiAssisted'
  | 'articleId'
  | 'availableAt'
  | 'content'
  | 'contents'
  | 'createdAt'
  | 'createdBy'
  | 'featuredImage'
  | 'indexedAt'
  | 'indexedBy'
  | 'interlinkedBy'
  | 'invalidInterlinks'
  | 'isIndexedVersion'
  | 'languageId'
  | 'metadata'
  | 'publicationStatus'
  | 'referencedConversationIds'
  | 'title'
  | 'titleTranslatedAt'
  | 'titleUpdatedAt'
  | 'updatedAt'
  | 'updatedBy'
  | 'version'
  | ArticleTranslationKeySpecifier
)[];
export type ArticleTranslationFieldPolicy = {
  aiAssisted?: FieldPolicy<any> | FieldReadFunction<any>;
  articleId?: FieldPolicy<any> | FieldReadFunction<any>;
  availableAt?: FieldPolicy<any> | FieldReadFunction<any>;
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  contents?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  createdBy?: FieldPolicy<any> | FieldReadFunction<any>;
  featuredImage?: FieldPolicy<any> | FieldReadFunction<any>;
  indexedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  indexedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  interlinkedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  invalidInterlinks?: FieldPolicy<any> | FieldReadFunction<any>;
  isIndexedVersion?: FieldPolicy<any> | FieldReadFunction<any>;
  languageId?: FieldPolicy<any> | FieldReadFunction<any>;
  metadata?: FieldPolicy<any> | FieldReadFunction<any>;
  publicationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  referencedConversationIds?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  titleTranslatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  titleUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  version?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ArticleTranslationListKeySpecifier = (
  | 'results'
  | ArticleTranslationListKeySpecifier
)[];
export type ArticleTranslationListFieldPolicy = {
  results?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AvailableAtPayloadKeySpecifier = (
  | 'helpCenters'
  | AvailableAtPayloadKeySpecifier
)[];
export type AvailableAtPayloadFieldPolicy = {
  helpCenters?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BAD_USER_INPUTKeySpecifier = ('_' | BAD_USER_INPUTKeySpecifier)[];
export type BAD_USER_INPUTFieldPolicy = {
  _?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CONTENT_SIZE_LIMIT_EXCEEDEDKeySpecifier = (
  | '_'
  | CONTENT_SIZE_LIMIT_EXCEEDEDKeySpecifier
)[];
export type CONTENT_SIZE_LIMIT_EXCEEDEDFieldPolicy = {
  _?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CategoryKeySpecifier = (
  | 'articles'
  | 'categories'
  | 'defaultLocation'
  | 'fields'
  | 'id'
  | 'isDefaultLocation'
  | 'isLocked'
  | 'locationHash'
  | 'parent'
  | 'parentCollections'
  | 'parents'
  | 'restrictions'
  | 'shortId'
  | 'title'
  | 'titleDefault'
  | 'titles'
  | CategoryKeySpecifier
)[];
export type CategoryFieldPolicy = {
  articles?: FieldPolicy<any> | FieldReadFunction<any>;
  categories?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultLocation?: FieldPolicy<any> | FieldReadFunction<any>;
  fields?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isDefaultLocation?: FieldPolicy<any> | FieldReadFunction<any>;
  isLocked?: FieldPolicy<any> | FieldReadFunction<any>;
  locationHash?: FieldPolicy<any> | FieldReadFunction<any>;
  parent?: FieldPolicy<any> | FieldReadFunction<any>;
  parentCollections?: FieldPolicy<any> | FieldReadFunction<any>;
  parents?: FieldPolicy<any> | FieldReadFunction<any>;
  restrictions?: FieldPolicy<any> | FieldReadFunction<any>;
  shortId?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  titleDefault?: FieldPolicy<any> | FieldReadFunction<any>;
  titles?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CategoryListKeySpecifier = ('results' | CategoryListKeySpecifier)[];
export type CategoryListFieldPolicy = {
  results?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CategoryListItemKeySpecifier = (
  | 'archived'
  | 'fields'
  | 'id'
  | 'isLocked'
  | 'parentCollections'
  | 'restrictions'
  | 'title'
  | 'titleDefault'
  | 'titles'
  | CategoryListItemKeySpecifier
)[];
export type CategoryListItemFieldPolicy = {
  archived?: FieldPolicy<any> | FieldReadFunction<any>;
  fields?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isLocked?: FieldPolicy<any> | FieldReadFunction<any>;
  parentCollections?: FieldPolicy<any> | FieldReadFunction<any>;
  restrictions?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  titleDefault?: FieldPolicy<any> | FieldReadFunction<any>;
  titles?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChildKeySpecifier = (
  | 'fields'
  | 'id'
  | 'isDefaultLocation'
  | 'isLocked'
  | 'locationHash'
  | 'parent'
  | 'parentCollections'
  | 'parents'
  | 'restrictions'
  | 'shortId'
  | 'title'
  | 'titleDefault'
  | 'titles'
  | ChildKeySpecifier
)[];
export type ChildFieldPolicy = {
  fields?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isDefaultLocation?: FieldPolicy<any> | FieldReadFunction<any>;
  isLocked?: FieldPolicy<any> | FieldReadFunction<any>;
  locationHash?: FieldPolicy<any> | FieldReadFunction<any>;
  parent?: FieldPolicy<any> | FieldReadFunction<any>;
  parentCollections?: FieldPolicy<any> | FieldReadFunction<any>;
  parents?: FieldPolicy<any> | FieldReadFunction<any>;
  restrictions?: FieldPolicy<any> | FieldReadFunction<any>;
  shortId?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  titleDefault?: FieldPolicy<any> | FieldReadFunction<any>;
  titles?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CnameRecordKeySpecifier = (
  | 'aliasOf'
  | 'hostname'
  | CnameRecordKeySpecifier
)[];
export type CnameRecordFieldPolicy = {
  aliasOf?: FieldPolicy<any> | FieldReadFunction<any>;
  hostname?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CnameStatusKeySpecifier = (
  | 'record'
  | 'status'
  | 'verificationErrors'
  | CnameStatusKeySpecifier
)[];
export type CnameStatusFieldPolicy = {
  record?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  verificationErrors?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CollectionKeySpecifier = (
  | 'articleList'
  | 'articles'
  | 'categories'
  | 'description'
  | 'fields'
  | 'helpCenters'
  | 'id'
  | 'internalKbEnabled'
  | 'isLocked'
  | 'linkedResources'
  | 'restrictions'
  | 'statistics'
  | 'themeColors'
  | 'title'
  | CollectionKeySpecifier
)[];
export type CollectionFieldPolicy = {
  articleList?: FieldPolicy<any> | FieldReadFunction<any>;
  articles?: FieldPolicy<any> | FieldReadFunction<any>;
  categories?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  fields?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenters?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  internalKbEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  isLocked?: FieldPolicy<any> | FieldReadFunction<any>;
  linkedResources?: FieldPolicy<any> | FieldReadFunction<any>;
  restrictions?: FieldPolicy<any> | FieldReadFunction<any>;
  statistics?: FieldPolicy<any> | FieldReadFunction<any>;
  themeColors?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CollectionArticleListKeySpecifier = (
  | 'pagination'
  | 'results'
  | CollectionArticleListKeySpecifier
)[];
export type CollectionArticleListFieldPolicy = {
  pagination?: FieldPolicy<any> | FieldReadFunction<any>;
  results?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CollectionListKeySpecifier = (
  | 'results'
  | CollectionListKeySpecifier
)[];
export type CollectionListFieldPolicy = {
  results?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CollectionListItemKeySpecifier = (
  | 'description'
  | 'fields'
  | 'id'
  | 'internalKbEnabled'
  | 'isLocked'
  | 'linkedResources'
  | 'restrictions'
  | 'themeColors'
  | 'title'
  | CollectionListItemKeySpecifier
)[];
export type CollectionListItemFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  fields?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  internalKbEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  isLocked?: FieldPolicy<any> | FieldReadFunction<any>;
  linkedResources?: FieldPolicy<any> | FieldReadFunction<any>;
  restrictions?: FieldPolicy<any> | FieldReadFunction<any>;
  themeColors?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CollectionStatsKeySpecifier = (
  | 'articleCount'
  | 'categoryCount'
  | 'queueCount'
  | CollectionStatsKeySpecifier
)[];
export type CollectionStatsFieldPolicy = {
  articleCount?: FieldPolicy<any> | FieldReadFunction<any>;
  categoryCount?: FieldPolicy<any> | FieldReadFunction<any>;
  queueCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CollectionThemeColorsKeySpecifier = (
  | 'icon'
  | CollectionThemeColorsKeySpecifier
)[];
export type CollectionThemeColorsFieldPolicy = {
  icon?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ContentsKeySpecifier = (
  | 'html'
  | 'json'
  | 'plaintext'
  | ContentsKeySpecifier
)[];
export type ContentsFieldPolicy = {
  html?: FieldPolicy<any> | FieldReadFunction<any>;
  json?: FieldPolicy<any> | FieldReadFunction<any>;
  plaintext?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomHostnameKeySpecifier = (
  | 'hostname'
  | 'records'
  | CustomHostnameKeySpecifier
)[];
export type CustomHostnameFieldPolicy = {
  hostname?: FieldPolicy<any> | FieldReadFunction<any>;
  records?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeletionSuccessfulKeySpecifier = (
  | '_'
  | DeletionSuccessfulKeySpecifier
)[];
export type DeletionSuccessfulFieldPolicy = {
  _?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DraftKeySpecifier = ('_' | DraftKeySpecifier)[];
export type DraftFieldPolicy = {
  _?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EntityKeySpecifier = (
  | 'fields'
  | 'id'
  | 'isLocked'
  | 'restrictions'
  | EntityKeySpecifier
)[];
export type EntityFieldPolicy = {
  fields?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isLocked?: FieldPolicy<any> | FieldReadFunction<any>;
  restrictions?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ExternalResourceKeySpecifier = (
  | 'archived'
  | 'id'
  | 'name'
  | ExternalResourceKeySpecifier
)[];
export type ExternalResourceFieldPolicy = {
  archived?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FORBIDDENKeySpecifier = ('_' | FORBIDDENKeySpecifier)[];
export type FORBIDDENFieldPolicy = {
  _?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FileKeySpecifier = (
  | 'availableAt'
  | 'fileType'
  | 'filename'
  | 'originalFileName'
  | 'size'
  | 'uploadedAt'
  | FileKeySpecifier
)[];
export type FileFieldPolicy = {
  availableAt?: FieldPolicy<any> | FieldReadFunction<any>;
  fileType?: FieldPolicy<any> | FieldReadFunction<any>;
  filename?: FieldPolicy<any> | FieldReadFunction<any>;
  originalFileName?: FieldPolicy<any> | FieldReadFunction<any>;
  size?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FileInUseFailureKeySpecifier = (
  | 'translations'
  | FileInUseFailureKeySpecifier
)[];
export type FileInUseFailureFieldPolicy = {
  translations?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FileListKeySpecifier = (
  | 'continuationToken'
  | 'results'
  | FileListKeySpecifier
)[];
export type FileListFieldPolicy = {
  continuationToken?: FieldPolicy<any> | FieldReadFunction<any>;
  results?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FullNameKeySpecifier = (
  | 'familyName'
  | 'givenName'
  | 'middleNames'
  | FullNameKeySpecifier
)[];
export type FullNameFieldPolicy = {
  familyName?: FieldPolicy<any> | FieldReadFunction<any>;
  givenName?: FieldPolicy<any> | FieldReadFunction<any>;
  middleNames?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HelpCenterKeySpecifier = (
  | 'collection'
  | 'companyUrl'
  | 'customHostname'
  | 'defaultLanguage'
  | 'enabledLanguages'
  | 'favicon'
  | 'hostname'
  | 'id'
  | 'isActive'
  | 'isHelpCenterIndexable'
  | 'logo'
  | 'name'
  | 'subdomain'
  | 'theme'
  | 'themeCustomization'
  | 'translation'
  | 'translations'
  | 'url'
  | HelpCenterKeySpecifier
)[];
export type HelpCenterFieldPolicy = {
  collection?: FieldPolicy<any> | FieldReadFunction<any>;
  companyUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customHostname?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledLanguages?: FieldPolicy<any> | FieldReadFunction<any>;
  favicon?: FieldPolicy<any> | FieldReadFunction<any>;
  hostname?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isHelpCenterIndexable?: FieldPolicy<any> | FieldReadFunction<any>;
  logo?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  subdomain?: FieldPolicy<any> | FieldReadFunction<any>;
  theme?: FieldPolicy<any> | FieldReadFunction<any>;
  themeCustomization?: FieldPolicy<any> | FieldReadFunction<any>;
  translation?: FieldPolicy<any> | FieldReadFunction<any>;
  translations?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HelpCenterLinkKeySpecifier = (
  | 'id'
  | 'name'
  | 'url'
  | HelpCenterLinkKeySpecifier
)[];
export type HelpCenterLinkFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HelpCenterListKeySpecifier = (
  | 'results'
  | HelpCenterListKeySpecifier
)[];
export type HelpCenterListFieldPolicy = {
  results?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HelpCenterSettingsKeySpecifier = (
  | 'hostedDomain'
  | HelpCenterSettingsKeySpecifier
)[];
export type HelpCenterSettingsFieldPolicy = {
  hostedDomain?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HelpCenterThemeKeySpecifier = (
  | 'colors'
  | 'id'
  | 'name'
  | 'usedBy'
  | HelpCenterThemeKeySpecifier
)[];
export type HelpCenterThemeFieldPolicy = {
  colors?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  usedBy?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HelpCenterThemeColorsKeySpecifier = (
  | 'accent'
  | 'accentText'
  | 'link'
  | 'pageBackground'
  | 'text'
  | 'websiteBackground'
  | HelpCenterThemeColorsKeySpecifier
)[];
export type HelpCenterThemeColorsFieldPolicy = {
  accent?: FieldPolicy<any> | FieldReadFunction<any>;
  accentText?: FieldPolicy<any> | FieldReadFunction<any>;
  link?: FieldPolicy<any> | FieldReadFunction<any>;
  pageBackground?: FieldPolicy<any> | FieldReadFunction<any>;
  text?: FieldPolicy<any> | FieldReadFunction<any>;
  websiteBackground?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HelpCenterThemeCustomizationKeySpecifier = (
  | 'css'
  | 'footerHtml'
  | 'headerHtml'
  | 'js'
  | HelpCenterThemeCustomizationKeySpecifier
)[];
export type HelpCenterThemeCustomizationFieldPolicy = {
  css?: FieldPolicy<any> | FieldReadFunction<any>;
  footerHtml?: FieldPolicy<any> | FieldReadFunction<any>;
  headerHtml?: FieldPolicy<any> | FieldReadFunction<any>;
  js?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HelpCenterThemeListKeySpecifier = (
  | 'results'
  | HelpCenterThemeListKeySpecifier
)[];
export type HelpCenterThemeListFieldPolicy = {
  results?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HelpCenterTranslationKeySpecifier = (
  | 'languageId'
  | 'tagline'
  | 'title'
  | HelpCenterTranslationKeySpecifier
)[];
export type HelpCenterTranslationFieldPolicy = {
  languageId?: FieldPolicy<any> | FieldReadFunction<any>;
  tagline?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HostnameRecordsKeySpecifier = (
  | 'cname'
  | 'ssl'
  | HostnameRecordsKeySpecifier
)[];
export type HostnameRecordsFieldPolicy = {
  cname?: FieldPolicy<any> | FieldReadFunction<any>;
  ssl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type INTERNAL_SERVER_ERRORKeySpecifier = (
  | '_'
  | INTERNAL_SERVER_ERRORKeySpecifier
)[];
export type INTERNAL_SERVER_ERRORFieldPolicy = {
  _?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type INVALID_DEPENDENCY_STATEKeySpecifier = (
  | '_'
  | INVALID_DEPENDENCY_STATEKeySpecifier
)[];
export type INVALID_DEPENDENCY_STATEFieldPolicy = {
  _?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IndexedKeySpecifier = ('versionNumber' | IndexedKeySpecifier)[];
export type IndexedFieldPolicy = {
  versionNumber?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InheritedRestrictionKeySpecifier = (
  | 'from'
  | 'restriction'
  | InheritedRestrictionKeySpecifier
)[];
export type InheritedRestrictionFieldPolicy = {
  from?: FieldPolicy<any> | FieldReadFunction<any>;
  restriction?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvalidInterlinkKeySpecifier = (
  | 'id'
  | InvalidInterlinkKeySpecifier
)[];
export type InvalidInterlinkFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvalidInterlink_ArticleNotFoundKeySpecifier = (
  | 'id'
  | InvalidInterlink_ArticleNotFoundKeySpecifier
)[];
export type InvalidInterlink_ArticleNotFoundFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvalidInterlink_ArticleNotInCollectionKeySpecifier = (
  | 'id'
  | 'missingFrom'
  | InvalidInterlink_ArticleNotInCollectionKeySpecifier
)[];
export type InvalidInterlink_ArticleNotInCollectionFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  missingFrom?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvalidInterlink_ArticleNotPublishedKeySpecifier = (
  | 'id'
  | InvalidInterlink_ArticleNotPublishedKeySpecifier
)[];
export type InvalidInterlink_ArticleNotPublishedFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvalidInterlink_TranslationNotFoundKeySpecifier = (
  | 'id'
  | 'languageId'
  | InvalidInterlink_TranslationNotFoundKeySpecifier
)[];
export type InvalidInterlink_TranslationNotFoundFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  languageId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvalidInterlink_TranslationNotPublishedKeySpecifier = (
  | 'id'
  | 'languageId'
  | InvalidInterlink_TranslationNotPublishedKeySpecifier
)[];
export type InvalidInterlink_TranslationNotPublishedFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  languageId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type KbFileInUseFailureKeySpecifier = (
  | 'ids'
  | KbFileInUseFailureKeySpecifier
)[];
export type KbFileInUseFailureFieldPolicy = {
  ids?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LanguageKeySpecifier = (
  | 'description'
  | 'languageId'
  | 'nativeDescription'
  | 'usage'
  | LanguageKeySpecifier
)[];
export type LanguageFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  languageId?: FieldPolicy<any> | FieldReadFunction<any>;
  nativeDescription?: FieldPolicy<any> | FieldReadFunction<any>;
  usage?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LanguageUsageKeySpecifier = (
  | 'nArticles'
  | 'nCategories'
  | 'nHelpCenters'
  | LanguageUsageKeySpecifier
)[];
export type LanguageUsageFieldPolicy = {
  nArticles?: FieldPolicy<any> | FieldReadFunction<any>;
  nCategories?: FieldPolicy<any> | FieldReadFunction<any>;
  nHelpCenters?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MEDIA_TYPE_NOT_SUPPORTEDKeySpecifier = (
  | '_'
  | MEDIA_TYPE_NOT_SUPPORTEDKeySpecifier
)[];
export type MEDIA_TYPE_NOT_SUPPORTEDFieldPolicy = {
  _?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MutationsKeySpecifier = (
  | 'aiDraftApprove'
  | 'aiDraftDelete'
  | 'aiDraftGenerate'
  | 'aiDraftReject'
  | 'aiDraftUpdate'
  | 'articleChangeDefaultParent'
  | 'articleClearPublishedHistory'
  | 'articleCreate'
  | 'articleDelete'
  | 'articlePublish'
  | 'articleTranslationCreate'
  | 'articleTranslationDelete'
  | 'articleTranslationPublish'
  | 'articleTranslationRevertDraft'
  | 'articleTranslationUnpublish'
  | 'articleTranslationUpdate'
  | 'articleTranslationUpsert'
  | 'articleUnlock'
  | 'articleUnpublish'
  | 'articleUpdate'
  | 'categoryChangeDefaultParent'
  | 'categoryCreate'
  | 'categoryDelete'
  | 'categoryTranslationDelete'
  | 'categoryTranslationUpsert'
  | 'categoryUpdate'
  | 'collectionCreate'
  | 'collectionDelete'
  | 'collectionPublish'
  | 'collectionUnlock'
  | 'collectionUnpublish'
  | 'collectionUpdate'
  | 'contentMove'
  | 'entityAddRestrictions'
  | 'entityRemoveRestrictions'
  | 'fileDelete'
  | 'fileUploadRequest'
  | 'helpCenterCreate'
  | 'helpCenterDelete'
  | 'helpCenterDeregisterHostname'
  | 'helpCenterRegisterHostname'
  | 'helpCenterThemeCreate'
  | 'helpCenterThemeDelete'
  | 'helpCenterThemeUpdate'
  | 'helpCenterUpdate'
  | 'organisationActivateAiSettingsVersion'
  | 'organisationCreateAiSettingsVersion'
  | 'organisationDisableLanguage'
  | 'organisationEnableLanguages'
  | 'organisationRenameAiSettingsVersion'
  | 'organisationSetDefaultLanguage'
  | 'organisationUpdateAiSettingsDraft'
  | 'parentAddChild'
  | 'parentRemoveChild'
  | 'setupOrganisation'
  | MutationsKeySpecifier
)[];
export type MutationsFieldPolicy = {
  aiDraftApprove?: FieldPolicy<any> | FieldReadFunction<any>;
  aiDraftDelete?: FieldPolicy<any> | FieldReadFunction<any>;
  aiDraftGenerate?: FieldPolicy<any> | FieldReadFunction<any>;
  aiDraftReject?: FieldPolicy<any> | FieldReadFunction<any>;
  aiDraftUpdate?: FieldPolicy<any> | FieldReadFunction<any>;
  articleChangeDefaultParent?: FieldPolicy<any> | FieldReadFunction<any>;
  articleClearPublishedHistory?: FieldPolicy<any> | FieldReadFunction<any>;
  articleCreate?: FieldPolicy<any> | FieldReadFunction<any>;
  articleDelete?: FieldPolicy<any> | FieldReadFunction<any>;
  articlePublish?: FieldPolicy<any> | FieldReadFunction<any>;
  articleTranslationCreate?: FieldPolicy<any> | FieldReadFunction<any>;
  articleTranslationDelete?: FieldPolicy<any> | FieldReadFunction<any>;
  articleTranslationPublish?: FieldPolicy<any> | FieldReadFunction<any>;
  articleTranslationRevertDraft?: FieldPolicy<any> | FieldReadFunction<any>;
  articleTranslationUnpublish?: FieldPolicy<any> | FieldReadFunction<any>;
  articleTranslationUpdate?: FieldPolicy<any> | FieldReadFunction<any>;
  articleTranslationUpsert?: FieldPolicy<any> | FieldReadFunction<any>;
  articleUnlock?: FieldPolicy<any> | FieldReadFunction<any>;
  articleUnpublish?: FieldPolicy<any> | FieldReadFunction<any>;
  articleUpdate?: FieldPolicy<any> | FieldReadFunction<any>;
  categoryChangeDefaultParent?: FieldPolicy<any> | FieldReadFunction<any>;
  categoryCreate?: FieldPolicy<any> | FieldReadFunction<any>;
  categoryDelete?: FieldPolicy<any> | FieldReadFunction<any>;
  categoryTranslationDelete?: FieldPolicy<any> | FieldReadFunction<any>;
  categoryTranslationUpsert?: FieldPolicy<any> | FieldReadFunction<any>;
  categoryUpdate?: FieldPolicy<any> | FieldReadFunction<any>;
  collectionCreate?: FieldPolicy<any> | FieldReadFunction<any>;
  collectionDelete?: FieldPolicy<any> | FieldReadFunction<any>;
  collectionPublish?: FieldPolicy<any> | FieldReadFunction<any>;
  collectionUnlock?: FieldPolicy<any> | FieldReadFunction<any>;
  collectionUnpublish?: FieldPolicy<any> | FieldReadFunction<any>;
  collectionUpdate?: FieldPolicy<any> | FieldReadFunction<any>;
  contentMove?: FieldPolicy<any> | FieldReadFunction<any>;
  entityAddRestrictions?: FieldPolicy<any> | FieldReadFunction<any>;
  entityRemoveRestrictions?: FieldPolicy<any> | FieldReadFunction<any>;
  fileDelete?: FieldPolicy<any> | FieldReadFunction<any>;
  fileUploadRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenterCreate?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenterDelete?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenterDeregisterHostname?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenterRegisterHostname?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenterThemeCreate?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenterThemeDelete?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenterThemeUpdate?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenterUpdate?: FieldPolicy<any> | FieldReadFunction<any>;
  organisationActivateAiSettingsVersion?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  organisationCreateAiSettingsVersion?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  organisationDisableLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  organisationEnableLanguages?: FieldPolicy<any> | FieldReadFunction<any>;
  organisationRenameAiSettingsVersion?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  organisationSetDefaultLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  organisationUpdateAiSettingsDraft?: FieldPolicy<any> | FieldReadFunction<any>;
  parentAddChild?: FieldPolicy<any> | FieldReadFunction<any>;
  parentRemoveChild?: FieldPolicy<any> | FieldReadFunction<any>;
  setupOrganisation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NOT_FOUNDKeySpecifier = ('_' | NOT_FOUNDKeySpecifier)[];
export type NOT_FOUNDFieldPolicy = {
  _?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ORGANISATION_NOT_SETUPKeySpecifier = (
  | '_'
  | ORGANISATION_NOT_SETUPKeySpecifier
)[];
export type ORGANISATION_NOT_SETUPFieldPolicy = {
  _?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrganisationSettingsPayloadKeySpecifier = (
  | 'availableLanguages'
  | 'defaultLanguage'
  | 'enabledLanguages'
  | OrganisationSettingsPayloadKeySpecifier
)[];
export type OrganisationSettingsPayloadFieldPolicy = {
  availableLanguages?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledLanguages?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaginationPayloadKeySpecifier = (
  | 'end'
  | 'hasMore'
  | 'start'
  | 'total'
  | PaginationPayloadKeySpecifier
)[];
export type PaginationPayloadFieldPolicy = {
  end?: FieldPolicy<any> | FieldReadFunction<any>;
  hasMore?: FieldPolicy<any> | FieldReadFunction<any>;
  start?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ParentKeySpecifier = (
  | 'articles'
  | 'categories'
  | 'fields'
  | 'id'
  | 'isLocked'
  | 'restrictions'
  | ParentKeySpecifier
)[];
export type ParentFieldPolicy = {
  articles?: FieldPolicy<any> | FieldReadFunction<any>;
  categories?: FieldPolicy<any> | FieldReadFunction<any>;
  fields?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isLocked?: FieldPolicy<any> | FieldReadFunction<any>;
  restrictions?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PresignedUploadRequestKeySpecifier = (
  | 'availableAt'
  | 'contentType'
  | 'customHeaders'
  | 'expiresAt'
  | 'filename'
  | 'method'
  | 'uploadUrl'
  | PresignedUploadRequestKeySpecifier
)[];
export type PresignedUploadRequestFieldPolicy = {
  availableAt?: FieldPolicy<any> | FieldReadFunction<any>;
  contentType?: FieldPolicy<any> | FieldReadFunction<any>;
  customHeaders?: FieldPolicy<any> | FieldReadFunction<any>;
  expiresAt?: FieldPolicy<any> | FieldReadFunction<any>;
  filename?: FieldPolicy<any> | FieldReadFunction<any>;
  method?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QueriesKeySpecifier = (
  | 'aiDraft'
  | 'aiDraftByCsid'
  | 'aiDrafts'
  | 'aiSettingsVersion'
  | 'aiSettingsVersions'
  | 'article'
  | 'articleTranslation'
  | 'articleTranslationSearch'
  | 'articleTranslations'
  | 'articles'
  | 'categories'
  | 'category'
  | 'collection'
  | 'collections'
  | 'files'
  | 'helpCenter'
  | 'helpCenterTheme'
  | 'helpCenterThemes'
  | 'helpCenters'
  | 'organisationSettings'
  | 'semanticSearch'
  | 'settings'
  | 'subdomainAvailability'
  | QueriesKeySpecifier
)[];
export type QueriesFieldPolicy = {
  aiDraft?: FieldPolicy<any> | FieldReadFunction<any>;
  aiDraftByCsid?: FieldPolicy<any> | FieldReadFunction<any>;
  aiDrafts?: FieldPolicy<any> | FieldReadFunction<any>;
  aiSettingsVersion?: FieldPolicy<any> | FieldReadFunction<any>;
  aiSettingsVersions?: FieldPolicy<any> | FieldReadFunction<any>;
  article?: FieldPolicy<any> | FieldReadFunction<any>;
  articleTranslation?: FieldPolicy<any> | FieldReadFunction<any>;
  articleTranslationSearch?: FieldPolicy<any> | FieldReadFunction<any>;
  articleTranslations?: FieldPolicy<any> | FieldReadFunction<any>;
  articles?: FieldPolicy<any> | FieldReadFunction<any>;
  categories?: FieldPolicy<any> | FieldReadFunction<any>;
  category?: FieldPolicy<any> | FieldReadFunction<any>;
  collection?: FieldPolicy<any> | FieldReadFunction<any>;
  collections?: FieldPolicy<any> | FieldReadFunction<any>;
  files?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenterTheme?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenterThemes?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenters?: FieldPolicy<any> | FieldReadFunction<any>;
  organisationSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  semanticSearch?: FieldPolicy<any> | FieldReadFunction<any>;
  settings?: FieldPolicy<any> | FieldReadFunction<any>;
  subdomainAvailability?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QueueKeySpecifier = (
  | 'archived'
  | 'id'
  | 'name'
  | QueueKeySpecifier
)[];
export type QueueFieldPolicy = {
  archived?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RestrictionsPayloadKeySpecifier = (
  | 'direct'
  | 'inherited'
  | RestrictionsPayloadKeySpecifier
)[];
export type RestrictionsPayloadFieldPolicy = {
  direct?: FieldPolicy<any> | FieldReadFunction<any>;
  inherited?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SemanticSearchResultKeySpecifier = (
  | 'aiDraftId'
  | 'articleId'
  | 'htmlContent'
  | 'languageId'
  | 'matchedChunk'
  | 'similarity'
  | 'title'
  | SemanticSearchResultKeySpecifier
)[];
export type SemanticSearchResultFieldPolicy = {
  aiDraftId?: FieldPolicy<any> | FieldReadFunction<any>;
  articleId?: FieldPolicy<any> | FieldReadFunction<any>;
  htmlContent?: FieldPolicy<any> | FieldReadFunction<any>;
  languageId?: FieldPolicy<any> | FieldReadFunction<any>;
  matchedChunk?: FieldPolicy<any> | FieldReadFunction<any>;
  similarity?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SemanticSearchResultsKeySpecifier = (
  | 'results'
  | SemanticSearchResultsKeySpecifier
)[];
export type SemanticSearchResultsFieldPolicy = {
  results?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SettingsPayloadKeySpecifier = (
  | 'canCreateCollections'
  | 'canSetupOrganisation'
  | 'helpCenter'
  | 'isOrganisationSetup'
  | 'userPermissions'
  | SettingsPayloadKeySpecifier
)[];
export type SettingsPayloadFieldPolicy = {
  canCreateCollections?: FieldPolicy<any> | FieldReadFunction<any>;
  canSetupOrganisation?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  isOrganisationSetup?: FieldPolicy<any> | FieldReadFunction<any>;
  userPermissions?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SslStatusKeySpecifier = (
  | 'record'
  | 'records'
  | 'status'
  | SslStatusKeySpecifier
)[];
export type SslStatusFieldPolicy = {
  record?: FieldPolicy<any> | FieldReadFunction<any>;
  records?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SslTxtRecordKeySpecifier = (
  | 'name'
  | 'value'
  | SslTxtRecordKeySpecifier
)[];
export type SslTxtRecordFieldPolicy = {
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubdomainAvailabilityKeySpecifier = (
  | 'isAvailable'
  | 'reason'
  | SubdomainAvailabilityKeySpecifier
)[];
export type SubdomainAvailabilityFieldPolicy = {
  isAvailable?: FieldPolicy<any> | FieldReadFunction<any>;
  reason?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubscriptionsKeySpecifier = (
  | 'articleTranslationUpdates'
  | SubscriptionsKeySpecifier
)[];
export type SubscriptionsFieldPolicy = {
  articleTranslationUpdates?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TagKeySpecifier = (
  | 'color'
  | 'id'
  | 'isDeactivated'
  | 'name'
  | 'type'
  | TagKeySpecifier
)[];
export type TagFieldPolicy = {
  color?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isDeactivated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ThemeCustomizationFieldKeySpecifier = (
  | 'enabled'
  | 'value'
  | ThemeCustomizationFieldKeySpecifier
)[];
export type ThemeCustomizationFieldFieldPolicy = {
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TranslationHeadKeySpecifier = (
  | 'articleId'
  | 'isCurrentlyIndexed'
  | 'languageId'
  | 'title'
  | 'version'
  | TranslationHeadKeySpecifier
)[];
export type TranslationHeadFieldPolicy = {
  articleId?: FieldPolicy<any> | FieldReadFunction<any>;
  isCurrentlyIndexed?: FieldPolicy<any> | FieldReadFunction<any>;
  languageId?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  version?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TranslationListQueryKeySpecifier = (
  | 'draft'
  | 'forLanguage'
  | 'published'
  | 'versions'
  | TranslationListQueryKeySpecifier
)[];
export type TranslationListQueryFieldPolicy = {
  draft?: FieldPolicy<any> | FieldReadFunction<any>;
  forLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  published?: FieldPolicy<any> | FieldReadFunction<any>;
  versions?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TranslationQueryKeySpecifier = (
  | 'articleId'
  | 'draft'
  | 'hasUnpublishedChanges'
  | 'languageId'
  | 'publicationStatus'
  | 'published'
  | 'version'
  | TranslationQueryKeySpecifier
)[];
export type TranslationQueryFieldPolicy = {
  articleId?: FieldPolicy<any> | FieldReadFunction<any>;
  draft?: FieldPolicy<any> | FieldReadFunction<any>;
  hasUnpublishedChanges?: FieldPolicy<any> | FieldReadFunction<any>;
  languageId?: FieldPolicy<any> | FieldReadFunction<any>;
  publicationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  published?: FieldPolicy<any> | FieldReadFunction<any>;
  version?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TranslationTitleKeySpecifier = (
  | 'languageId'
  | 'title'
  | TranslationTitleKeySpecifier
)[];
export type TranslationTitleFieldPolicy = {
  languageId?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TranslationVersionSummaryPayloadKeySpecifier = (
  | 'aiAssisted'
  | 'isCurrentlyIndexed'
  | 'publishedAt'
  | 'publishedBy'
  | 'referencedConversationIds'
  | 'title'
  | 'version'
  | TranslationVersionSummaryPayloadKeySpecifier
)[];
export type TranslationVersionSummaryPayloadFieldPolicy = {
  aiAssisted?: FieldPolicy<any> | FieldReadFunction<any>;
  isCurrentlyIndexed?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  referencedConversationIds?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  version?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UNAUTHORIZEDKeySpecifier = ('_' | UNAUTHORIZEDKeySpecifier)[];
export type UNAUTHORIZEDFieldPolicy = {
  _?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserKeySpecifier = (
  | 'avatarUrl'
  | 'deactivated'
  | 'email'
  | 'fullName'
  | 'id'
  | 'name'
  | UserKeySpecifier
)[];
export type UserFieldPolicy = {
  avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  deactivated?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserPermissionsSettingsKeySpecifier = (
  | 'collections'
  | 'content'
  | 'helpCenterSettings'
  | 'languageSettings'
  | UserPermissionsSettingsKeySpecifier
)[];
export type UserPermissionsSettingsFieldPolicy = {
  collections?: FieldPolicy<any> | FieldReadFunction<any>;
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  helpCenterSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  languageSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StrictTypedTypePolicies = {
  AiDraft?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AiDraftKeySpecifier
      | (() => undefined | AiDraftKeySpecifier);
    fields?: AiDraftFieldPolicy;
  };
  AiDraftCategory?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AiDraftCategoryKeySpecifier
      | (() => undefined | AiDraftCategoryKeySpecifier);
    fields?: AiDraftCategoryFieldPolicy;
  };
  AiDraftCollection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AiDraftCollectionKeySpecifier
      | (() => undefined | AiDraftCollectionKeySpecifier);
    fields?: AiDraftCollectionFieldPolicy;
  };
  AiDraftQueryPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AiDraftQueryPayloadKeySpecifier
      | (() => undefined | AiDraftQueryPayloadKeySpecifier);
    fields?: AiDraftQueryPayloadFieldPolicy;
  };
  AiSettingsPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AiSettingsPayloadKeySpecifier
      | (() => undefined | AiSettingsPayloadKeySpecifier);
    fields?: AiSettingsPayloadFieldPolicy;
  };
  AiSettingsVersionPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AiSettingsVersionPayloadKeySpecifier
      | (() => undefined | AiSettingsVersionPayloadKeySpecifier);
    fields?: AiSettingsVersionPayloadFieldPolicy;
  };
  AiSettingsVersionSummaryPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AiSettingsVersionSummaryPayloadKeySpecifier
      | (() => undefined | AiSettingsVersionSummaryPayloadKeySpecifier);
    fields?: AiSettingsVersionSummaryPayloadFieldPolicy;
  };
  Article?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArticleKeySpecifier
      | (() => undefined | ArticleKeySpecifier);
    fields?: ArticleFieldPolicy;
  };
  ArticleList?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArticleListKeySpecifier
      | (() => undefined | ArticleListKeySpecifier);
    fields?: ArticleListFieldPolicy;
  };
  ArticleListItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArticleListItemKeySpecifier
      | (() => undefined | ArticleListItemKeySpecifier);
    fields?: ArticleListItemFieldPolicy;
  };
  ArticleQueryPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArticleQueryPayloadKeySpecifier
      | (() => undefined | ArticleQueryPayloadKeySpecifier);
    fields?: ArticleQueryPayloadFieldPolicy;
  };
  ArticleTranslation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArticleTranslationKeySpecifier
      | (() => undefined | ArticleTranslationKeySpecifier);
    fields?: ArticleTranslationFieldPolicy;
  };
  ArticleTranslationList?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArticleTranslationListKeySpecifier
      | (() => undefined | ArticleTranslationListKeySpecifier);
    fields?: ArticleTranslationListFieldPolicy;
  };
  AvailableAtPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AvailableAtPayloadKeySpecifier
      | (() => undefined | AvailableAtPayloadKeySpecifier);
    fields?: AvailableAtPayloadFieldPolicy;
  };
  BAD_USER_INPUT?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BAD_USER_INPUTKeySpecifier
      | (() => undefined | BAD_USER_INPUTKeySpecifier);
    fields?: BAD_USER_INPUTFieldPolicy;
  };
  CONTENT_SIZE_LIMIT_EXCEEDED?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CONTENT_SIZE_LIMIT_EXCEEDEDKeySpecifier
      | (() => undefined | CONTENT_SIZE_LIMIT_EXCEEDEDKeySpecifier);
    fields?: CONTENT_SIZE_LIMIT_EXCEEDEDFieldPolicy;
  };
  Category?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CategoryKeySpecifier
      | (() => undefined | CategoryKeySpecifier);
    fields?: CategoryFieldPolicy;
  };
  CategoryList?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CategoryListKeySpecifier
      | (() => undefined | CategoryListKeySpecifier);
    fields?: CategoryListFieldPolicy;
  };
  CategoryListItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CategoryListItemKeySpecifier
      | (() => undefined | CategoryListItemKeySpecifier);
    fields?: CategoryListItemFieldPolicy;
  };
  Child?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChildKeySpecifier
      | (() => undefined | ChildKeySpecifier);
    fields?: ChildFieldPolicy;
  };
  CnameRecord?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CnameRecordKeySpecifier
      | (() => undefined | CnameRecordKeySpecifier);
    fields?: CnameRecordFieldPolicy;
  };
  CnameStatus?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CnameStatusKeySpecifier
      | (() => undefined | CnameStatusKeySpecifier);
    fields?: CnameStatusFieldPolicy;
  };
  Collection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollectionKeySpecifier
      | (() => undefined | CollectionKeySpecifier);
    fields?: CollectionFieldPolicy;
  };
  CollectionArticleList?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollectionArticleListKeySpecifier
      | (() => undefined | CollectionArticleListKeySpecifier);
    fields?: CollectionArticleListFieldPolicy;
  };
  CollectionList?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollectionListKeySpecifier
      | (() => undefined | CollectionListKeySpecifier);
    fields?: CollectionListFieldPolicy;
  };
  CollectionListItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollectionListItemKeySpecifier
      | (() => undefined | CollectionListItemKeySpecifier);
    fields?: CollectionListItemFieldPolicy;
  };
  CollectionStats?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollectionStatsKeySpecifier
      | (() => undefined | CollectionStatsKeySpecifier);
    fields?: CollectionStatsFieldPolicy;
  };
  CollectionThemeColors?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollectionThemeColorsKeySpecifier
      | (() => undefined | CollectionThemeColorsKeySpecifier);
    fields?: CollectionThemeColorsFieldPolicy;
  };
  Contents?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ContentsKeySpecifier
      | (() => undefined | ContentsKeySpecifier);
    fields?: ContentsFieldPolicy;
  };
  CustomHostname?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomHostnameKeySpecifier
      | (() => undefined | CustomHostnameKeySpecifier);
    fields?: CustomHostnameFieldPolicy;
  };
  DeletionSuccessful?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeletionSuccessfulKeySpecifier
      | (() => undefined | DeletionSuccessfulKeySpecifier);
    fields?: DeletionSuccessfulFieldPolicy;
  };
  Draft?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DraftKeySpecifier
      | (() => undefined | DraftKeySpecifier);
    fields?: DraftFieldPolicy;
  };
  Entity?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EntityKeySpecifier
      | (() => undefined | EntityKeySpecifier);
    fields?: EntityFieldPolicy;
  };
  ExternalResource?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ExternalResourceKeySpecifier
      | (() => undefined | ExternalResourceKeySpecifier);
    fields?: ExternalResourceFieldPolicy;
  };
  FORBIDDEN?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FORBIDDENKeySpecifier
      | (() => undefined | FORBIDDENKeySpecifier);
    fields?: FORBIDDENFieldPolicy;
  };
  File?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | FileKeySpecifier | (() => undefined | FileKeySpecifier);
    fields?: FileFieldPolicy;
  };
  FileInUseFailure?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FileInUseFailureKeySpecifier
      | (() => undefined | FileInUseFailureKeySpecifier);
    fields?: FileInUseFailureFieldPolicy;
  };
  FileList?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FileListKeySpecifier
      | (() => undefined | FileListKeySpecifier);
    fields?: FileListFieldPolicy;
  };
  FullName?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FullNameKeySpecifier
      | (() => undefined | FullNameKeySpecifier);
    fields?: FullNameFieldPolicy;
  };
  HelpCenter?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HelpCenterKeySpecifier
      | (() => undefined | HelpCenterKeySpecifier);
    fields?: HelpCenterFieldPolicy;
  };
  HelpCenterLink?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HelpCenterLinkKeySpecifier
      | (() => undefined | HelpCenterLinkKeySpecifier);
    fields?: HelpCenterLinkFieldPolicy;
  };
  HelpCenterList?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HelpCenterListKeySpecifier
      | (() => undefined | HelpCenterListKeySpecifier);
    fields?: HelpCenterListFieldPolicy;
  };
  HelpCenterSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HelpCenterSettingsKeySpecifier
      | (() => undefined | HelpCenterSettingsKeySpecifier);
    fields?: HelpCenterSettingsFieldPolicy;
  };
  HelpCenterTheme?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HelpCenterThemeKeySpecifier
      | (() => undefined | HelpCenterThemeKeySpecifier);
    fields?: HelpCenterThemeFieldPolicy;
  };
  HelpCenterThemeColors?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HelpCenterThemeColorsKeySpecifier
      | (() => undefined | HelpCenterThemeColorsKeySpecifier);
    fields?: HelpCenterThemeColorsFieldPolicy;
  };
  HelpCenterThemeCustomization?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HelpCenterThemeCustomizationKeySpecifier
      | (() => undefined | HelpCenterThemeCustomizationKeySpecifier);
    fields?: HelpCenterThemeCustomizationFieldPolicy;
  };
  HelpCenterThemeList?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HelpCenterThemeListKeySpecifier
      | (() => undefined | HelpCenterThemeListKeySpecifier);
    fields?: HelpCenterThemeListFieldPolicy;
  };
  HelpCenterTranslation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HelpCenterTranslationKeySpecifier
      | (() => undefined | HelpCenterTranslationKeySpecifier);
    fields?: HelpCenterTranslationFieldPolicy;
  };
  HostnameRecords?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HostnameRecordsKeySpecifier
      | (() => undefined | HostnameRecordsKeySpecifier);
    fields?: HostnameRecordsFieldPolicy;
  };
  INTERNAL_SERVER_ERROR?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | INTERNAL_SERVER_ERRORKeySpecifier
      | (() => undefined | INTERNAL_SERVER_ERRORKeySpecifier);
    fields?: INTERNAL_SERVER_ERRORFieldPolicy;
  };
  INVALID_DEPENDENCY_STATE?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | INVALID_DEPENDENCY_STATEKeySpecifier
      | (() => undefined | INVALID_DEPENDENCY_STATEKeySpecifier);
    fields?: INVALID_DEPENDENCY_STATEFieldPolicy;
  };
  Indexed?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IndexedKeySpecifier
      | (() => undefined | IndexedKeySpecifier);
    fields?: IndexedFieldPolicy;
  };
  InheritedRestriction?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InheritedRestrictionKeySpecifier
      | (() => undefined | InheritedRestrictionKeySpecifier);
    fields?: InheritedRestrictionFieldPolicy;
  };
  InvalidInterlink?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InvalidInterlinkKeySpecifier
      | (() => undefined | InvalidInterlinkKeySpecifier);
    fields?: InvalidInterlinkFieldPolicy;
  };
  InvalidInterlink_ArticleNotFound?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | InvalidInterlink_ArticleNotFoundKeySpecifier
      | (() => undefined | InvalidInterlink_ArticleNotFoundKeySpecifier);
    fields?: InvalidInterlink_ArticleNotFoundFieldPolicy;
  };
  InvalidInterlink_ArticleNotInCollection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | InvalidInterlink_ArticleNotInCollectionKeySpecifier
      | (() => undefined | InvalidInterlink_ArticleNotInCollectionKeySpecifier);
    fields?: InvalidInterlink_ArticleNotInCollectionFieldPolicy;
  };
  InvalidInterlink_ArticleNotPublished?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | InvalidInterlink_ArticleNotPublishedKeySpecifier
      | (() => undefined | InvalidInterlink_ArticleNotPublishedKeySpecifier);
    fields?: InvalidInterlink_ArticleNotPublishedFieldPolicy;
  };
  InvalidInterlink_TranslationNotFound?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | InvalidInterlink_TranslationNotFoundKeySpecifier
      | (() => undefined | InvalidInterlink_TranslationNotFoundKeySpecifier);
    fields?: InvalidInterlink_TranslationNotFoundFieldPolicy;
  };
  InvalidInterlink_TranslationNotPublished?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | InvalidInterlink_TranslationNotPublishedKeySpecifier
      | (() =>
          | undefined
          | InvalidInterlink_TranslationNotPublishedKeySpecifier);
    fields?: InvalidInterlink_TranslationNotPublishedFieldPolicy;
  };
  KbFileInUseFailure?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | KbFileInUseFailureKeySpecifier
      | (() => undefined | KbFileInUseFailureKeySpecifier);
    fields?: KbFileInUseFailureFieldPolicy;
  };
  Language?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LanguageKeySpecifier
      | (() => undefined | LanguageKeySpecifier);
    fields?: LanguageFieldPolicy;
  };
  LanguageUsage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LanguageUsageKeySpecifier
      | (() => undefined | LanguageUsageKeySpecifier);
    fields?: LanguageUsageFieldPolicy;
  };
  MEDIA_TYPE_NOT_SUPPORTED?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MEDIA_TYPE_NOT_SUPPORTEDKeySpecifier
      | (() => undefined | MEDIA_TYPE_NOT_SUPPORTEDKeySpecifier);
    fields?: MEDIA_TYPE_NOT_SUPPORTEDFieldPolicy;
  };
  Mutations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MutationsKeySpecifier
      | (() => undefined | MutationsKeySpecifier);
    fields?: MutationsFieldPolicy;
  };
  NOT_FOUND?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NOT_FOUNDKeySpecifier
      | (() => undefined | NOT_FOUNDKeySpecifier);
    fields?: NOT_FOUNDFieldPolicy;
  };
  ORGANISATION_NOT_SETUP?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ORGANISATION_NOT_SETUPKeySpecifier
      | (() => undefined | ORGANISATION_NOT_SETUPKeySpecifier);
    fields?: ORGANISATION_NOT_SETUPFieldPolicy;
  };
  OrganisationSettingsPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrganisationSettingsPayloadKeySpecifier
      | (() => undefined | OrganisationSettingsPayloadKeySpecifier);
    fields?: OrganisationSettingsPayloadFieldPolicy;
  };
  PaginationPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaginationPayloadKeySpecifier
      | (() => undefined | PaginationPayloadKeySpecifier);
    fields?: PaginationPayloadFieldPolicy;
  };
  Parent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ParentKeySpecifier
      | (() => undefined | ParentKeySpecifier);
    fields?: ParentFieldPolicy;
  };
  PresignedUploadRequest?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PresignedUploadRequestKeySpecifier
      | (() => undefined | PresignedUploadRequestKeySpecifier);
    fields?: PresignedUploadRequestFieldPolicy;
  };
  Queries?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QueriesKeySpecifier
      | (() => undefined | QueriesKeySpecifier);
    fields?: QueriesFieldPolicy;
  };
  Queue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QueueKeySpecifier
      | (() => undefined | QueueKeySpecifier);
    fields?: QueueFieldPolicy;
  };
  RestrictionsPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RestrictionsPayloadKeySpecifier
      | (() => undefined | RestrictionsPayloadKeySpecifier);
    fields?: RestrictionsPayloadFieldPolicy;
  };
  SemanticSearchResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SemanticSearchResultKeySpecifier
      | (() => undefined | SemanticSearchResultKeySpecifier);
    fields?: SemanticSearchResultFieldPolicy;
  };
  SemanticSearchResults?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SemanticSearchResultsKeySpecifier
      | (() => undefined | SemanticSearchResultsKeySpecifier);
    fields?: SemanticSearchResultsFieldPolicy;
  };
  SettingsPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SettingsPayloadKeySpecifier
      | (() => undefined | SettingsPayloadKeySpecifier);
    fields?: SettingsPayloadFieldPolicy;
  };
  SslStatus?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SslStatusKeySpecifier
      | (() => undefined | SslStatusKeySpecifier);
    fields?: SslStatusFieldPolicy;
  };
  SslTxtRecord?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SslTxtRecordKeySpecifier
      | (() => undefined | SslTxtRecordKeySpecifier);
    fields?: SslTxtRecordFieldPolicy;
  };
  SubdomainAvailability?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SubdomainAvailabilityKeySpecifier
      | (() => undefined | SubdomainAvailabilityKeySpecifier);
    fields?: SubdomainAvailabilityFieldPolicy;
  };
  Subscriptions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SubscriptionsKeySpecifier
      | (() => undefined | SubscriptionsKeySpecifier);
    fields?: SubscriptionsFieldPolicy;
  };
  Tag?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TagKeySpecifier | (() => undefined | TagKeySpecifier);
    fields?: TagFieldPolicy;
  };
  ThemeCustomizationField?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ThemeCustomizationFieldKeySpecifier
      | (() => undefined | ThemeCustomizationFieldKeySpecifier);
    fields?: ThemeCustomizationFieldFieldPolicy;
  };
  TranslationHead?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TranslationHeadKeySpecifier
      | (() => undefined | TranslationHeadKeySpecifier);
    fields?: TranslationHeadFieldPolicy;
  };
  TranslationListQuery?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TranslationListQueryKeySpecifier
      | (() => undefined | TranslationListQueryKeySpecifier);
    fields?: TranslationListQueryFieldPolicy;
  };
  TranslationQuery?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TranslationQueryKeySpecifier
      | (() => undefined | TranslationQueryKeySpecifier);
    fields?: TranslationQueryFieldPolicy;
  };
  TranslationTitle?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TranslationTitleKeySpecifier
      | (() => undefined | TranslationTitleKeySpecifier);
    fields?: TranslationTitleFieldPolicy;
  };
  TranslationVersionSummaryPayload?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | TranslationVersionSummaryPayloadKeySpecifier
      | (() => undefined | TranslationVersionSummaryPayloadKeySpecifier);
    fields?: TranslationVersionSummaryPayloadFieldPolicy;
  };
  UNAUTHORIZED?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UNAUTHORIZEDKeySpecifier
      | (() => undefined | UNAUTHORIZEDKeySpecifier);
    fields?: UNAUTHORIZEDFieldPolicy;
  };
  User?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier);
    fields?: UserFieldPolicy;
  };
  UserPermissionsSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserPermissionsSettingsKeySpecifier
      | (() => undefined | UserPermissionsSettingsKeySpecifier);
    fields?: UserPermissionsSettingsFieldPolicy;
  };
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
